var ls = Object.defineProperty;
var is = (e, t, n) => t in e ? ls(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var ue = (e, t, n) => (is(e, typeof t != "symbol" ? t + "" : t, n), n);
import { onMounted as tt, onBeforeUnmount as nt, ref as B, computed as P, defineComponent as H, h as zo, getCurrentInstance as sn, inject as Ve, onUnmounted as cs, shallowRef as ir, onBeforeMount as ea, watch as ne, Fragment as Mt, createVNode as We, Text as ta, openBlock as F, createElementBlock as W, createElementVNode as fe, toDisplayString as z, provide as mt, renderSlot as te, normalizeClass as Fe, unref as L, normalizeStyle as us, withDirectives as Sn, cloneVNode as fs, Comment as ds, createCommentVNode as re, createBlock as Oe, mergeProps as Cn, withCtx as pe, toRef as qt, Teleport as ps, Transition as ms, vShow as na, readonly as _s, onDeactivated as vs, createTextVNode as Jt, warn as gs, nextTick as Ur, getCurrentScope as ra, onScopeDispose as oa, toRefs as Vr, isRef as Gn, vModelCheckbox as hs, createStaticVNode as bs, toRaw as Es, renderList as xn, resolveDynamicComponent as ys, normalizeProps as Ns, guardReactiveProps as Os, useSlots as Ts } from "vue";
const Ls = (e) => {
  tt(() => {
    e.setComponentRef(), e.startWatchingViewportWidth();
  }), nt(() => {
    e.stopWatchingViewportWidth();
  });
}, Is = (e, t) => {
  const n = B([]), r = B(!1), o = P(() => e.allowToSelectRows ? e.data.reduce((d, _, p) => (_.isSelectable !== !1 && d.push(p), d), []) : []), a = P(() => o.value.length > 0 && n.value.length === o.value.length), l = B(!1);
  return {
    selectedRowIndex: n,
    selectAllValues: r,
    areAllRowsSelected: a,
    isSelectAllInvisibleRowsShown: l,
    onSelectAllRowsClick: () => {
      n.value = a.value ? [] : o.value;
    },
    onSelectAllInvisibleRows: () => {
      l.value = !1, t("selectAllInvisibleRows");
    },
    onResetSelection: () => {
      l.value = !1, n.value = [];
    }
  };
}, Rt = {
  asc: "asc",
  desc: "desc",
  inactive: "inactive"
}, ws = (e, t) => {
  var s, c;
  const n = Rt.desc, r = P(() => {
    var d;
    return !!((d = e.sorting) != null && d.isEnabled);
  }), o = B((s = e.sorting) == null ? void 0 : s.defaultSortingColumn), a = B((c = e.sorting) != null && c.isEnabled ? n : void 0);
  return {
    defaultSortDirection: n,
    isSortingEnabled: r,
    sortingColumnId: o,
    sortingDirection: a,
    onSortingChanged: (d) => {
      r.value && (d === o.value ? a.value = a.value === Rt.asc ? Rt.desc : Rt.asc : (o.value = d, a.value = n), t("sortingChange", { columnId: o.value, direction: a.value }));
    },
    retrieveSortingOptionsForHeader: (d, _) => {
      const p = {
        isEnabled: !!(r.value && _)
      };
      return p.isEnabled && (p.direction = o.value === d ? a.value : Rt.inactive), p;
    }
  };
};
class As {
  constructor(t, n) {
    ue(this, "mediaQueryList");
    ue(this, "componentRef");
    this.mediaQueryList = window.matchMedia(t), this.componentRef = n;
  }
  startWatchingViewportWidth() {
    this.mediaQueryList.addEventListener("change", this.handleCardModeMediaQueryEvent());
  }
  stopWatchingViewportWidth() {
    this.mediaQueryList.removeEventListener("change", this.handleCardModeMediaQueryEvent());
  }
  setComponentRef(t) {
    this.componentRef.value = t ?? this.mediaQueryList.matches;
  }
  handleCardModeMediaQueryEvent() {
    return (t) => {
      this.setComponentRef(t.matches);
    };
  }
}
/*!
  * shared v9.9.0
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
const lt = typeof window < "u";
let Se, Lt;
if (process.env.NODE_ENV !== "production") {
  const e = lt && window.performance;
  e && e.mark && e.measure && e.clearMarks && // @ts-ignore browser compat
  e.clearMeasures && (Se = (t) => {
    e.mark(t);
  }, Lt = (t, n, r) => {
    e.measure(t, n, r), e.clearMarks(n), e.clearMarks(r);
  });
}
const Ss = /\{([0-9a-zA-Z]+)\}/g;
function cr(e, ...t) {
  return t.length === 1 && J(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(Ss, (n, r) => t.hasOwnProperty(r) ? t[r] : "");
}
const ct = (e, t = !1) => t ? Symbol.for(e) : Symbol(e), Cs = (e, t, n) => Rs({ l: e, k: t, s: n }), Rs = (e) => JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), ge = (e) => typeof e == "number" && isFinite(e), ks = (e) => sa(e) === "[object Date]", Ft = (e) => sa(e) === "[object RegExp]", Rn = (e) => Y(e) && Object.keys(e).length === 0, he = Object.assign;
let Br;
const st = () => Br || (Br = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function Wr(e) {
  return e.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
const Ps = Object.prototype.hasOwnProperty;
function On(e, t) {
  return Ps.call(e, t);
}
const de = Array.isArray, ee = (e) => typeof e == "function", k = (e) => typeof e == "string", Z = (e) => typeof e == "boolean", J = (e) => e !== null && typeof e == "object", Ds = (e) => J(e) && ee(e.then) && ee(e.catch), aa = Object.prototype.toString, sa = (e) => aa.call(e), Y = (e) => {
  if (!J(e))
    return !1;
  const t = Object.getPrototypeOf(e);
  return t === null || t.constructor === Object;
}, Ms = (e) => e == null ? "" : de(e) || Y(e) && e.toString === aa ? JSON.stringify(e, null, 2) : String(e);
function Fs(e, t = "") {
  return e.reduce((n, r, o) => o === 0 ? n + r : n + t + r, "");
}
const Hr = 2;
function xs(e, t = 0, n = e.length) {
  const r = e.split(/\r?\n/);
  let o = 0;
  const a = [];
  for (let l = 0; l < r.length; l++)
    if (o += r[l].length + 1, o >= t) {
      for (let i = l - Hr; i <= l + Hr || n > o; i++) {
        if (i < 0 || i >= r.length)
          continue;
        const s = i + 1;
        a.push(`${s}${" ".repeat(3 - String(s).length)}|  ${r[i]}`);
        const c = r[i].length;
        if (i === l) {
          const d = t - (o - c) + 1, _ = Math.max(1, n > o ? c - d : n - t);
          a.push("   |  " + " ".repeat(d) + "^".repeat(_));
        } else if (i > l) {
          if (n > o) {
            const d = Math.max(Math.min(n - o, c), 1);
            a.push("   |  " + "^".repeat(d));
          }
          o += c + 1;
        }
      }
      break;
    }
  return a.join(`
`);
}
function ur(e) {
  let t = e;
  return () => ++t;
}
function _t(e, t) {
  typeof console < "u" && (console.warn("[intlify] " + e), t && console.warn(t.stack));
}
const jr = {};
function $s(e) {
  jr[e] || (jr[e] = !0, _t(e));
}
function Us() {
  const e = /* @__PURE__ */ new Map();
  return {
    events: e,
    on(n, r) {
      const o = e.get(n);
      o && o.push(r) || e.set(n, [r]);
    },
    off(n, r) {
      const o = e.get(n);
      o && o.splice(o.indexOf(r) >>> 0, 1);
    },
    emit(n, r) {
      (e.get(n) || []).slice().map((o) => o(r)), (e.get("*") || []).slice().map((o) => o(n, r));
    }
  };
}
const mn = (e) => !J(e) || de(e);
function En(e, t) {
  if (mn(e) || mn(t))
    throw new Error("Invalid value");
  const n = [{ src: e, des: t }];
  for (; n.length; ) {
    const { src: r, des: o } = n.pop();
    Object.keys(r).forEach((a) => {
      mn(r[a]) || mn(o[a]) ? o[a] = r[a] : n.push({ src: r[a], des: o[a] });
    });
  }
}
/*!
  * message-compiler v9.9.0
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
function Vs(e, t, n) {
  return { line: e, column: t, offset: n };
}
function Kn(e, t, n) {
  const r = { start: e, end: t };
  return n != null && (r.source = n), r;
}
const Bs = /\{([0-9a-zA-Z]+)\}/g;
function Ws(e, ...t) {
  return t.length === 1 && Hs(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(Bs, (n, r) => t.hasOwnProperty(r) ? t[r] : "");
}
const la = Object.assign, Yr = (e) => typeof e == "string", Hs = (e) => e !== null && typeof e == "object";
function ia(e, t = "") {
  return e.reduce((n, r, o) => o === 0 ? n + r : n + t + r, "");
}
const U = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16,
  // Special value for higher-order compilers to pick up the last code
  // to avoid collision of error codes. This should always be kept as the last
  // item.
  __EXTEND_POINT__: 17
}, js = {
  // tokenizer error messages
  [U.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [U.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [U.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [U.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [U.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [U.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [U.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [U.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [U.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [U.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [U.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [U.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [U.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [U.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [U.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [U.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function Ht(e, t, n = {}) {
  const { domain: r, messages: o, args: a } = n, l = Ws((o || js)[e] || "", ...a || []), i = new SyntaxError(String(l));
  return i.code = e, t && (i.location = t), i.domain = r, i;
}
function Ys(e) {
  throw e;
}
const Gs = /<\/?[\w\s="/.':;#-\/]+>/, Ks = (e) => Gs.test(e), ot = " ", Xs = "\r", ye = `
`, qs = String.fromCharCode(8232), Js = String.fromCharCode(8233);
function Qs(e) {
  const t = e;
  let n = 0, r = 1, o = 1, a = 0;
  const l = (S) => t[S] === Xs && t[S + 1] === ye, i = (S) => t[S] === ye, s = (S) => t[S] === Js, c = (S) => t[S] === qs, d = (S) => l(S) || i(S) || s(S) || c(S), _ = () => n, p = () => r, b = () => o, g = () => a, y = (S) => l(S) || s(S) || c(S) ? ye : t[S], E = () => y(n), u = () => y(n + a);
  function h() {
    return a = 0, d(n) && (r++, o = 0), l(n) && n++, n++, o++, t[n];
  }
  function T() {
    return l(n + a) && a++, a++, t[n + a];
  }
  function v() {
    n = 0, r = 1, o = 1, a = 0;
  }
  function A(S = 0) {
    a = S;
  }
  function N() {
    const S = n + a;
    for (; S !== n; )
      h();
    a = 0;
  }
  return {
    index: _,
    line: p,
    column: b,
    peekOffset: g,
    charAt: y,
    currentChar: E,
    currentPeek: u,
    next: h,
    peek: T,
    reset: v,
    resetPeek: A,
    skipToPeek: N
  };
}
const ut = void 0, Zs = ".", Gr = "'", zs = "tokenizer";
function el(e, t = {}) {
  const n = t.location !== !1, r = Qs(e), o = () => r.index(), a = () => Vs(r.line(), r.column(), r.index()), l = a(), i = o(), s = {
    currentType: 14,
    offset: i,
    startLoc: l,
    endLoc: l,
    lastType: 14,
    lastOffset: i,
    lastStartLoc: l,
    lastEndLoc: l,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, c = () => s, { onError: d } = t;
  function _(m, f, O, ...R) {
    const $ = c();
    if (f.column += O, f.offset += O, d) {
      const X = n ? Kn($.startLoc, f) : null, ke = Ht(m, X, {
        domain: zs,
        args: R
      });
      d(ke);
    }
  }
  function p(m, f, O) {
    m.endLoc = a(), m.currentType = f;
    const R = { type: f };
    return n && (R.loc = Kn(m.startLoc, m.endLoc)), O != null && (R.value = O), R;
  }
  const b = (m) => p(
    m,
    14
    /* TokenTypes.EOF */
  );
  function g(m, f) {
    return m.currentChar() === f ? (m.next(), f) : (_(U.EXPECTED_TOKEN, a(), 0, f), "");
  }
  function y(m) {
    let f = "";
    for (; m.currentPeek() === ot || m.currentPeek() === ye; )
      f += m.currentPeek(), m.peek();
    return f;
  }
  function E(m) {
    const f = y(m);
    return m.skipToPeek(), f;
  }
  function u(m) {
    if (m === ut)
      return !1;
    const f = m.charCodeAt(0);
    return f >= 97 && f <= 122 || // a-z
    f >= 65 && f <= 90 || // A-Z
    f === 95;
  }
  function h(m) {
    if (m === ut)
      return !1;
    const f = m.charCodeAt(0);
    return f >= 48 && f <= 57;
  }
  function T(m, f) {
    const { currentType: O } = f;
    if (O !== 2)
      return !1;
    y(m);
    const R = u(m.currentPeek());
    return m.resetPeek(), R;
  }
  function v(m, f) {
    const { currentType: O } = f;
    if (O !== 2)
      return !1;
    y(m);
    const R = m.currentPeek() === "-" ? m.peek() : m.currentPeek(), $ = h(R);
    return m.resetPeek(), $;
  }
  function A(m, f) {
    const { currentType: O } = f;
    if (O !== 2)
      return !1;
    y(m);
    const R = m.currentPeek() === Gr;
    return m.resetPeek(), R;
  }
  function N(m, f) {
    const { currentType: O } = f;
    if (O !== 8)
      return !1;
    y(m);
    const R = m.currentPeek() === ".";
    return m.resetPeek(), R;
  }
  function S(m, f) {
    const { currentType: O } = f;
    if (O !== 9)
      return !1;
    y(m);
    const R = u(m.currentPeek());
    return m.resetPeek(), R;
  }
  function w(m, f) {
    const { currentType: O } = f;
    if (!(O === 8 || O === 12))
      return !1;
    y(m);
    const R = m.currentPeek() === ":";
    return m.resetPeek(), R;
  }
  function D(m, f) {
    const { currentType: O } = f;
    if (O !== 10)
      return !1;
    const R = () => {
      const X = m.currentPeek();
      return X === "{" ? u(m.peek()) : X === "@" || X === "%" || X === "|" || X === ":" || X === "." || X === ot || !X ? !1 : X === ye ? (m.peek(), R()) : u(X);
    }, $ = R();
    return m.resetPeek(), $;
  }
  function x(m) {
    y(m);
    const f = m.currentPeek() === "|";
    return m.resetPeek(), f;
  }
  function V(m) {
    const f = y(m), O = m.currentPeek() === "%" && m.peek() === "{";
    return m.resetPeek(), {
      isModulo: O,
      hasSpace: f.length > 0
    };
  }
  function G(m, f = !0) {
    const O = ($ = !1, X = "", ke = !1) => {
      const ve = m.currentPeek();
      return ve === "{" ? X === "%" ? !1 : $ : ve === "@" || !ve ? X === "%" ? !0 : $ : ve === "%" ? (m.peek(), O($, "%", !0)) : ve === "|" ? X === "%" || ke ? !0 : !(X === ot || X === ye) : ve === ot ? (m.peek(), O(!0, ot, ke)) : ve === ye ? (m.peek(), O(!0, ye, ke)) : !0;
    }, R = O();
    return f && m.resetPeek(), R;
  }
  function j(m, f) {
    const O = m.currentChar();
    return O === ut ? ut : f(O) ? (m.next(), O) : null;
  }
  function le(m) {
    return j(m, (O) => {
      const R = O.charCodeAt(0);
      return R >= 97 && R <= 122 || // a-z
      R >= 65 && R <= 90 || // A-Z
      R >= 48 && R <= 57 || // 0-9
      R === 95 || // _
      R === 36;
    });
  }
  function se(m) {
    return j(m, (O) => {
      const R = O.charCodeAt(0);
      return R >= 48 && R <= 57;
    });
  }
  function q(m) {
    return j(m, (O) => {
      const R = O.charCodeAt(0);
      return R >= 48 && R <= 57 || // 0-9
      R >= 65 && R <= 70 || // A-F
      R >= 97 && R <= 102;
    });
  }
  function M(m) {
    let f = "", O = "";
    for (; f = se(m); )
      O += f;
    return O;
  }
  function ce(m) {
    E(m);
    const f = m.currentChar();
    return f !== "%" && _(U.EXPECTED_TOKEN, a(), 0, f), m.next(), "%";
  }
  function _e(m) {
    let f = "";
    for (; ; ) {
      const O = m.currentChar();
      if (O === "{" || O === "}" || O === "@" || O === "|" || !O)
        break;
      if (O === "%")
        if (G(m))
          f += O, m.next();
        else
          break;
      else if (O === ot || O === ye)
        if (G(m))
          f += O, m.next();
        else {
          if (x(m))
            break;
          f += O, m.next();
        }
      else
        f += O, m.next();
    }
    return f;
  }
  function Ye(m) {
    E(m);
    let f = "", O = "";
    for (; f = le(m); )
      O += f;
    return m.currentChar() === ut && _(U.UNTERMINATED_CLOSING_BRACE, a(), 0), O;
  }
  function be(m) {
    E(m);
    let f = "";
    return m.currentChar() === "-" ? (m.next(), f += `-${M(m)}`) : f += M(m), m.currentChar() === ut && _(U.UNTERMINATED_CLOSING_BRACE, a(), 0), f;
  }
  function Re(m) {
    E(m), g(m, "'");
    let f = "", O = "";
    const R = (X) => X !== Gr && X !== ye;
    for (; f = j(m, R); )
      f === "\\" ? O += Ge(m) : O += f;
    const $ = m.currentChar();
    return $ === ye || $ === ut ? (_(U.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, a(), 0), $ === ye && (m.next(), g(m, "'")), O) : (g(m, "'"), O);
  }
  function Ge(m) {
    const f = m.currentChar();
    switch (f) {
      case "\\":
      case "'":
        return m.next(), `\\${f}`;
      case "u":
        return Te(m, f, 4);
      case "U":
        return Te(m, f, 6);
      default:
        return _(U.UNKNOWN_ESCAPE_SEQUENCE, a(), 0, f), "";
    }
  }
  function Te(m, f, O) {
    g(m, f);
    let R = "";
    for (let $ = 0; $ < O; $++) {
      const X = q(m);
      if (!X) {
        _(U.INVALID_UNICODE_ESCAPE_SEQUENCE, a(), 0, `\\${f}${R}${m.currentChar()}`);
        break;
      }
      R += X;
    }
    return `\\${f}${R}`;
  }
  function Ee(m) {
    E(m);
    let f = "", O = "";
    const R = ($) => $ !== "{" && $ !== "}" && $ !== ot && $ !== ye;
    for (; f = j(m, R); )
      O += f;
    return O;
  }
  function Ke(m) {
    let f = "", O = "";
    for (; f = le(m); )
      O += f;
    return O;
  }
  function Xe(m) {
    const f = (O = !1, R) => {
      const $ = m.currentChar();
      return $ === "{" || $ === "%" || $ === "@" || $ === "|" || $ === "(" || $ === ")" || !$ || $ === ot ? R : $ === ye || $ === Zs ? (R += $, m.next(), f(O, R)) : (R += $, m.next(), f(!0, R));
    };
    return f(!1, "");
  }
  function Le(m) {
    E(m);
    const f = g(
      m,
      "|"
      /* TokenChars.Pipe */
    );
    return E(m), f;
  }
  function rt(m, f) {
    let O = null;
    switch (m.currentChar()) {
      case "{":
        return f.braceNest >= 1 && _(U.NOT_ALLOW_NEST_PLACEHOLDER, a(), 0), m.next(), O = p(
          f,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), E(m), f.braceNest++, O;
      case "}":
        return f.braceNest > 0 && f.currentType === 2 && _(U.EMPTY_PLACEHOLDER, a(), 0), m.next(), O = p(
          f,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), f.braceNest--, f.braceNest > 0 && E(m), f.inLinked && f.braceNest === 0 && (f.inLinked = !1), O;
      case "@":
        return f.braceNest > 0 && _(U.UNTERMINATED_CLOSING_BRACE, a(), 0), O = qe(m, f) || b(f), f.braceNest = 0, O;
      default:
        let $ = !0, X = !0, ke = !0;
        if (x(m))
          return f.braceNest > 0 && _(U.UNTERMINATED_CLOSING_BRACE, a(), 0), O = p(f, 1, Le(m)), f.braceNest = 0, f.inLinked = !1, O;
        if (f.braceNest > 0 && (f.currentType === 5 || f.currentType === 6 || f.currentType === 7))
          return _(U.UNTERMINATED_CLOSING_BRACE, a(), 0), f.braceNest = 0, Be(m, f);
        if ($ = T(m, f))
          return O = p(f, 5, Ye(m)), E(m), O;
        if (X = v(m, f))
          return O = p(f, 6, be(m)), E(m), O;
        if (ke = A(m, f))
          return O = p(f, 7, Re(m)), E(m), O;
        if (!$ && !X && !ke)
          return O = p(f, 13, Ee(m)), _(U.INVALID_TOKEN_IN_PLACEHOLDER, a(), 0, O.value), E(m), O;
        break;
    }
    return O;
  }
  function qe(m, f) {
    const { currentType: O } = f;
    let R = null;
    const $ = m.currentChar();
    switch ((O === 8 || O === 9 || O === 12 || O === 10) && ($ === ye || $ === ot) && _(U.INVALID_LINKED_FORMAT, a(), 0), $) {
      case "@":
        return m.next(), R = p(
          f,
          8,
          "@"
          /* TokenChars.LinkedAlias */
        ), f.inLinked = !0, R;
      case ".":
        return E(m), m.next(), p(
          f,
          9,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return E(m), m.next(), p(
          f,
          10,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return x(m) ? (R = p(f, 1, Le(m)), f.braceNest = 0, f.inLinked = !1, R) : N(m, f) || w(m, f) ? (E(m), qe(m, f)) : S(m, f) ? (E(m), p(f, 12, Ke(m))) : D(m, f) ? (E(m), $ === "{" ? rt(m, f) || R : p(f, 11, Xe(m))) : (O === 8 && _(U.INVALID_LINKED_FORMAT, a(), 0), f.braceNest = 0, f.inLinked = !1, Be(m, f));
    }
  }
  function Be(m, f) {
    let O = {
      type: 14
      /* TokenTypes.EOF */
    };
    if (f.braceNest > 0)
      return rt(m, f) || b(f);
    if (f.inLinked)
      return qe(m, f) || b(f);
    switch (m.currentChar()) {
      case "{":
        return rt(m, f) || b(f);
      case "}":
        return _(U.UNBALANCED_CLOSING_BRACE, a(), 0), m.next(), p(
          f,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return qe(m, f) || b(f);
      default:
        if (x(m))
          return O = p(f, 1, Le(m)), f.braceNest = 0, f.inLinked = !1, O;
        const { isModulo: $, hasSpace: X } = V(m);
        if ($)
          return X ? p(f, 0, _e(m)) : p(f, 4, ce(m));
        if (G(m))
          return p(f, 0, _e(m));
        break;
    }
    return O;
  }
  function ht() {
    const { currentType: m, offset: f, startLoc: O, endLoc: R } = s;
    return s.lastType = m, s.lastOffset = f, s.lastStartLoc = O, s.lastEndLoc = R, s.offset = o(), s.startLoc = a(), r.currentChar() === ut ? p(
      s,
      14
      /* TokenTypes.EOF */
    ) : Be(r, s);
  }
  return {
    nextToken: ht,
    currentOffset: o,
    currentPosition: a,
    context: c
  };
}
const tl = "parser", nl = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function rl(e, t, n) {
  switch (e) {
    case "\\\\":
      return "\\";
    case "\\'":
      return "'";
    default: {
      const r = parseInt(t || n, 16);
      return r <= 55295 || r >= 57344 ? String.fromCodePoint(r) : "�";
    }
  }
}
function ol(e = {}) {
  const t = e.location !== !1, { onError: n } = e;
  function r(u, h, T, v, ...A) {
    const N = u.currentPosition();
    if (N.offset += v, N.column += v, n) {
      const S = t ? Kn(T, N) : null, w = Ht(h, S, {
        domain: tl,
        args: A
      });
      n(w);
    }
  }
  function o(u, h, T) {
    const v = { type: u };
    return t && (v.start = h, v.end = h, v.loc = { start: T, end: T }), v;
  }
  function a(u, h, T, v) {
    v && (u.type = v), t && (u.end = h, u.loc && (u.loc.end = T));
  }
  function l(u, h) {
    const T = u.context(), v = o(3, T.offset, T.startLoc);
    return v.value = h, a(v, u.currentOffset(), u.currentPosition()), v;
  }
  function i(u, h) {
    const T = u.context(), { lastOffset: v, lastStartLoc: A } = T, N = o(5, v, A);
    return N.index = parseInt(h, 10), u.nextToken(), a(N, u.currentOffset(), u.currentPosition()), N;
  }
  function s(u, h) {
    const T = u.context(), { lastOffset: v, lastStartLoc: A } = T, N = o(4, v, A);
    return N.key = h, u.nextToken(), a(N, u.currentOffset(), u.currentPosition()), N;
  }
  function c(u, h) {
    const T = u.context(), { lastOffset: v, lastStartLoc: A } = T, N = o(9, v, A);
    return N.value = h.replace(nl, rl), u.nextToken(), a(N, u.currentOffset(), u.currentPosition()), N;
  }
  function d(u) {
    const h = u.nextToken(), T = u.context(), { lastOffset: v, lastStartLoc: A } = T, N = o(8, v, A);
    return h.type !== 12 ? (r(u, U.UNEXPECTED_EMPTY_LINKED_MODIFIER, T.lastStartLoc, 0), N.value = "", a(N, v, A), {
      nextConsumeToken: h,
      node: N
    }) : (h.value == null && r(u, U.UNEXPECTED_LEXICAL_ANALYSIS, T.lastStartLoc, 0, Je(h)), N.value = h.value || "", a(N, u.currentOffset(), u.currentPosition()), {
      node: N
    });
  }
  function _(u, h) {
    const T = u.context(), v = o(7, T.offset, T.startLoc);
    return v.value = h, a(v, u.currentOffset(), u.currentPosition()), v;
  }
  function p(u) {
    const h = u.context(), T = o(6, h.offset, h.startLoc);
    let v = u.nextToken();
    if (v.type === 9) {
      const A = d(u);
      T.modifier = A.node, v = A.nextConsumeToken || u.nextToken();
    }
    switch (v.type !== 10 && r(u, U.UNEXPECTED_LEXICAL_ANALYSIS, h.lastStartLoc, 0, Je(v)), v = u.nextToken(), v.type === 2 && (v = u.nextToken()), v.type) {
      case 11:
        v.value == null && r(u, U.UNEXPECTED_LEXICAL_ANALYSIS, h.lastStartLoc, 0, Je(v)), T.key = _(u, v.value || "");
        break;
      case 5:
        v.value == null && r(u, U.UNEXPECTED_LEXICAL_ANALYSIS, h.lastStartLoc, 0, Je(v)), T.key = s(u, v.value || "");
        break;
      case 6:
        v.value == null && r(u, U.UNEXPECTED_LEXICAL_ANALYSIS, h.lastStartLoc, 0, Je(v)), T.key = i(u, v.value || "");
        break;
      case 7:
        v.value == null && r(u, U.UNEXPECTED_LEXICAL_ANALYSIS, h.lastStartLoc, 0, Je(v)), T.key = c(u, v.value || "");
        break;
      default:
        r(u, U.UNEXPECTED_EMPTY_LINKED_KEY, h.lastStartLoc, 0);
        const A = u.context(), N = o(7, A.offset, A.startLoc);
        return N.value = "", a(N, A.offset, A.startLoc), T.key = N, a(T, A.offset, A.startLoc), {
          nextConsumeToken: v,
          node: T
        };
    }
    return a(T, u.currentOffset(), u.currentPosition()), {
      node: T
    };
  }
  function b(u) {
    const h = u.context(), T = h.currentType === 1 ? u.currentOffset() : h.offset, v = h.currentType === 1 ? h.endLoc : h.startLoc, A = o(2, T, v);
    A.items = [];
    let N = null;
    do {
      const D = N || u.nextToken();
      switch (N = null, D.type) {
        case 0:
          D.value == null && r(u, U.UNEXPECTED_LEXICAL_ANALYSIS, h.lastStartLoc, 0, Je(D)), A.items.push(l(u, D.value || ""));
          break;
        case 6:
          D.value == null && r(u, U.UNEXPECTED_LEXICAL_ANALYSIS, h.lastStartLoc, 0, Je(D)), A.items.push(i(u, D.value || ""));
          break;
        case 5:
          D.value == null && r(u, U.UNEXPECTED_LEXICAL_ANALYSIS, h.lastStartLoc, 0, Je(D)), A.items.push(s(u, D.value || ""));
          break;
        case 7:
          D.value == null && r(u, U.UNEXPECTED_LEXICAL_ANALYSIS, h.lastStartLoc, 0, Je(D)), A.items.push(c(u, D.value || ""));
          break;
        case 8:
          const x = p(u);
          A.items.push(x.node), N = x.nextConsumeToken || null;
          break;
      }
    } while (h.currentType !== 14 && h.currentType !== 1);
    const S = h.currentType === 1 ? h.lastOffset : u.currentOffset(), w = h.currentType === 1 ? h.lastEndLoc : u.currentPosition();
    return a(A, S, w), A;
  }
  function g(u, h, T, v) {
    const A = u.context();
    let N = v.items.length === 0;
    const S = o(1, h, T);
    S.cases = [], S.cases.push(v);
    do {
      const w = b(u);
      N || (N = w.items.length === 0), S.cases.push(w);
    } while (A.currentType !== 14);
    return N && r(u, U.MUST_HAVE_MESSAGES_IN_PLURAL, T, 0), a(S, u.currentOffset(), u.currentPosition()), S;
  }
  function y(u) {
    const h = u.context(), { offset: T, startLoc: v } = h, A = b(u);
    return h.currentType === 14 ? A : g(u, T, v, A);
  }
  function E(u) {
    const h = el(u, la({}, e)), T = h.context(), v = o(0, T.offset, T.startLoc);
    return t && v.loc && (v.loc.source = u), v.body = y(h), e.onCacheKey && (v.cacheKey = e.onCacheKey(u)), T.currentType !== 14 && r(h, U.UNEXPECTED_LEXICAL_ANALYSIS, T.lastStartLoc, 0, u[T.offset] || ""), a(v, h.currentOffset(), h.currentPosition()), v;
  }
  return { parse: E };
}
function Je(e) {
  if (e.type === 14)
    return "EOF";
  const t = (e.value || "").replace(/\r?\n/gu, "\\n");
  return t.length > 10 ? t.slice(0, 9) + "…" : t;
}
function al(e, t = {}) {
  const n = {
    ast: e,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => n, helper: (a) => (n.helpers.add(a), a) };
}
function Kr(e, t) {
  for (let n = 0; n < e.length; n++)
    fr(e[n], t);
}
function fr(e, t) {
  switch (e.type) {
    case 1:
      Kr(e.cases, t), t.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      Kr(e.items, t);
      break;
    case 6:
      fr(e.key, t), t.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), t.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    case 5:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function sl(e, t = {}) {
  const n = al(e);
  n.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), e.body && fr(e.body, n);
  const r = n.context();
  e.helpers = Array.from(r.helpers);
}
function ll(e) {
  const t = e.body;
  return t.type === 2 ? Xr(t) : t.cases.forEach((n) => Xr(n)), e;
}
function Xr(e) {
  if (e.items.length === 1) {
    const t = e.items[0];
    (t.type === 3 || t.type === 9) && (e.static = t.value, delete t.value);
  } else {
    const t = [];
    for (let n = 0; n < e.items.length; n++) {
      const r = e.items[n];
      if (!(r.type === 3 || r.type === 9) || r.value == null)
        break;
      t.push(r.value);
    }
    if (t.length === e.items.length) {
      e.static = ia(t);
      for (let n = 0; n < e.items.length; n++) {
        const r = e.items[n];
        (r.type === 3 || r.type === 9) && delete r.value;
      }
    }
  }
}
const il = "minifier";
function kt(e) {
  switch (e.t = e.type, e.type) {
    case 0:
      const t = e;
      kt(t.body), t.b = t.body, delete t.body;
      break;
    case 1:
      const n = e, r = n.cases;
      for (let d = 0; d < r.length; d++)
        kt(r[d]);
      n.c = r, delete n.cases;
      break;
    case 2:
      const o = e, a = o.items;
      for (let d = 0; d < a.length; d++)
        kt(a[d]);
      o.i = a, delete o.items, o.static && (o.s = o.static, delete o.static);
      break;
    case 3:
    case 9:
    case 8:
    case 7:
      const l = e;
      l.value && (l.v = l.value, delete l.value);
      break;
    case 6:
      const i = e;
      kt(i.key), i.k = i.key, delete i.key, i.modifier && (kt(i.modifier), i.m = i.modifier, delete i.modifier);
      break;
    case 5:
      const s = e;
      s.i = s.index, delete s.index;
      break;
    case 4:
      const c = e;
      c.k = c.key, delete c.key;
      break;
    default:
      throw Ht(U.UNHANDLED_MINIFIER_NODE_TYPE, null, {
        domain: il,
        args: [e.type]
      });
  }
  delete e.type;
}
const cl = "parser";
function ul(e, t) {
  const { sourceMap: n, filename: r, breakLineCode: o, needIndent: a } = t, l = t.location !== !1, i = {
    filename: r,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: o,
    needIndent: a,
    indentLevel: 0
  };
  l && e.loc && (i.source = e.loc.source);
  const s = () => i;
  function c(E, u) {
    i.code += E;
  }
  function d(E, u = !0) {
    const h = u ? o : "";
    c(a ? h + "  ".repeat(E) : h);
  }
  function _(E = !0) {
    const u = ++i.indentLevel;
    E && d(u);
  }
  function p(E = !0) {
    const u = --i.indentLevel;
    E && d(u);
  }
  function b() {
    d(i.indentLevel);
  }
  return {
    context: s,
    push: c,
    indent: _,
    deindent: p,
    newline: b,
    helper: (E) => `_${E}`,
    needIndent: () => i.needIndent
  };
}
function fl(e, t) {
  const { helper: n } = e;
  e.push(`${n(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), xt(e, t.key), t.modifier ? (e.push(", "), xt(e, t.modifier), e.push(", _type")) : e.push(", undefined, _type"), e.push(")");
}
function dl(e, t) {
  const { helper: n, needIndent: r } = e;
  e.push(`${n(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), e.indent(r());
  const o = t.items.length;
  for (let a = 0; a < o && (xt(e, t.items[a]), a !== o - 1); a++)
    e.push(", ");
  e.deindent(r()), e.push("])");
}
function pl(e, t) {
  const { helper: n, needIndent: r } = e;
  if (t.cases.length > 1) {
    e.push(`${n(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), e.indent(r());
    const o = t.cases.length;
    for (let a = 0; a < o && (xt(e, t.cases[a]), a !== o - 1); a++)
      e.push(", ");
    e.deindent(r()), e.push("])");
  }
}
function ml(e, t) {
  t.body ? xt(e, t.body) : e.push("null");
}
function xt(e, t) {
  const { helper: n } = e;
  switch (t.type) {
    case 0:
      ml(e, t);
      break;
    case 1:
      pl(e, t);
      break;
    case 2:
      dl(e, t);
      break;
    case 6:
      fl(e, t);
      break;
    case 8:
      e.push(JSON.stringify(t.value), t);
      break;
    case 7:
      e.push(JSON.stringify(t.value), t);
      break;
    case 5:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "list"
        /* HelperNameMap.LIST */
      )}(${t.index}))`, t);
      break;
    case 4:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(t.key)}))`, t);
      break;
    case 9:
      e.push(JSON.stringify(t.value), t);
      break;
    case 3:
      e.push(JSON.stringify(t.value), t);
      break;
    default:
      throw Ht(U.UNHANDLED_CODEGEN_NODE_TYPE, null, {
        domain: cl,
        args: [t.type]
      });
  }
}
const _l = (e, t = {}) => {
  const n = Yr(t.mode) ? t.mode : "normal", r = Yr(t.filename) ? t.filename : "message.intl", o = !!t.sourceMap, a = t.breakLineCode != null ? t.breakLineCode : n === "arrow" ? ";" : `
`, l = t.needIndent ? t.needIndent : n !== "arrow", i = e.helpers || [], s = ul(e, {
    mode: n,
    filename: r,
    sourceMap: o,
    breakLineCode: a,
    needIndent: l
  });
  s.push(n === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), s.indent(l), i.length > 0 && (s.push(`const { ${ia(i.map((_) => `${_}: _${_}`), ", ")} } = ctx`), s.newline()), s.push("return "), xt(s, e), s.deindent(l), s.push("}"), delete e.helpers;
  const { code: c, map: d } = s.context();
  return {
    ast: e,
    code: c,
    map: d ? d.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function vl(e, t = {}) {
  const n = la({}, t), r = !!n.jit, o = !!n.minify, a = n.optimize == null ? !0 : n.optimize, i = ol(n).parse(e);
  return r ? (a && ll(i), o && kt(i), { ast: i, code: "" }) : (sl(i, n), _l(i, n));
}
/*!
  * core-base v9.9.0
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
function gl() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (st().__INTLIFY_PROD_DEVTOOLS__ = !1), typeof __INTLIFY_JIT_COMPILATION__ != "boolean" && (st().__INTLIFY_JIT_COMPILATION__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (st().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
const vt = [];
vt[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
vt[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
vt[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
vt[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
vt[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
vt[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
vt[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const hl = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function bl(e) {
  return hl.test(e);
}
function El(e) {
  const t = e.charCodeAt(0), n = e.charCodeAt(e.length - 1);
  return t === n && (t === 34 || t === 39) ? e.slice(1, -1) : e;
}
function yl(e) {
  if (e == null)
    return "o";
  switch (e.charCodeAt(0)) {
    case 91:
    case 93:
    case 46:
    case 34:
    case 39:
      return e;
    case 95:
    case 36:
    case 45:
      return "i";
    case 9:
    case 10:
    case 13:
    case 160:
    case 65279:
    case 8232:
    case 8233:
      return "w";
  }
  return "i";
}
function Nl(e) {
  const t = e.trim();
  return e.charAt(0) === "0" && isNaN(parseInt(e)) ? !1 : bl(t) ? El(t) : "*" + t;
}
function Ol(e) {
  const t = [];
  let n = -1, r = 0, o = 0, a, l, i, s, c, d, _;
  const p = [];
  p[
    0
    /* Actions.APPEND */
  ] = () => {
    l === void 0 ? l = i : l += i;
  }, p[
    1
    /* Actions.PUSH */
  ] = () => {
    l !== void 0 && (t.push(l), l = void 0);
  }, p[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    p[
      0
      /* Actions.APPEND */
    ](), o++;
  }, p[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (o > 0)
      o--, r = 4, p[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (o = 0, l === void 0 || (l = Nl(l), l === !1))
        return !1;
      p[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function b() {
    const g = e[n + 1];
    if (r === 5 && g === "'" || r === 6 && g === '"')
      return n++, i = "\\" + g, p[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; r !== null; )
    if (n++, a = e[n], !(a === "\\" && b())) {
      if (s = yl(a), _ = vt[r], c = _[s] || _.l || 8, c === 8 || (r = c[0], c[1] !== void 0 && (d = p[c[1]], d && (i = a, d() === !1))))
        return;
      if (r === 7)
        return t;
    }
}
const qr = /* @__PURE__ */ new Map();
function Tl(e, t) {
  return J(e) ? e[t] : null;
}
function Ll(e, t) {
  if (!J(e))
    return null;
  let n = qr.get(t);
  if (n || (n = Ol(t), n && qr.set(t, n)), !n)
    return null;
  const r = n.length;
  let o = e, a = 0;
  for (; a < r; ) {
    const l = o[n[a]];
    if (l === void 0 || ee(o))
      return null;
    o = l, a++;
  }
  return o;
}
const Il = (e) => e, wl = (e) => "", Al = "text", Sl = (e) => e.length === 0 ? "" : Fs(e), Cl = Ms;
function Jr(e, t) {
  return e = Math.abs(e), t === 2 ? e ? e > 1 ? 1 : 0 : 1 : e ? Math.min(e, 2) : 0;
}
function Rl(e) {
  const t = ge(e.pluralIndex) ? e.pluralIndex : -1;
  return e.named && (ge(e.named.count) || ge(e.named.n)) ? ge(e.named.count) ? e.named.count : ge(e.named.n) ? e.named.n : t : t;
}
function kl(e, t) {
  t.count || (t.count = e), t.n || (t.n = e);
}
function Pl(e = {}) {
  const t = e.locale, n = Rl(e), r = J(e.pluralRules) && k(t) && ee(e.pluralRules[t]) ? e.pluralRules[t] : Jr, o = J(e.pluralRules) && k(t) && ee(e.pluralRules[t]) ? Jr : void 0, a = (u) => u[r(n, u.length, o)], l = e.list || [], i = (u) => l[u], s = e.named || {};
  ge(e.pluralIndex) && kl(n, s);
  const c = (u) => s[u];
  function d(u) {
    const h = ee(e.messages) ? e.messages(u) : J(e.messages) ? e.messages[u] : !1;
    return h || (e.parent ? e.parent.message(u) : wl);
  }
  const _ = (u) => e.modifiers ? e.modifiers[u] : Il, p = Y(e.processor) && ee(e.processor.normalize) ? e.processor.normalize : Sl, b = Y(e.processor) && ee(e.processor.interpolate) ? e.processor.interpolate : Cl, g = Y(e.processor) && k(e.processor.type) ? e.processor.type : Al, E = {
    list: i,
    named: c,
    plural: a,
    linked: (u, ...h) => {
      const [T, v] = h;
      let A = "text", N = "";
      h.length === 1 ? J(T) ? (N = T.modifier || N, A = T.type || A) : k(T) && (N = T || N) : h.length === 2 && (k(T) && (N = T || N), k(v) && (A = v || A));
      const S = d(u)(E), w = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        A === "vnode" && de(S) && N ? S[0] : S
      );
      return N ? _(N)(w, A) : w;
    },
    message: d,
    type: g,
    interpolate: b,
    normalize: p,
    values: he({}, l, s)
  };
  return E;
}
let en = null;
function Dl(e) {
  en = e;
}
function Ml(e, t, n) {
  en && en.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: e,
    version: t,
    meta: n
  });
}
const Fl = /* @__PURE__ */ xl(
  "function:translate"
  /* IntlifyDevToolsHooks.FunctionTranslate */
);
function xl(e) {
  return (t) => en && en.emit(e, t);
}
const Ne = {
  NOT_FOUND_KEY: 1,
  FALLBACK_TO_TRANSLATE: 2,
  CANNOT_FORMAT_NUMBER: 3,
  FALLBACK_TO_NUMBER_FORMAT: 4,
  CANNOT_FORMAT_DATE: 5,
  FALLBACK_TO_DATE_FORMAT: 6,
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: 7,
  __EXTEND_POINT__: 8
}, $l = {
  [Ne.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [Ne.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [Ne.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [Ne.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [Ne.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [Ne.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [Ne.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future."
};
function It(e, ...t) {
  return cr($l[e], ...t);
}
const ca = U.__EXTEND_POINT__, yt = ur(ca), me = {
  INVALID_ARGUMENT: ca,
  INVALID_DATE_ARGUMENT: yt(),
  INVALID_ISO_DATE_ARGUMENT: yt(),
  NOT_SUPPORT_NON_STRING_MESSAGE: yt(),
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: yt(),
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: yt(),
  NOT_SUPPORT_LOCALE_TYPE: yt(),
  __EXTEND_POINT__: yt()
  // 25
};
function Qe(e) {
  return Ht(e, null, process.env.NODE_ENV !== "production" ? { messages: Ul } : void 0);
}
const Ul = {
  [me.INVALID_ARGUMENT]: "Invalid arguments",
  [me.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [me.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [me.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
  [me.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
  [me.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
  [me.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
function dr(e, t) {
  return t.locale != null ? Qr(t.locale) : Qr(e.locale);
}
let $n;
function Qr(e) {
  if (k(e))
    return e;
  if (ee(e)) {
    if (e.resolvedOnce && $n != null)
      return $n;
    if (e.constructor.name === "Function") {
      const t = e();
      if (Ds(t))
        throw Qe(me.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return $n = t;
    } else
      throw Qe(me.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw Qe(me.NOT_SUPPORT_LOCALE_TYPE);
}
function Vl(e, t, n) {
  return [.../* @__PURE__ */ new Set([
    n,
    ...de(t) ? t : J(t) ? Object.keys(t) : k(t) ? [t] : [n]
  ])];
}
function ua(e, t, n) {
  const r = k(n) ? n : tn, o = e;
  o.__localeChainCache || (o.__localeChainCache = /* @__PURE__ */ new Map());
  let a = o.__localeChainCache.get(r);
  if (!a) {
    a = [];
    let l = [n];
    for (; de(l); )
      l = Zr(a, l, t);
    const i = de(t) || !Y(t) ? t : t.default ? t.default : null;
    l = k(i) ? [i] : i, de(l) && Zr(a, l, !1), o.__localeChainCache.set(r, a);
  }
  return a;
}
function Zr(e, t, n) {
  let r = !0;
  for (let o = 0; o < t.length && Z(r); o++) {
    const a = t[o];
    k(a) && (r = Bl(e, t[o], n));
  }
  return r;
}
function Bl(e, t, n) {
  let r;
  const o = t.split("-");
  do {
    const a = o.join("-");
    r = Wl(e, a, n), o.splice(-1, 1);
  } while (o.length && r === !0);
  return r;
}
function Wl(e, t, n) {
  let r = !1;
  if (!e.includes(t) && (r = !0, t)) {
    r = t[t.length - 1] !== "!";
    const o = t.replace(/!/g, "");
    e.push(o), (de(n) || Y(n)) && n[o] && (r = n[o]);
  }
  return r;
}
const Hl = "9.9.0", kn = -1, tn = "en-US", Tn = "", zr = (e) => `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}`;
function jl() {
  return {
    upper: (e, t) => t === "text" && k(e) ? e.toUpperCase() : t === "vnode" && J(e) && "__v_isVNode" in e ? e.children.toUpperCase() : e,
    lower: (e, t) => t === "text" && k(e) ? e.toLowerCase() : t === "vnode" && J(e) && "__v_isVNode" in e ? e.children.toLowerCase() : e,
    capitalize: (e, t) => t === "text" && k(e) ? zr(e) : t === "vnode" && J(e) && "__v_isVNode" in e ? zr(e.children) : e
  };
}
let fa;
function eo(e) {
  fa = e;
}
let da;
function Yl(e) {
  da = e;
}
let pa;
function Gl(e) {
  pa = e;
}
let ma = null;
const Kl = /* @__NO_SIDE_EFFECTS__ */ (e) => {
  ma = e;
}, Xl = /* @__NO_SIDE_EFFECTS__ */ () => ma;
let _a = null;
const to = (e) => {
  _a = e;
}, ql = () => _a;
let no = 0;
function Jl(e = {}) {
  const t = ee(e.onWarn) ? e.onWarn : _t, n = k(e.version) ? e.version : Hl, r = k(e.locale) || ee(e.locale) ? e.locale : tn, o = ee(r) ? tn : r, a = de(e.fallbackLocale) || Y(e.fallbackLocale) || k(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : o, l = Y(e.messages) ? e.messages : { [o]: {} }, i = Y(e.datetimeFormats) ? e.datetimeFormats : { [o]: {} }, s = Y(e.numberFormats) ? e.numberFormats : { [o]: {} }, c = he({}, e.modifiers || {}, jl()), d = e.pluralRules || {}, _ = ee(e.missing) ? e.missing : null, p = Z(e.missingWarn) || Ft(e.missingWarn) ? e.missingWarn : !0, b = Z(e.fallbackWarn) || Ft(e.fallbackWarn) ? e.fallbackWarn : !0, g = !!e.fallbackFormat, y = !!e.unresolving, E = ee(e.postTranslation) ? e.postTranslation : null, u = Y(e.processor) ? e.processor : null, h = Z(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, T = !!e.escapeParameter, v = ee(e.messageCompiler) ? e.messageCompiler : fa;
  process.env.NODE_ENV !== "production" && ee(e.messageCompiler) && $s(It(Ne.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const A = ee(e.messageResolver) ? e.messageResolver : da || Tl, N = ee(e.localeFallbacker) ? e.localeFallbacker : pa || Vl, S = J(e.fallbackContext) ? e.fallbackContext : void 0, w = e, D = J(w.__datetimeFormatters) ? w.__datetimeFormatters : /* @__PURE__ */ new Map(), x = J(w.__numberFormatters) ? w.__numberFormatters : /* @__PURE__ */ new Map(), V = J(w.__meta) ? w.__meta : {};
  no++;
  const G = {
    version: n,
    cid: no,
    locale: r,
    fallbackLocale: a,
    messages: l,
    modifiers: c,
    pluralRules: d,
    missing: _,
    missingWarn: p,
    fallbackWarn: b,
    fallbackFormat: g,
    unresolving: y,
    postTranslation: E,
    processor: u,
    warnHtmlMessage: h,
    escapeParameter: T,
    messageCompiler: v,
    messageResolver: A,
    localeFallbacker: N,
    fallbackContext: S,
    onWarn: t,
    __meta: V
  };
  return G.datetimeFormats = i, G.numberFormats = s, G.__datetimeFormatters = D, G.__numberFormatters = x, process.env.NODE_ENV !== "production" && (G.__v_emitter = w.__v_emitter != null ? w.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && Ml(G, n, V), G;
}
function Pn(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function va(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function pr(e, t, n, r, o) {
  const { missing: a, onWarn: l } = e;
  if (process.env.NODE_ENV !== "production") {
    const i = e.__v_emitter;
    i && i.emit("missing", {
      locale: n,
      key: t,
      type: o,
      groupId: `${o}:${t}`
    });
  }
  if (a !== null) {
    const i = a(e, n, t, o);
    return k(i) ? i : t;
  } else
    return process.env.NODE_ENV !== "production" && va(r, t) && l(It(Ne.NOT_FOUND_KEY, { key: t, locale: n })), t;
}
function Kt(e, t, n) {
  const r = e;
  r.__localeChainCache = /* @__PURE__ */ new Map(), e.localeFallbacker(e, n, t);
}
function Un(e) {
  return (n) => Ql(n, e);
}
function Ql(e, t) {
  const n = t.b || t.body;
  if ((n.t || n.type) === 1) {
    const r = n, o = r.c || r.cases;
    return e.plural(o.reduce((a, l) => [
      ...a,
      ro(e, l)
    ], []));
  } else
    return ro(e, n);
}
function ro(e, t) {
  const n = t.s || t.static;
  if (n)
    return e.type === "text" ? n : e.normalize([n]);
  {
    const r = (t.i || t.items).reduce((o, a) => [...o, Xn(e, a)], []);
    return e.normalize(r);
  }
}
function Xn(e, t) {
  const n = t.t || t.type;
  switch (n) {
    case 3:
      const r = t;
      return r.v || r.value;
    case 9:
      const o = t;
      return o.v || o.value;
    case 4:
      const a = t;
      return e.interpolate(e.named(a.k || a.key));
    case 5:
      const l = t;
      return e.interpolate(e.list(l.i != null ? l.i : l.index));
    case 6:
      const i = t, s = i.m || i.modifier;
      return e.linked(Xn(e, i.k || i.key), s ? Xn(e, s) : void 0, e.type);
    case 7:
      const c = t;
      return c.v || c.value;
    case 8:
      const d = t;
      return d.v || d.value;
    default:
      throw new Error(`unhandled node type on format message part: ${n}`);
  }
}
const Zl = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function ga(e, t) {
  t && Ks(e) && _t(cr(Zl, { source: e }));
}
const ha = (e) => e;
let Dt = /* @__PURE__ */ Object.create(null);
const wt = (e) => J(e) && (e.t === 0 || e.type === 0) && ("b" in e || "body" in e);
function ba(e, t = {}) {
  let n = !1;
  const r = t.onError || Ys;
  return t.onError = (o) => {
    n = !0, r(o);
  }, { ...vl(e, t), detectError: n };
}
const zl = /* @__NO_SIDE_EFFECTS__ */ (e, t) => {
  if (!k(e))
    throw Qe(me.NOT_SUPPORT_NON_STRING_MESSAGE);
  {
    const n = Z(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && ga(e, n);
    const o = (t.onCacheKey || ha)(e), a = Dt[o];
    if (a)
      return a;
    const { code: l, detectError: i } = ba(e, t), s = new Function(`return ${l}`)();
    return i ? s : Dt[o] = s;
  }
};
function ei(e, t) {
  if (__INTLIFY_JIT_COMPILATION__ && !__INTLIFY_DROP_MESSAGE_COMPILER__ && k(e)) {
    const n = Z(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && ga(e, n);
    const o = (t.onCacheKey || ha)(e), a = Dt[o];
    if (a)
      return a;
    const { ast: l, detectError: i } = ba(e, {
      ...t,
      location: process.env.NODE_ENV !== "production",
      jit: !0
    }), s = Un(l);
    return i ? s : Dt[o] = s;
  } else {
    if (process.env.NODE_ENV !== "production" && !wt(e))
      return _t(`the message that is resolve with key '${t.key}' is not supported for jit compilation`), () => e;
    const n = e.cacheKey;
    if (n) {
      const r = Dt[n];
      return r || (Dt[n] = Un(e));
    } else
      return Un(e);
  }
}
const oo = () => "", Me = (e) => ee(e);
function ao(e, ...t) {
  const { fallbackFormat: n, postTranslation: r, unresolving: o, messageCompiler: a, fallbackLocale: l, messages: i } = e, [s, c] = qn(...t), d = Z(c.missingWarn) ? c.missingWarn : e.missingWarn, _ = Z(c.fallbackWarn) ? c.fallbackWarn : e.fallbackWarn, p = Z(c.escapeParameter) ? c.escapeParameter : e.escapeParameter, b = !!c.resolvedMessage, g = k(c.default) || Z(c.default) ? Z(c.default) ? a ? s : () => s : c.default : n ? a ? s : () => s : "", y = n || g !== "", E = dr(e, c);
  p && ti(c);
  let [u, h, T] = b ? [
    s,
    E,
    i[E] || {}
  ] : Ea(e, s, E, l, _, d), v = u, A = s;
  if (!b && !(k(v) || wt(v) || Me(v)) && y && (v = g, A = v), !b && (!(k(v) || wt(v) || Me(v)) || !k(h)))
    return o ? kn : s;
  if (process.env.NODE_ENV !== "production" && k(v) && e.messageCompiler == null)
    return _t(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${s}'.`), s;
  let N = !1;
  const S = () => {
    N = !0;
  }, w = Me(v) ? v : ya(e, s, h, v, A, S);
  if (N)
    return v;
  const D = ai(e, h, T, c), x = Pl(D), V = ni(e, w, x), G = r ? r(V, s) : V;
  if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const j = {
      timestamp: Date.now(),
      key: k(s) ? s : Me(v) ? v.key : "",
      locale: h || (Me(v) ? v.locale : ""),
      format: k(v) ? v : Me(v) ? v.source : "",
      message: G
    };
    j.meta = he({}, e.__meta, /* @__PURE__ */ Xl() || {}), Fl(j);
  }
  return G;
}
function ti(e) {
  de(e.list) ? e.list = e.list.map((t) => k(t) ? Wr(t) : t) : J(e.named) && Object.keys(e.named).forEach((t) => {
    k(e.named[t]) && (e.named[t] = Wr(e.named[t]));
  });
}
function Ea(e, t, n, r, o, a) {
  const { messages: l, onWarn: i, messageResolver: s, localeFallbacker: c } = e, d = c(e, r, n);
  let _ = {}, p, b = null, g = n, y = null;
  const E = "translate";
  for (let u = 0; u < d.length; u++) {
    if (p = y = d[u], process.env.NODE_ENV !== "production" && n !== p && Pn(o, t) && i(It(Ne.FALLBACK_TO_TRANSLATE, {
      key: t,
      target: p
    })), process.env.NODE_ENV !== "production" && n !== p) {
      const N = e.__v_emitter;
      N && N.emit("fallback", {
        type: E,
        key: t,
        from: g,
        to: y,
        groupId: `${E}:${t}`
      });
    }
    _ = l[p] || {};
    let h = null, T, v;
    if (process.env.NODE_ENV !== "production" && lt && (h = window.performance.now(), T = "intlify-message-resolve-start", v = "intlify-message-resolve-end", Se && Se(T)), (b = s(_, t)) === null && (b = _[t]), process.env.NODE_ENV !== "production" && lt) {
      const N = window.performance.now(), S = e.__v_emitter;
      S && h && b && S.emit("message-resolve", {
        type: "message-resolve",
        key: t,
        message: b,
        time: N - h,
        groupId: `${E}:${t}`
      }), T && v && Se && Lt && (Se(v), Lt("intlify message resolve", T, v));
    }
    if (k(b) || wt(b) || Me(b))
      break;
    const A = pr(
      e,
      // eslint-disable-line @typescript-eslint/no-explicit-any
      t,
      p,
      a,
      E
    );
    A !== t && (b = A), g = y;
  }
  return [b, p, _];
}
function ya(e, t, n, r, o, a) {
  const { messageCompiler: l, warnHtmlMessage: i } = e;
  if (Me(r)) {
    const p = r;
    return p.locale = p.locale || n, p.key = p.key || t, p;
  }
  if (l == null) {
    const p = () => r;
    return p.locale = n, p.key = t, p;
  }
  let s = null, c, d;
  process.env.NODE_ENV !== "production" && lt && (s = window.performance.now(), c = "intlify-message-compilation-start", d = "intlify-message-compilation-end", Se && Se(c));
  const _ = l(r, ri(e, n, o, r, i, a));
  if (process.env.NODE_ENV !== "production" && lt) {
    const p = window.performance.now(), b = e.__v_emitter;
    b && s && b.emit("message-compilation", {
      type: "message-compilation",
      message: r,
      time: p - s,
      groupId: `translate:${t}`
    }), c && d && Se && Lt && (Se(d), Lt("intlify message compilation", c, d));
  }
  return _.locale = n, _.key = t, _.source = r, _;
}
function ni(e, t, n) {
  let r = null, o, a;
  process.env.NODE_ENV !== "production" && lt && (r = window.performance.now(), o = "intlify-message-evaluation-start", a = "intlify-message-evaluation-end", Se && Se(o));
  const l = t(n);
  if (process.env.NODE_ENV !== "production" && lt) {
    const i = window.performance.now(), s = e.__v_emitter;
    s && r && s.emit("message-evaluation", {
      type: "message-evaluation",
      value: l,
      time: i - r,
      groupId: `translate:${t.key}`
    }), o && a && Se && Lt && (Se(a), Lt("intlify message evaluation", o, a));
  }
  return l;
}
function qn(...e) {
  const [t, n, r] = e, o = {};
  if (!k(t) && !ge(t) && !Me(t) && !wt(t))
    throw Qe(me.INVALID_ARGUMENT);
  const a = ge(t) ? String(t) : (Me(t), t);
  return ge(n) ? o.plural = n : k(n) ? o.default = n : Y(n) && !Rn(n) ? o.named = n : de(n) && (o.list = n), ge(r) ? o.plural = r : k(r) ? o.default = r : Y(r) && he(o, r), [a, o];
}
function ri(e, t, n, r, o, a) {
  return {
    locale: t,
    key: n,
    warnHtmlMessage: o,
    onError: (l) => {
      if (a && a(l), process.env.NODE_ENV !== "production") {
        const i = oi(r), s = `Message compilation error: ${l.message}`, c = l.location && i && xs(i, l.location.start.offset, l.location.end.offset), d = e.__v_emitter;
        d && i && d.emit("compile-error", {
          message: i,
          error: l.message,
          start: l.location && l.location.start.offset,
          end: l.location && l.location.end.offset,
          groupId: `translate:${n}`
        }), console.error(c ? `${s}
${c}` : s);
      } else
        throw l;
    },
    onCacheKey: (l) => Cs(t, n, l)
  };
}
function oi(e) {
  if (k(e))
    return e;
  if (e.loc && e.loc.source)
    return e.loc.source;
}
function ai(e, t, n, r) {
  const { modifiers: o, pluralRules: a, messageResolver: l, fallbackLocale: i, fallbackWarn: s, missingWarn: c, fallbackContext: d } = e, p = {
    locale: t,
    modifiers: o,
    pluralRules: a,
    messages: (b) => {
      let g = l(n, b);
      if (g == null && d) {
        const [, , y] = Ea(d, b, t, i, s, c);
        g = l(y, b);
      }
      if (k(g) || wt(g)) {
        let y = !1;
        const u = ya(e, b, t, g, b, () => {
          y = !0;
        });
        return y ? oo : u;
      } else
        return Me(g) ? g : oo;
    }
  };
  return e.processor && (p.processor = e.processor), r.list && (p.list = r.list), r.named && (p.named = r.named), ge(r.plural) && (p.pluralIndex = r.plural), p;
}
const so = typeof Intl < "u", Na = {
  dateTimeFormat: so && typeof Intl.DateTimeFormat < "u",
  numberFormat: so && typeof Intl.NumberFormat < "u"
};
function lo(e, ...t) {
  const { datetimeFormats: n, unresolving: r, fallbackLocale: o, onWarn: a, localeFallbacker: l } = e, { __datetimeFormatters: i } = e;
  if (process.env.NODE_ENV !== "production" && !Na.dateTimeFormat)
    return a(It(Ne.CANNOT_FORMAT_DATE)), Tn;
  const [s, c, d, _] = Jn(...t), p = Z(d.missingWarn) ? d.missingWarn : e.missingWarn, b = Z(d.fallbackWarn) ? d.fallbackWarn : e.fallbackWarn, g = !!d.part, y = dr(e, d), E = l(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    o,
    y
  );
  if (!k(s) || s === "")
    return new Intl.DateTimeFormat(y, _).format(c);
  let u = {}, h, T = null, v = y, A = null;
  const N = "datetime format";
  for (let D = 0; D < E.length; D++) {
    if (h = A = E[D], process.env.NODE_ENV !== "production" && y !== h && Pn(b, s) && a(It(Ne.FALLBACK_TO_DATE_FORMAT, {
      key: s,
      target: h
    })), process.env.NODE_ENV !== "production" && y !== h) {
      const x = e.__v_emitter;
      x && x.emit("fallback", {
        type: N,
        key: s,
        from: v,
        to: A,
        groupId: `${N}:${s}`
      });
    }
    if (u = n[h] || {}, T = u[s], Y(T))
      break;
    pr(e, s, h, p, N), v = A;
  }
  if (!Y(T) || !k(h))
    return r ? kn : s;
  let S = `${h}__${s}`;
  Rn(_) || (S = `${S}__${JSON.stringify(_)}`);
  let w = i.get(S);
  return w || (w = new Intl.DateTimeFormat(h, he({}, T, _)), i.set(S, w)), g ? w.formatToParts(c) : w.format(c);
}
const Oa = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function Jn(...e) {
  const [t, n, r, o] = e, a = {};
  let l = {}, i;
  if (k(t)) {
    const s = t.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!s)
      throw Qe(me.INVALID_ISO_DATE_ARGUMENT);
    const c = s[3] ? s[3].trim().startsWith("T") ? `${s[1].trim()}${s[3].trim()}` : `${s[1].trim()}T${s[3].trim()}` : s[1].trim();
    i = new Date(c);
    try {
      i.toISOString();
    } catch {
      throw Qe(me.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (ks(t)) {
    if (isNaN(t.getTime()))
      throw Qe(me.INVALID_DATE_ARGUMENT);
    i = t;
  } else if (ge(t))
    i = t;
  else
    throw Qe(me.INVALID_ARGUMENT);
  return k(n) ? a.key = n : Y(n) && Object.keys(n).forEach((s) => {
    Oa.includes(s) ? l[s] = n[s] : a[s] = n[s];
  }), k(r) ? a.locale = r : Y(r) && (l = r), Y(o) && (l = o), [a.key || "", i, a, l];
}
function io(e, t, n) {
  const r = e;
  for (const o in n) {
    const a = `${t}__${o}`;
    r.__datetimeFormatters.has(a) && r.__datetimeFormatters.delete(a);
  }
}
function co(e, ...t) {
  const { numberFormats: n, unresolving: r, fallbackLocale: o, onWarn: a, localeFallbacker: l } = e, { __numberFormatters: i } = e;
  if (process.env.NODE_ENV !== "production" && !Na.numberFormat)
    return a(It(Ne.CANNOT_FORMAT_NUMBER)), Tn;
  const [s, c, d, _] = Qn(...t), p = Z(d.missingWarn) ? d.missingWarn : e.missingWarn, b = Z(d.fallbackWarn) ? d.fallbackWarn : e.fallbackWarn, g = !!d.part, y = dr(e, d), E = l(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    o,
    y
  );
  if (!k(s) || s === "")
    return new Intl.NumberFormat(y, _).format(c);
  let u = {}, h, T = null, v = y, A = null;
  const N = "number format";
  for (let D = 0; D < E.length; D++) {
    if (h = A = E[D], process.env.NODE_ENV !== "production" && y !== h && Pn(b, s) && a(It(Ne.FALLBACK_TO_NUMBER_FORMAT, {
      key: s,
      target: h
    })), process.env.NODE_ENV !== "production" && y !== h) {
      const x = e.__v_emitter;
      x && x.emit("fallback", {
        type: N,
        key: s,
        from: v,
        to: A,
        groupId: `${N}:${s}`
      });
    }
    if (u = n[h] || {}, T = u[s], Y(T))
      break;
    pr(e, s, h, p, N), v = A;
  }
  if (!Y(T) || !k(h))
    return r ? kn : s;
  let S = `${h}__${s}`;
  Rn(_) || (S = `${S}__${JSON.stringify(_)}`);
  let w = i.get(S);
  return w || (w = new Intl.NumberFormat(h, he({}, T, _)), i.set(S, w)), g ? w.formatToParts(c) : w.format(c);
}
const Ta = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function Qn(...e) {
  const [t, n, r, o] = e, a = {};
  let l = {};
  if (!ge(t))
    throw Qe(me.INVALID_ARGUMENT);
  const i = t;
  return k(n) ? a.key = n : Y(n) && Object.keys(n).forEach((s) => {
    Ta.includes(s) ? l[s] = n[s] : a[s] = n[s];
  }), k(r) ? a.locale = r : Y(r) && (l = r), Y(o) && (l = o), [a.key || "", i, a, l];
}
function uo(e, t, n) {
  const r = e;
  for (const o in n) {
    const a = `${t}__${o}`;
    r.__numberFormatters.has(a) && r.__numberFormatters.delete(a);
  }
}
gl();
/*!
  * vue-i18n v9.9.0
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
const si = "9.9.0";
function li() {
  typeof __VUE_I18N_FULL_INSTALL__ != "boolean" && (st().__VUE_I18N_FULL_INSTALL__ = !0), typeof __VUE_I18N_LEGACY_API__ != "boolean" && (st().__VUE_I18N_LEGACY_API__ = !0), typeof __INTLIFY_JIT_COMPILATION__ != "boolean" && (st().__INTLIFY_JIT_COMPILATION__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (st().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1), typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (st().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const La = Ne.__EXTEND_POINT__, ft = ur(La), Pe = {
  FALLBACK_TO_ROOT: La,
  NOT_SUPPORTED_PRESERVE: ft(),
  NOT_SUPPORTED_FORMATTER: ft(),
  NOT_SUPPORTED_PRESERVE_DIRECTIVE: ft(),
  NOT_SUPPORTED_GET_CHOICE_INDEX: ft(),
  COMPONENT_NAME_LEGACY_COMPATIBLE: ft(),
  NOT_FOUND_PARENT_SCOPE: ft(),
  IGNORE_OBJ_FLATTEN: ft(),
  NOTICE_DROP_ALLOW_COMPOSITION: ft()
  // 17
}, ii = {
  [Pe.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [Pe.NOT_SUPPORTED_PRESERVE]: "Not supported 'preserve'.",
  [Pe.NOT_SUPPORTED_FORMATTER]: "Not supported 'formatter'.",
  [Pe.NOT_SUPPORTED_PRESERVE_DIRECTIVE]: "Not supported 'preserveDirectiveContent'.",
  [Pe.NOT_SUPPORTED_GET_CHOICE_INDEX]: "Not supported 'getChoiceIndex'.",
  [Pe.COMPONENT_NAME_LEGACY_COMPATIBLE]: "Component name legacy compatible: '{name}' -> 'i18n'",
  [Pe.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [Pe.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  [Pe.NOTICE_DROP_ALLOW_COMPOSITION]: "'allowComposition' option will be dropped in the next major version. For more information, please see 👉 https://tinyurl.com/2p97mcze"
};
function mr(e, ...t) {
  return cr(ii[e], ...t);
}
const Ia = me.__EXTEND_POINT__, Ie = ur(Ia), ae = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: Ia,
  // legacy module errors
  INVALID_ARGUMENT: Ie(),
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: Ie(),
  NOT_INSTALLED: Ie(),
  NOT_AVAILABLE_IN_LEGACY_MODE: Ie(),
  // directive module errors
  REQUIRED_VALUE: Ie(),
  INVALID_VALUE: Ie(),
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: Ie(),
  NOT_INSTALLED_WITH_PROVIDE: Ie(),
  // unexpected error
  UNEXPECTED_ERROR: Ie(),
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: Ie(),
  // bridge support vue 2.x only
  BRIDGE_SUPPORT_VUE_2_ONLY: Ie(),
  // need to define `i18n` option in `allowComposition: true` and `useScope: 'local' at `useI18n``
  MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION: Ie(),
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: Ie(),
  // for enhancement
  __EXTEND_POINT__: Ie()
  // 40
};
function pt(e, ...t) {
  return Ht(e, null, process.env.NODE_ENV !== "production" ? { messages: ci, args: t } : void 0);
}
const ci = {
  [ae.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [ae.INVALID_ARGUMENT]: "Invalid argument",
  [ae.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [ae.NOT_INSTALLED]: "Need to install with `app.use` function",
  [ae.UNEXPECTED_ERROR]: "Unexpected error",
  [ae.NOT_AVAILABLE_IN_LEGACY_MODE]: "Not available in legacy mode",
  [ae.REQUIRED_VALUE]: "Required in value: {0}",
  [ae.INVALID_VALUE]: "Invalid value",
  [ae.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [ae.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [ae.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [ae.BRIDGE_SUPPORT_VUE_2_ONLY]: "vue-i18n-bridge support Vue 2.x only",
  [ae.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION]: "Must define ‘i18n’ option or custom block in Composition API with using local scope in Legacy API mode",
  [ae.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, Zn = /* @__PURE__ */ ct("__translateVNode"), zn = /* @__PURE__ */ ct("__datetimeParts"), er = /* @__PURE__ */ ct("__numberParts"), tr = /* @__PURE__ */ ct("__enableEmitter"), nr = /* @__PURE__ */ ct("__disableEmitter"), ui = ct("__setPluralRules"), wa = /* @__PURE__ */ ct("__injectWithOption"), rr = /* @__PURE__ */ ct("__dispose");
function nn(e) {
  if (!J(e))
    return e;
  for (const t in e)
    if (On(e, t))
      if (!t.includes("."))
        J(e[t]) && nn(e[t]);
      else {
        const n = t.split("."), r = n.length - 1;
        let o = e, a = !1;
        for (let l = 0; l < r; l++) {
          if (n[l] in o || (o[n[l]] = {}), !J(o[n[l]])) {
            process.env.NODE_ENV !== "production" && _t(mr(Pe.IGNORE_OBJ_FLATTEN, {
              key: n[l]
            })), a = !0;
            break;
          }
          o = o[n[l]];
        }
        a || (o[n[r]] = e[t], delete e[t]), J(o[n[r]]) && nn(o[n[r]]);
      }
  return e;
}
function _r(e, t) {
  const { messages: n, __i18n: r, messageResolver: o, flatJson: a } = t, l = Y(n) ? n : de(r) ? {} : { [e]: {} };
  if (de(r) && r.forEach((i) => {
    if ("locale" in i && "resource" in i) {
      const { locale: s, resource: c } = i;
      s ? (l[s] = l[s] || {}, En(c, l[s])) : En(c, l);
    } else
      k(i) && En(JSON.parse(i), l);
  }), o == null && a)
    for (const i in l)
      On(l, i) && nn(l[i]);
  return l;
}
function Aa(e) {
  return e.type;
}
function fi(e, t, n) {
  let r = J(t.messages) ? t.messages : {};
  "__i18nGlobal" in n && (r = _r(e.locale.value, {
    messages: r,
    __i18n: n.__i18nGlobal
  }));
  const o = Object.keys(r);
  o.length && o.forEach((a) => {
    e.mergeLocaleMessage(a, r[a]);
  });
  {
    if (J(t.datetimeFormats)) {
      const a = Object.keys(t.datetimeFormats);
      a.length && a.forEach((l) => {
        e.mergeDateTimeFormat(l, t.datetimeFormats[l]);
      });
    }
    if (J(t.numberFormats)) {
      const a = Object.keys(t.numberFormats);
      a.length && a.forEach((l) => {
        e.mergeNumberFormat(l, t.numberFormats[l]);
      });
    }
  }
}
function fo(e) {
  return We(ta, null, e, 0);
}
const po = "__INTLIFY_META__", mo = () => [], di = () => !1;
let _o = 0;
function vo(e) {
  return (t, n, r, o) => e(n, r, sn() || void 0, o);
}
const pi = /* @__NO_SIDE_EFFECTS__ */ () => {
  const e = sn();
  let t = null;
  return e && (t = Aa(e)[po]) ? { [po]: t } : null;
};
function mi(e = {}, t) {
  const { __root: n, __injectWithOption: r } = e, o = n === void 0, a = e.flatJson, l = lt ? B : ir;
  let i = Z(e.inheritLocale) ? e.inheritLocale : !0;
  const s = l(
    // prettier-ignore
    n && i ? n.locale.value : k(e.locale) ? e.locale : tn
  ), c = l(
    // prettier-ignore
    n && i ? n.fallbackLocale.value : k(e.fallbackLocale) || de(e.fallbackLocale) || Y(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : s.value
  ), d = l(_r(s.value, e)), _ = l(Y(e.datetimeFormats) ? e.datetimeFormats : { [s.value]: {} }), p = l(Y(e.numberFormats) ? e.numberFormats : { [s.value]: {} });
  let b = n ? n.missingWarn : Z(e.missingWarn) || Ft(e.missingWarn) ? e.missingWarn : !0, g = n ? n.fallbackWarn : Z(e.fallbackWarn) || Ft(e.fallbackWarn) ? e.fallbackWarn : !0, y = n ? n.fallbackRoot : Z(e.fallbackRoot) ? e.fallbackRoot : !0, E = !!e.fallbackFormat, u = ee(e.missing) ? e.missing : null, h = ee(e.missing) ? vo(e.missing) : null, T = ee(e.postTranslation) ? e.postTranslation : null, v = n ? n.warnHtmlMessage : Z(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, A = !!e.escapeParameter;
  const N = n ? n.modifiers : Y(e.modifiers) ? e.modifiers : {};
  let S = e.pluralRules || n && n.pluralRules, w;
  w = (() => {
    o && to(null);
    const I = {
      version: si,
      locale: s.value,
      fallbackLocale: c.value,
      messages: d.value,
      modifiers: N,
      pluralRules: S,
      missing: h === null ? void 0 : h,
      missingWarn: b,
      fallbackWarn: g,
      fallbackFormat: E,
      unresolving: !0,
      postTranslation: T === null ? void 0 : T,
      warnHtmlMessage: v,
      escapeParameter: A,
      messageResolver: e.messageResolver,
      messageCompiler: e.messageCompiler,
      __meta: { framework: "vue" }
    };
    I.datetimeFormats = _.value, I.numberFormats = p.value, I.__datetimeFormatters = Y(w) ? w.__datetimeFormatters : void 0, I.__numberFormatters = Y(w) ? w.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (I.__v_emitter = Y(w) ? w.__v_emitter : void 0);
    const C = Jl(I);
    return o && to(C), C;
  })(), Kt(w, s.value, c.value);
  function x() {
    return [
      s.value,
      c.value,
      d.value,
      _.value,
      p.value
    ];
  }
  const V = P({
    get: () => s.value,
    set: (I) => {
      s.value = I, w.locale = s.value;
    }
  }), G = P({
    get: () => c.value,
    set: (I) => {
      c.value = I, w.fallbackLocale = c.value, Kt(w, s.value, I);
    }
  }), j = P(() => d.value), le = /* @__PURE__ */ P(() => _.value), se = /* @__PURE__ */ P(() => p.value);
  function q() {
    return ee(T) ? T : null;
  }
  function M(I) {
    T = I, w.postTranslation = I;
  }
  function ce() {
    return u;
  }
  function _e(I) {
    I !== null && (h = vo(I)), u = I, w.missing = h;
  }
  function Ye(I, C) {
    return I !== "translate" || !C.resolvedMessage;
  }
  const be = (I, C, K, ie, bt, pn) => {
    x();
    let St;
    try {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, o || (w.fallbackContext = n ? ql() : void 0), St = I(w);
    } finally {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, o || (w.fallbackContext = void 0);
    }
    if (K !== "translate exists" && // for not `te` (e.g `t`)
    ge(St) && St === kn || K === "translate exists" && !St) {
      const [Et, ss] = C();
      if (process.env.NODE_ENV !== "production" && n && k(Et) && Ye(K, ss) && (y && (Pn(g, Et) || va(b, Et)) && _t(mr(Pe.FALLBACK_TO_ROOT, {
        key: Et,
        type: K
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: $r } = w;
        $r && y && $r.emit("fallback", {
          type: K,
          key: Et,
          to: "global",
          groupId: `${K}:${Et}`
        });
      }
      return n && y ? ie(n) : bt(Et);
    } else {
      if (pn(St))
        return St;
      throw pt(ae.UNEXPECTED_RETURN_TYPE);
    }
  };
  function Re(...I) {
    return be((C) => Reflect.apply(ao, null, [C, ...I]), () => qn(...I), "translate", (C) => Reflect.apply(C.t, C, [...I]), (C) => C, (C) => k(C));
  }
  function Ge(...I) {
    const [C, K, ie] = I;
    if (ie && !J(ie))
      throw pt(ae.INVALID_ARGUMENT);
    return Re(C, K, he({ resolvedMessage: !0 }, ie || {}));
  }
  function Te(...I) {
    return be((C) => Reflect.apply(lo, null, [C, ...I]), () => Jn(...I), "datetime format", (C) => Reflect.apply(C.d, C, [...I]), () => Tn, (C) => k(C));
  }
  function Ee(...I) {
    return be((C) => Reflect.apply(co, null, [C, ...I]), () => Qn(...I), "number format", (C) => Reflect.apply(C.n, C, [...I]), () => Tn, (C) => k(C));
  }
  function Ke(I) {
    return I.map((C) => k(C) || ge(C) || Z(C) ? fo(String(C)) : C);
  }
  const Le = {
    normalize: Ke,
    interpolate: (I) => I,
    type: "vnode"
  };
  function rt(...I) {
    return be(
      (C) => {
        let K;
        const ie = C;
        try {
          ie.processor = Le, K = Reflect.apply(ao, null, [ie, ...I]);
        } finally {
          ie.processor = null;
        }
        return K;
      },
      () => qn(...I),
      "translate",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (C) => C[Zn](...I),
      (C) => [fo(C)],
      (C) => de(C)
    );
  }
  function qe(...I) {
    return be(
      (C) => Reflect.apply(co, null, [C, ...I]),
      () => Qn(...I),
      "number format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (C) => C[er](...I),
      mo,
      (C) => k(C) || de(C)
    );
  }
  function Be(...I) {
    return be(
      (C) => Reflect.apply(lo, null, [C, ...I]),
      () => Jn(...I),
      "datetime format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (C) => C[zn](...I),
      mo,
      (C) => k(C) || de(C)
    );
  }
  function ht(I) {
    S = I, w.pluralRules = S;
  }
  function m(I, C) {
    return be(() => {
      if (!I)
        return !1;
      const K = k(C) ? C : s.value, ie = R(K), bt = w.messageResolver(ie, I);
      return wt(bt) || Me(bt) || k(bt);
    }, () => [I], "translate exists", (K) => Reflect.apply(K.te, K, [I, C]), di, (K) => Z(K));
  }
  function f(I) {
    let C = null;
    const K = ua(w, c.value, s.value);
    for (let ie = 0; ie < K.length; ie++) {
      const bt = d.value[K[ie]] || {}, pn = w.messageResolver(bt, I);
      if (pn != null) {
        C = pn;
        break;
      }
    }
    return C;
  }
  function O(I) {
    const C = f(I);
    return C ?? (n ? n.tm(I) || {} : {});
  }
  function R(I) {
    return d.value[I] || {};
  }
  function $(I, C) {
    if (a) {
      const K = { [I]: C };
      for (const ie in K)
        On(K, ie) && nn(K[ie]);
      C = K[I];
    }
    d.value[I] = C, w.messages = d.value;
  }
  function X(I, C) {
    d.value[I] = d.value[I] || {};
    const K = { [I]: C };
    for (const ie in K)
      On(K, ie) && nn(K[ie]);
    C = K[I], En(C, d.value[I]), w.messages = d.value;
  }
  function ke(I) {
    return _.value[I] || {};
  }
  function ve(I, C) {
    _.value[I] = C, w.datetimeFormats = _.value, io(w, I, C);
  }
  function At(I, C) {
    _.value[I] = he(_.value[I] || {}, C), w.datetimeFormats = _.value, io(w, I, C);
  }
  function fn(I) {
    return p.value[I] || {};
  }
  function dn(I, C) {
    p.value[I] = C, w.numberFormats = p.value, uo(w, I, C);
  }
  function Gt(I, C) {
    p.value[I] = he(p.value[I] || {}, C), w.numberFormats = p.value, uo(w, I, C);
  }
  _o++, n && lt && (ne(n.locale, (I) => {
    i && (s.value = I, w.locale = I, Kt(w, s.value, c.value));
  }), ne(n.fallbackLocale, (I) => {
    i && (c.value = I, w.fallbackLocale = I, Kt(w, s.value, c.value));
  }));
  const oe = {
    id: _o,
    locale: V,
    fallbackLocale: G,
    get inheritLocale() {
      return i;
    },
    set inheritLocale(I) {
      i = I, I && n && (s.value = n.locale.value, c.value = n.fallbackLocale.value, Kt(w, s.value, c.value));
    },
    get availableLocales() {
      return Object.keys(d.value).sort();
    },
    messages: j,
    get modifiers() {
      return N;
    },
    get pluralRules() {
      return S || {};
    },
    get isGlobal() {
      return o;
    },
    get missingWarn() {
      return b;
    },
    set missingWarn(I) {
      b = I, w.missingWarn = b;
    },
    get fallbackWarn() {
      return g;
    },
    set fallbackWarn(I) {
      g = I, w.fallbackWarn = g;
    },
    get fallbackRoot() {
      return y;
    },
    set fallbackRoot(I) {
      y = I;
    },
    get fallbackFormat() {
      return E;
    },
    set fallbackFormat(I) {
      E = I, w.fallbackFormat = E;
    },
    get warnHtmlMessage() {
      return v;
    },
    set warnHtmlMessage(I) {
      v = I, w.warnHtmlMessage = I;
    },
    get escapeParameter() {
      return A;
    },
    set escapeParameter(I) {
      A = I, w.escapeParameter = I;
    },
    t: Re,
    getLocaleMessage: R,
    setLocaleMessage: $,
    mergeLocaleMessage: X,
    getPostTranslationHandler: q,
    setPostTranslationHandler: M,
    getMissingHandler: ce,
    setMissingHandler: _e,
    [ui]: ht
  };
  return oe.datetimeFormats = le, oe.numberFormats = se, oe.rt = Ge, oe.te = m, oe.tm = O, oe.d = Te, oe.n = Ee, oe.getDateTimeFormat = ke, oe.setDateTimeFormat = ve, oe.mergeDateTimeFormat = At, oe.getNumberFormat = fn, oe.setNumberFormat = dn, oe.mergeNumberFormat = Gt, oe[wa] = r, oe[Zn] = rt, oe[zn] = Be, oe[er] = qe, process.env.NODE_ENV !== "production" && (oe[tr] = (I) => {
    w.__v_emitter = I;
  }, oe[nr] = () => {
    w.__v_emitter = void 0;
  }), oe;
}
const vr = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (e) => e === "parent" || e === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function _i({ slots: e }, t) {
  return t.length === 1 && t[0] === "default" ? (e.default ? e.default() : []).reduce((r, o) => [
    ...r,
    // prettier-ignore
    ...o.type === Mt ? o.children : [o]
  ], []) : t.reduce((n, r) => {
    const o = e[r];
    return o && (n[r] = o()), n;
  }, {});
}
function Sa(e) {
  return Mt;
}
he({
  keypath: {
    type: String,
    required: !0
  },
  plural: {
    type: [Number, String],
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    validator: (e) => ge(e) || !isNaN(e)
  }
}, vr);
function vi(e) {
  return de(e) && !k(e[0]);
}
function Ca(e, t, n, r) {
  const { slots: o, attrs: a } = t;
  return () => {
    const l = { part: !0 };
    let i = {};
    e.locale && (l.locale = e.locale), k(e.format) ? l.key = e.format : J(e.format) && (k(e.format.key) && (l.key = e.format.key), i = Object.keys(e.format).reduce((p, b) => n.includes(b) ? he({}, p, { [b]: e.format[b] }) : p, {}));
    const s = r(e.value, l, i);
    let c = [l.key];
    de(s) ? c = s.map((p, b) => {
      const g = o[p.type], y = g ? g({ [p.type]: p.value, index: b, parts: s }) : [p.value];
      return vi(y) && (y[0].key = `${p.type}-${b}`), y;
    }) : k(s) && (c = [s]);
    const d = he({}, a), _ = k(e.tag) || J(e.tag) ? e.tag : Sa();
    return zo(_, d, c);
  };
}
he({
  value: {
    type: Number,
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, vr);
he({
  value: {
    type: [Number, Date],
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, vr);
function go(e, t) {
}
const gi = /* @__PURE__ */ ct("global-vue-i18n");
function jt(e = {}) {
  const t = sn();
  if (t == null)
    throw pt(ae.MUST_BE_CALL_SETUP_TOP);
  if (!t.isCE && t.appContext.app != null && !t.appContext.app.__VUE_I18N_SYMBOL__)
    throw pt(ae.NOT_INSTALLED);
  const n = hi(t), r = Ei(n), o = Aa(t), a = bi(e, o);
  if (__VUE_I18N_LEGACY_API__ && n.mode === "legacy" && !e.__useComponent) {
    if (!n.allowComposition)
      throw pt(ae.NOT_AVAILABLE_IN_LEGACY_MODE);
    return Ti(t, a, r, e);
  }
  if (a === "global")
    return fi(r, e, o), r;
  if (a === "parent") {
    let s = yi(n, t, e.__useComponent);
    return s == null && (process.env.NODE_ENV !== "production" && _t(mr(Pe.NOT_FOUND_PARENT_SCOPE)), s = r), s;
  }
  const l = n;
  let i = l.__getInstance(t);
  if (i == null) {
    const s = he({}, e);
    "__i18n" in o && (s.__i18n = o.__i18n), r && (s.__root = r), i = mi(s), l.__composerExtend && (i[rr] = l.__composerExtend(i)), Oi(l, t, i), l.__setInstance(t, i);
  }
  return i;
}
function hi(e) {
  {
    const t = Ve(e.isCE ? gi : e.appContext.app.__VUE_I18N_SYMBOL__);
    if (!t)
      throw pt(e.isCE ? ae.NOT_INSTALLED_WITH_PROVIDE : ae.UNEXPECTED_ERROR);
    return t;
  }
}
function bi(e, t) {
  return Rn(e) ? "__i18n" in t ? "local" : "global" : e.useScope ? e.useScope : "local";
}
function Ei(e) {
  return e.mode === "composition" ? e.global : e.global.__composer;
}
function yi(e, t, n = !1) {
  let r = null;
  const o = t.root;
  let a = Ni(t, n);
  for (; a != null; ) {
    const l = e;
    if (e.mode === "composition")
      r = l.__getInstance(a);
    else if (__VUE_I18N_LEGACY_API__) {
      const i = l.__getInstance(a);
      i != null && (r = i.__composer, n && r && !r[wa] && (r = null));
    }
    if (r != null || o === a)
      break;
    a = a.parent;
  }
  return r;
}
function Ni(e, t = !1) {
  return e == null ? null : t && e.vnode.ctx || e.parent;
}
function Oi(e, t, n) {
  let r = null;
  tt(() => {
    if (process.env.NODE_ENV !== "production" && t.vnode.el) {
      t.vnode.el.__VUE_I18N__ = n, r = Us();
      const o = n;
      o[tr] && o[tr](r), r.on("*", go);
    }
  }, t), cs(() => {
    const o = n;
    process.env.NODE_ENV !== "production" && t.vnode.el && t.vnode.el.__VUE_I18N__ && (r && r.off("*", go), o[nr] && o[nr](), delete t.vnode.el.__VUE_I18N__), e.__deleteInstance(t);
    const a = o[rr];
    a && (a(), delete o[rr]);
  }, t);
}
function Ti(e, t, n, r = {}) {
  const o = t === "local", a = ir(null);
  if (o && e.proxy && !(e.proxy.$options.i18n || e.proxy.$options.__i18n))
    throw pt(ae.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION);
  const l = Z(r.inheritLocale) ? r.inheritLocale : !k(r.locale), i = B(
    // prettier-ignore
    !o || l ? n.locale.value : k(r.locale) ? r.locale : tn
  ), s = B(
    // prettier-ignore
    !o || l ? n.fallbackLocale.value : k(r.fallbackLocale) || de(r.fallbackLocale) || Y(r.fallbackLocale) || r.fallbackLocale === !1 ? r.fallbackLocale : i.value
  ), c = B(_r(i.value, r)), d = B(Y(r.datetimeFormats) ? r.datetimeFormats : { [i.value]: {} }), _ = B(Y(r.numberFormats) ? r.numberFormats : { [i.value]: {} }), p = o ? n.missingWarn : Z(r.missingWarn) || Ft(r.missingWarn) ? r.missingWarn : !0, b = o ? n.fallbackWarn : Z(r.fallbackWarn) || Ft(r.fallbackWarn) ? r.fallbackWarn : !0, g = o ? n.fallbackRoot : Z(r.fallbackRoot) ? r.fallbackRoot : !0, y = !!r.fallbackFormat, E = ee(r.missing) ? r.missing : null, u = ee(r.postTranslation) ? r.postTranslation : null, h = o ? n.warnHtmlMessage : Z(r.warnHtmlMessage) ? r.warnHtmlMessage : !0, T = !!r.escapeParameter, v = o ? n.modifiers : Y(r.modifiers) ? r.modifiers : {}, A = r.pluralRules || o && n.pluralRules;
  function N() {
    return [
      i.value,
      s.value,
      c.value,
      d.value,
      _.value
    ];
  }
  const S = P({
    get: () => a.value ? a.value.locale.value : i.value,
    set: (f) => {
      a.value && (a.value.locale.value = f), i.value = f;
    }
  }), w = P({
    get: () => a.value ? a.value.fallbackLocale.value : s.value,
    set: (f) => {
      a.value && (a.value.fallbackLocale.value = f), s.value = f;
    }
  }), D = P(() => a.value ? a.value.messages.value : c.value), x = P(() => d.value), V = P(() => _.value);
  function G() {
    return a.value ? a.value.getPostTranslationHandler() : u;
  }
  function j(f) {
    a.value && a.value.setPostTranslationHandler(f);
  }
  function le() {
    return a.value ? a.value.getMissingHandler() : E;
  }
  function se(f) {
    a.value && a.value.setMissingHandler(f);
  }
  function q(f) {
    return N(), f();
  }
  function M(...f) {
    return a.value ? q(() => Reflect.apply(a.value.t, null, [...f])) : q(() => "");
  }
  function ce(...f) {
    return a.value ? Reflect.apply(a.value.rt, null, [...f]) : "";
  }
  function _e(...f) {
    return a.value ? q(() => Reflect.apply(a.value.d, null, [...f])) : q(() => "");
  }
  function Ye(...f) {
    return a.value ? q(() => Reflect.apply(a.value.n, null, [...f])) : q(() => "");
  }
  function be(f) {
    return a.value ? a.value.tm(f) : {};
  }
  function Re(f, O) {
    return a.value ? a.value.te(f, O) : !1;
  }
  function Ge(f) {
    return a.value ? a.value.getLocaleMessage(f) : {};
  }
  function Te(f, O) {
    a.value && (a.value.setLocaleMessage(f, O), c.value[f] = O);
  }
  function Ee(f, O) {
    a.value && a.value.mergeLocaleMessage(f, O);
  }
  function Ke(f) {
    return a.value ? a.value.getDateTimeFormat(f) : {};
  }
  function Xe(f, O) {
    a.value && (a.value.setDateTimeFormat(f, O), d.value[f] = O);
  }
  function Le(f, O) {
    a.value && a.value.mergeDateTimeFormat(f, O);
  }
  function rt(f) {
    return a.value ? a.value.getNumberFormat(f) : {};
  }
  function qe(f, O) {
    a.value && (a.value.setNumberFormat(f, O), _.value[f] = O);
  }
  function Be(f, O) {
    a.value && a.value.mergeNumberFormat(f, O);
  }
  const ht = {
    get id() {
      return a.value ? a.value.id : -1;
    },
    locale: S,
    fallbackLocale: w,
    messages: D,
    datetimeFormats: x,
    numberFormats: V,
    get inheritLocale() {
      return a.value ? a.value.inheritLocale : l;
    },
    set inheritLocale(f) {
      a.value && (a.value.inheritLocale = f);
    },
    get availableLocales() {
      return a.value ? a.value.availableLocales : Object.keys(c.value);
    },
    get modifiers() {
      return a.value ? a.value.modifiers : v;
    },
    get pluralRules() {
      return a.value ? a.value.pluralRules : A;
    },
    get isGlobal() {
      return a.value ? a.value.isGlobal : !1;
    },
    get missingWarn() {
      return a.value ? a.value.missingWarn : p;
    },
    set missingWarn(f) {
      a.value && (a.value.missingWarn = f);
    },
    get fallbackWarn() {
      return a.value ? a.value.fallbackWarn : b;
    },
    set fallbackWarn(f) {
      a.value && (a.value.missingWarn = f);
    },
    get fallbackRoot() {
      return a.value ? a.value.fallbackRoot : g;
    },
    set fallbackRoot(f) {
      a.value && (a.value.fallbackRoot = f);
    },
    get fallbackFormat() {
      return a.value ? a.value.fallbackFormat : y;
    },
    set fallbackFormat(f) {
      a.value && (a.value.fallbackFormat = f);
    },
    get warnHtmlMessage() {
      return a.value ? a.value.warnHtmlMessage : h;
    },
    set warnHtmlMessage(f) {
      a.value && (a.value.warnHtmlMessage = f);
    },
    get escapeParameter() {
      return a.value ? a.value.escapeParameter : T;
    },
    set escapeParameter(f) {
      a.value && (a.value.escapeParameter = f);
    },
    t: M,
    getPostTranslationHandler: G,
    setPostTranslationHandler: j,
    getMissingHandler: le,
    setMissingHandler: se,
    rt: ce,
    d: _e,
    n: Ye,
    tm: be,
    te: Re,
    getLocaleMessage: Ge,
    setLocaleMessage: Te,
    mergeLocaleMessage: Ee,
    getDateTimeFormat: Ke,
    setDateTimeFormat: Xe,
    mergeDateTimeFormat: Le,
    getNumberFormat: rt,
    setNumberFormat: qe,
    mergeNumberFormat: Be
  };
  function m(f) {
    f.locale.value = i.value, f.fallbackLocale.value = s.value, Object.keys(c.value).forEach((O) => {
      f.mergeLocaleMessage(O, c.value[O]);
    }), Object.keys(d.value).forEach((O) => {
      f.mergeDateTimeFormat(O, d.value[O]);
    }), Object.keys(_.value).forEach((O) => {
      f.mergeNumberFormat(O, _.value[O]);
    }), f.escapeParameter = T, f.fallbackFormat = y, f.fallbackRoot = g, f.fallbackWarn = b, f.missingWarn = p, f.warnHtmlMessage = h;
  }
  return ea(() => {
    if (e.proxy == null || e.proxy.$i18n == null)
      throw pt(ae.NOT_AVAILABLE_COMPOSITION_IN_LEGACY);
    const f = a.value = e.proxy.$i18n.__composer;
    t === "global" ? (i.value = f.locale.value, s.value = f.fallbackLocale.value, c.value = f.messages.value, d.value = f.datetimeFormats.value, _.value = f.numberFormats.value) : o && m(f);
  }), ht;
}
li();
__INTLIFY_JIT_COMPILATION__ ? eo(ei) : eo(zl);
Yl(Ll);
Gl(ua);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const e = st();
  e.__INTLIFY__ = !0, Dl(e.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
const Li = [
  "Января",
  "Февраля",
  "Марта",
  "Апреля",
  "Мая",
  "Июня",
  "Июля",
  "Августа",
  "Сентября",
  "Октября",
  "Ноября",
  "Декабря"
], Ii = {
  month: Li
}, wi = [
  "Қаңтар",
  "Ақпан",
  "Наурыз",
  "Сәуір",
  "Мамыр",
  "Маусым",
  "Шілде",
  "Тамыз",
  "Қыркүйек",
  "Қазан",
  "Қараша",
  "Желтоқсан"
], Ai = {
  month: wi
}, Si = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
], Ci = {
  month: Si
}, Ri = [
  "Stycznia",
  "Lutego",
  "Marca",
  "Kwietnia",
  "Maja",
  "Czerwca",
  "Lipca",
  "Sierpnia",
  "Września",
  "Października",
  "Listopada",
  "Grudnia"
], ki = {
  month: Ri
}, Pi = [
  "Yanvar",
  "Fevral",
  "Mart",
  "Aprel",
  "May",
  "Iyun",
  "Iyul",
  "Avgust",
  "Sentabr",
  "Oktabr",
  "Noyabr",
  "Dekabr"
], Di = {
  month: Pi
}, Mi = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre"
], Fi = {
  month: Mi
}, xi = {
  ru: Ii,
  kk: Ai,
  en: Ci,
  pl: ki,
  uz: Di,
  es: Fi
};
class $i {
  constructor(t, n) {
    ue(this, "dd");
    ue(this, "month");
    ue(this, "yyyy");
    ue(this, "hh");
    ue(this, "mm");
    this.dd = this.formatDD(n), this.month = this.formatMonth(n, t), this.yyyy = this.formatYYYY(n), this.hh = this.formatHH(n), this.mm = this.formatMM(n);
  }
  toFormatTT(t) {
    return String(t).length === 1 ? `0${t}` : `${t}`;
  }
  formatDD(t) {
    return this.toFormatTT(new Date(t).getDate());
  }
  formatMonth(t, n) {
    const a = `month[${new Date(t).getMonth()}]`;
    return n(a).slice(0, 3);
  }
  formatYYYY(t) {
    const n = new Date(t).getFullYear();
    return String(n);
  }
  formatHH(t) {
    return this.toFormatTT(new Date(t).getHours());
  }
  formatMM(t) {
    return this.toFormatTT(new Date(t).getMinutes());
  }
}
const Ui = {
  key: 0,
  class: "ap-datetime"
}, Vi = { class: "date" }, Bi = { class: "time" }, Wi = { key: 1 }, Hi = /* @__PURE__ */ H({
  __name: "DateTime",
  props: {
    value: String
  },
  setup(e) {
    const { t } = jt({ messages: xi }), n = e, r = P(() => n.value ? new $i(t, n.value) : null);
    return (o, a) => {
      var l, i, s, c, d;
      return e.value ? (F(), W("div", Ui, [
        fe("span", Vi, z((l = r.value) == null ? void 0 : l.dd) + " " + z((i = r.value) == null ? void 0 : i.month) + " " + z((s = r.value) == null ? void 0 : s.yyyy), 1),
        fe("span", Bi, z((c = r.value) == null ? void 0 : c.hh) + ":" + z((d = r.value) == null ? void 0 : d.mm), 1)
      ])) : (F(), W("div", Wi, "—"));
    };
  }
});
const ji = "д.", Yi = "ч.", Gi = "мин.", Ki = "сек.", Xi = {
  days: ji,
  hours: Yi,
  minutes: Gi,
  seconds: Ki
}, qi = "к.", Ji = "сағ.", Qi = "мин.", Zi = "сек.", zi = {
  days: qi,
  hours: Ji,
  minutes: Qi,
  seconds: Zi
}, ec = "d.", tc = "h.", nc = "min.", rc = "sec.", oc = {
  days: ec,
  hours: tc,
  minutes: nc,
  seconds: rc
}, ac = "d.", sc = "h.", lc = "min.", ic = "sek.", cc = {
  days: ac,
  hours: sc,
  minutes: lc,
  seconds: ic
}, uc = "k.", fc = "s.", dc = "daq.", pc = "son.", mc = {
  days: uc,
  hours: fc,
  minutes: dc,
  seconds: pc
}, _c = "d", vc = "h", gc = "m", hc = "s", bc = {
  days: _c,
  hours: vc,
  minutes: gc,
  seconds: hc
}, Ec = {
  ru: Xi,
  kk: zi,
  en: oc,
  pl: cc,
  uz: mc,
  es: bc
};
class gr {
  constructor(t) {
    ue(this, "msInSec");
    ue(this, "secInMin");
    ue(this, "minInHour");
    ue(this, "hourInDay");
    ue(this, "currentDate");
    ue(this, "endDate");
    this.msInSec = 1e3, this.secInMin = 60, this.minInHour = 60, this.hourInDay = 24, this.currentDate = /* @__PURE__ */ new Date(), this.endDate = new Date(t);
  }
  getLeftTimeInMs() {
    const t = Number(this.endDate) - Number(this.currentDate);
    return t > 0 ? t : 0;
  }
}
class yc extends gr {
  constructor(n, r) {
    super(n);
    ue(this, "paramName");
    ue(this, "value");
    this.paramName = r("days"), this.value = Math.floor(this.getLeftTimeInMs() / this.msInSec / this.secInMin / this.minInHour / this.hourInDay);
  }
}
class Nc extends gr {
  constructor(n, r) {
    super(n);
    ue(this, "paramName");
    ue(this, "value");
    this.paramName = r("hours"), this.value = Math.floor(this.getLeftTimeInMs() / this.msInSec / this.secInMin / this.minInHour) % this.hourInDay;
  }
}
class Oc extends gr {
  constructor(n, r) {
    super(n);
    ue(this, "paramName");
    ue(this, "value");
    this.paramName = r("minutes"), this.value = Math.floor(this.getLeftTimeInMs() / this.msInSec / this.secInMin) % this.minInHour;
  }
}
const Tc = { key: 0 }, Lc = { key: 1 }, Ic = /* @__PURE__ */ H({
  __name: "LeftTime",
  props: {
    value: {}
  },
  setup(e) {
    const t = e, { t: n } = jt({ messages: Ec }), r = P(() => [
      new yc(t.value, n),
      new Nc(t.value, n),
      new Oc(t.value, n)
    ].reduce((o, a) => a.value ? o ? o + " " + a.value + a.paramName : a.value + a.paramName : o, ""));
    return (o, a) => o.value ? (F(), W("span", Tc, z(r.value), 1)) : (F(), W("div", Lc, "—"));
  }
}), at = (e, t, { checkForDefaultPrevented: n = !0 } = {}) => (r) => {
  const o = e == null ? void 0 : e(r);
  if (n === !1 || !o)
    return t == null ? void 0 : t(r);
};
var ho;
const Ze = typeof window < "u", wc = (e) => typeof e == "string", Ra = () => {
}, Ac = Ze && ((ho = window == null ? void 0 : window.navigator) == null ? void 0 : ho.userAgent) && /iP(ad|hone|od)/.test(window.navigator.userAgent);
function ka(e) {
  return typeof e == "function" ? e() : L(e);
}
function Sc(e) {
  return e;
}
function Pa(e) {
  return ra() ? (oa(e), !0) : !1;
}
function Ot(e) {
  var t;
  const n = ka(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
const Da = Ze ? window : void 0;
function Vn(...e) {
  let t, n, r, o;
  if (wc(e[0]) || Array.isArray(e[0]) ? ([n, r, o] = e, t = Da) : [t, n, r, o] = e, !t)
    return Ra;
  Array.isArray(n) || (n = [n]), Array.isArray(r) || (r = [r]);
  const a = [], l = () => {
    a.forEach((d) => d()), a.length = 0;
  }, i = (d, _, p, b) => (d.addEventListener(_, p, b), () => d.removeEventListener(_, p, b)), s = ne(() => [Ot(t), ka(o)], ([d, _]) => {
    l(), d && a.push(...n.flatMap((p) => r.map((b) => i(d, p, b, _))));
  }, { immediate: !0, flush: "post" }), c = () => {
    s(), l();
  };
  return Pa(c), c;
}
let bo = !1;
function Cc(e, t, n = {}) {
  const { window: r = Da, ignore: o = [], capture: a = !0, detectIframe: l = !1 } = n;
  if (!r)
    return;
  Ac && !bo && (bo = !0, Array.from(r.document.body.children).forEach((d) => d.addEventListener("click", Ra)));
  let i = !0;
  const s = (d) => o.some((_) => {
    if (typeof _ == "string")
      return Array.from(r.document.querySelectorAll(_)).some((p) => p === d.target || d.composedPath().includes(p));
    {
      const p = Ot(_);
      return p && (d.target === p || d.composedPath().includes(p));
    }
  }), c = [
    Vn(r, "click", (d) => {
      const _ = Ot(e);
      if (!(!_ || _ === d.target || d.composedPath().includes(_))) {
        if (d.detail === 0 && (i = !s(d)), !i) {
          i = !0;
          return;
        }
        t(d);
      }
    }, { passive: !0, capture: a }),
    Vn(r, "pointerdown", (d) => {
      const _ = Ot(e);
      _ && (i = !d.composedPath().includes(_) && !s(d));
    }, { passive: !0 }),
    l && Vn(r, "blur", (d) => {
      var _;
      const p = Ot(e);
      ((_ = r.document.activeElement) == null ? void 0 : _.tagName) === "IFRAME" && !(p != null && p.contains(r.document.activeElement)) && t(d);
    })
  ].filter(Boolean);
  return () => c.forEach((d) => d());
}
const Eo = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, yo = "__vueuse_ssr_handlers__";
Eo[yo] = Eo[yo] || {};
var No;
(function(e) {
  e.UP = "UP", e.RIGHT = "RIGHT", e.DOWN = "DOWN", e.LEFT = "LEFT", e.NONE = "NONE";
})(No || (No = {}));
var Rc = Object.defineProperty, Oo = Object.getOwnPropertySymbols, kc = Object.prototype.hasOwnProperty, Pc = Object.prototype.propertyIsEnumerable, To = (e, t, n) => t in e ? Rc(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Dc = (e, t) => {
  for (var n in t || (t = {}))
    kc.call(t, n) && To(e, n, t[n]);
  if (Oo)
    for (var n of Oo(t))
      Pc.call(t, n) && To(e, n, t[n]);
  return e;
};
const Mc = {
  easeInSine: [0.12, 0, 0.39, 0],
  easeOutSine: [0.61, 1, 0.88, 1],
  easeInOutSine: [0.37, 0, 0.63, 1],
  easeInQuad: [0.11, 0, 0.5, 0],
  easeOutQuad: [0.5, 1, 0.89, 1],
  easeInOutQuad: [0.45, 0, 0.55, 1],
  easeInCubic: [0.32, 0, 0.67, 0],
  easeOutCubic: [0.33, 1, 0.68, 1],
  easeInOutCubic: [0.65, 0, 0.35, 1],
  easeInQuart: [0.5, 0, 0.75, 0],
  easeOutQuart: [0.25, 1, 0.5, 1],
  easeInOutQuart: [0.76, 0, 0.24, 1],
  easeInQuint: [0.64, 0, 0.78, 0],
  easeOutQuint: [0.22, 1, 0.36, 1],
  easeInOutQuint: [0.83, 0, 0.17, 1],
  easeInExpo: [0.7, 0, 0.84, 0],
  easeOutExpo: [0.16, 1, 0.3, 1],
  easeInOutExpo: [0.87, 0, 0.13, 1],
  easeInCirc: [0.55, 0, 1, 0.45],
  easeOutCirc: [0, 0.55, 0.45, 1],
  easeInOutCirc: [0.85, 0, 0.15, 1],
  easeInBack: [0.36, 0, 0.66, -0.56],
  easeOutBack: [0.34, 1.56, 0.64, 1],
  easeInOutBack: [0.68, -0.6, 0.32, 1.6]
};
Dc({
  linear: Sc
}, Mc);
process.env.NODE_ENV !== "production" && Object.freeze({});
process.env.NODE_ENV !== "production" && Object.freeze([]);
const or = () => {
}, Fc = Object.prototype.hasOwnProperty, Lo = (e, t) => Fc.call(e, t), xc = Array.isArray, _n = (e) => typeof e == "function", Dn = (e) => typeof e == "string", hr = (e) => e !== null && typeof e == "object";
function ar(e) {
  for (var t = -1, n = e == null ? 0 : e.length, r = {}; ++t < n; ) {
    var o = e[t];
    r[o[0]] = o[1];
  }
  return r;
}
function br(e) {
  return e == null;
}
function $c(e) {
  return e === void 0;
}
const Er = (e) => typeof e == "boolean", yr = (e) => typeof e == "number", Ln = (e) => typeof Element > "u" ? !1 : e instanceof Element, Uc = (e) => Dn(e) ? !Number.isNaN(Number(e)) : !1;
class Vc extends Error {
  constructor(t) {
    super(t), this.name = "ElementPlusError";
  }
}
function In(e, t) {
  if (process.env.NODE_ENV !== "production") {
    const n = Dn(e) ? new Vc(`[${e}] ${t}`) : e;
    console.warn(n);
  }
}
const Bc = "utils/dom/style";
function Wc(e, t = "px") {
  if (!e)
    return "";
  if (yr(e) || Uc(e))
    return `${e}${t}`;
  if (Dn(e))
    return e;
  In(Bc, "binding value must be a string or number");
}
const Ma = "__epPropKey", Q = (e) => e, Hc = (e) => hr(e) && !!e[Ma], Nr = (e, t) => {
  if (!hr(e) || Hc(e))
    return e;
  const { values: n, required: r, default: o, type: a, validator: l } = e, i = {
    type: a,
    required: !!r,
    validator: n || l ? (s) => {
      let c = !1, d = [];
      if (n && (d = Array.from(n), Lo(e, "default") && d.push(o), c || (c = d.includes(s))), l && (c || (c = l(s))), !c && d.length > 0) {
        const _ = [...new Set(d)].map((p) => JSON.stringify(p)).join(", ");
        gs(`Invalid prop: validation failed${t ? ` for prop "${t}"` : ""}. Expected one of [${_}], got value ${JSON.stringify(s)}.`);
      }
      return c;
    } : void 0,
    [Ma]: !0
  };
  return Lo(e, "default") && (i.default = o), i;
}, Ce = (e) => ar(Object.entries(e).map(([t, n]) => [
  t,
  Nr(n, t)
])), jc = Q([
  String,
  Object,
  Function
]), Or = (e, t) => {
  if (e.install = (n) => {
    for (const r of [e, ...Object.values(t ?? {})])
      n.component(r.name, r);
  }, t)
    for (const [n, r] of Object.entries(t))
      e[n] = r;
  return e;
}, Yc = (e, t) => (e.install = (n) => {
  n.directive(t, e);
}, e), wn = {
  tab: "Tab",
  enter: "Enter",
  space: "Space",
  left: "ArrowLeft",
  up: "ArrowUp",
  right: "ArrowRight",
  down: "ArrowDown",
  esc: "Escape",
  delete: "Delete",
  backspace: "Backspace",
  numpadEnter: "NumpadEnter",
  pageUp: "PageUp",
  pageDown: "PageDown",
  home: "Home",
  end: "End"
}, Io = "el", Gc = "is-", Nt = (e, t, n, r, o) => {
  let a = `${e}-${t}`;
  return n && (a += `-${n}`), r && (a += `__${r}`), o && (a += `--${o}`), a;
}, Kc = Symbol("namespaceContextKey"), Tr = (e) => {
  const t = e || Ve(Kc, B(Io));
  return P(() => L(t) || Io);
}, Yt = (e, t) => {
  const n = Tr(t);
  return {
    namespace: n,
    b: (r = "") => Nt(n.value, e, r, "", ""),
    e: (r) => r ? Nt(n.value, e, "", r, "") : "",
    m: (r) => r ? Nt(n.value, e, "", "", r) : "",
    be: (r, o) => r && o ? Nt(n.value, e, r, o, "") : "",
    em: (r, o) => r && o ? Nt(n.value, e, "", r, o) : "",
    bm: (r, o) => r && o ? Nt(n.value, e, r, "", o) : "",
    bem: (r, o, a) => r && o && a ? Nt(n.value, e, r, o, a) : "",
    is: (r, ...o) => {
      const a = o.length >= 1 ? o[0] : !0;
      return r && a ? `${Gc}${r}` : "";
    },
    cssVar: (r) => {
      const o = {};
      for (const a in r)
        r[a] && (o[`--${n.value}-${a}`] = r[a]);
      return o;
    },
    cssVarName: (r) => `--${n.value}-${r}`,
    cssVarBlock: (r) => {
      const o = {};
      for (const a in r)
        r[a] && (o[`--${n.value}-${e}-${a}`] = r[a]);
      return o;
    },
    cssVarBlockName: (r) => `--${n.value}-${e}-${r}`
  };
}, Xc = Nr({
  type: Q(Boolean),
  default: null
}), qc = Nr({
  type: Q(Function)
}), Jc = (e) => {
  const t = `update:${e}`, n = `onUpdate:${e}`, r = [t], o = {
    [e]: Xc,
    [n]: qc
  };
  return {
    useModelToggle: ({
      indicator: a,
      toggleReason: l,
      shouldHideWhenRouteChanges: i,
      shouldProceed: s,
      onShow: c,
      onHide: d
    }) => {
      const _ = sn(), { emit: p } = _, b = _.props, g = P(() => _n(b[n])), y = P(() => b[e] === null), E = (N) => {
        a.value !== !0 && (a.value = !0, l && (l.value = N), _n(c) && c(N));
      }, u = (N) => {
        a.value !== !1 && (a.value = !1, l && (l.value = N), _n(d) && d(N));
      }, h = (N) => {
        if (b.disabled === !0 || _n(s) && !s())
          return;
        const S = g.value && Ze;
        S && p(t, !0), (y.value || !S) && E(N);
      }, T = (N) => {
        if (b.disabled === !0 || !Ze)
          return;
        const S = g.value && Ze;
        S && p(t, !1), (y.value || !S) && u(N);
      }, v = (N) => {
        Er(N) && (b.disabled && N ? g.value && p(t, !1) : a.value !== N && (N ? E() : u()));
      }, A = () => {
        a.value ? T() : h();
      };
      return ne(() => b[e], v), i && _.appContext.config.globalProperties.$route !== void 0 && ne(() => ({
        ..._.proxy.$route
      }), () => {
        i.value && a.value && T();
      }), tt(() => {
        v(b[e]);
      }), {
        hide: T,
        show: h,
        toggle: A,
        hasUpdateHandler: g
      };
    },
    useModelToggleProps: o,
    useModelToggleEmits: r
  };
};
var we = "top", $e = "bottom", Ue = "right", Ae = "left", Lr = "auto", ln = [we, $e, Ue, Ae], $t = "start", rn = "end", Qc = "clippingParents", Fa = "viewport", Xt = "popper", Zc = "reference", wo = ln.reduce(function(e, t) {
  return e.concat([t + "-" + $t, t + "-" + rn]);
}, []), Ir = [].concat(ln, [Lr]).reduce(function(e, t) {
  return e.concat([t, t + "-" + $t, t + "-" + rn]);
}, []), zc = "beforeRead", eu = "read", tu = "afterRead", nu = "beforeMain", ru = "main", ou = "afterMain", au = "beforeWrite", su = "write", lu = "afterWrite", iu = [zc, eu, tu, nu, ru, ou, au, su, lu];
function et(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function He(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Ut(e) {
  var t = He(e).Element;
  return e instanceof t || e instanceof Element;
}
function xe(e) {
  var t = He(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function wr(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = He(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function cu(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var r = t.styles[n] || {}, o = t.attributes[n] || {}, a = t.elements[n];
    !xe(a) || !et(a) || (Object.assign(a.style, r), Object.keys(o).forEach(function(l) {
      var i = o[l];
      i === !1 ? a.removeAttribute(l) : a.setAttribute(l, i === !0 ? "" : i);
    }));
  });
}
function uu(e) {
  var t = e.state, n = { popper: { position: t.options.strategy, left: "0", top: "0", margin: "0" }, arrow: { position: "absolute" }, reference: {} };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var o = t.elements[r], a = t.attributes[r] || {}, l = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), i = l.reduce(function(s, c) {
        return s[c] = "", s;
      }, {});
      !xe(o) || !et(o) || (Object.assign(o.style, i), Object.keys(a).forEach(function(s) {
        o.removeAttribute(s);
      }));
    });
  };
}
var xa = { name: "applyStyles", enabled: !0, phase: "write", fn: cu, effect: uu, requires: ["computeStyles"] };
function ze(e) {
  return e.split("-")[0];
}
var Tt = Math.max, An = Math.min, Vt = Math.round;
function Bt(e, t) {
  t === void 0 && (t = !1);
  var n = e.getBoundingClientRect(), r = 1, o = 1;
  if (xe(e) && t) {
    var a = e.offsetHeight, l = e.offsetWidth;
    l > 0 && (r = Vt(n.width) / l || 1), a > 0 && (o = Vt(n.height) / a || 1);
  }
  return { width: n.width / r, height: n.height / o, top: n.top / o, right: n.right / r, bottom: n.bottom / o, left: n.left / r, x: n.left / r, y: n.top / o };
}
function Ar(e) {
  var t = Bt(e), n = e.offsetWidth, r = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), { x: e.offsetLeft, y: e.offsetTop, width: n, height: r };
}
function $a(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && wr(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function it(e) {
  return He(e).getComputedStyle(e);
}
function fu(e) {
  return ["table", "td", "th"].indexOf(et(e)) >= 0;
}
function gt(e) {
  return ((Ut(e) ? e.ownerDocument : e.document) || window.document).documentElement;
}
function Mn(e) {
  return et(e) === "html" ? e : e.assignedSlot || e.parentNode || (wr(e) ? e.host : null) || gt(e);
}
function Ao(e) {
  return !xe(e) || it(e).position === "fixed" ? null : e.offsetParent;
}
function du(e) {
  var t = navigator.userAgent.toLowerCase().indexOf("firefox") !== -1, n = navigator.userAgent.indexOf("Trident") !== -1;
  if (n && xe(e)) {
    var r = it(e);
    if (r.position === "fixed")
      return null;
  }
  var o = Mn(e);
  for (wr(o) && (o = o.host); xe(o) && ["html", "body"].indexOf(et(o)) < 0; ) {
    var a = it(o);
    if (a.transform !== "none" || a.perspective !== "none" || a.contain === "paint" || ["transform", "perspective"].indexOf(a.willChange) !== -1 || t && a.willChange === "filter" || t && a.filter && a.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function cn(e) {
  for (var t = He(e), n = Ao(e); n && fu(n) && it(n).position === "static"; )
    n = Ao(n);
  return n && (et(n) === "html" || et(n) === "body" && it(n).position === "static") ? t : n || du(e) || t;
}
function Sr(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Zt(e, t, n) {
  return Tt(e, An(t, n));
}
function pu(e, t, n) {
  var r = Zt(e, t, n);
  return r > n ? n : r;
}
function Ua() {
  return { top: 0, right: 0, bottom: 0, left: 0 };
}
function Va(e) {
  return Object.assign({}, Ua(), e);
}
function Ba(e, t) {
  return t.reduce(function(n, r) {
    return n[r] = e, n;
  }, {});
}
var mu = function(e, t) {
  return e = typeof e == "function" ? e(Object.assign({}, t.rects, { placement: t.placement })) : e, Va(typeof e != "number" ? e : Ba(e, ln));
};
function _u(e) {
  var t, n = e.state, r = e.name, o = e.options, a = n.elements.arrow, l = n.modifiersData.popperOffsets, i = ze(n.placement), s = Sr(i), c = [Ae, Ue].indexOf(i) >= 0, d = c ? "height" : "width";
  if (!(!a || !l)) {
    var _ = mu(o.padding, n), p = Ar(a), b = s === "y" ? we : Ae, g = s === "y" ? $e : Ue, y = n.rects.reference[d] + n.rects.reference[s] - l[s] - n.rects.popper[d], E = l[s] - n.rects.reference[s], u = cn(a), h = u ? s === "y" ? u.clientHeight || 0 : u.clientWidth || 0 : 0, T = y / 2 - E / 2, v = _[b], A = h - p[d] - _[g], N = h / 2 - p[d] / 2 + T, S = Zt(v, N, A), w = s;
    n.modifiersData[r] = (t = {}, t[w] = S, t.centerOffset = S - N, t);
  }
}
function vu(e) {
  var t = e.state, n = e.options, r = n.element, o = r === void 0 ? "[data-popper-arrow]" : r;
  o != null && (typeof o == "string" && (o = t.elements.popper.querySelector(o), !o) || !$a(t.elements.popper, o) || (t.elements.arrow = o));
}
var gu = { name: "arrow", enabled: !0, phase: "main", fn: _u, effect: vu, requires: ["popperOffsets"], requiresIfExists: ["preventOverflow"] };
function Wt(e) {
  return e.split("-")[1];
}
var hu = { top: "auto", right: "auto", bottom: "auto", left: "auto" };
function bu(e) {
  var t = e.x, n = e.y, r = window, o = r.devicePixelRatio || 1;
  return { x: Vt(t * o) / o || 0, y: Vt(n * o) / o || 0 };
}
function So(e) {
  var t, n = e.popper, r = e.popperRect, o = e.placement, a = e.variation, l = e.offsets, i = e.position, s = e.gpuAcceleration, c = e.adaptive, d = e.roundOffsets, _ = e.isFixed, p = l.x, b = p === void 0 ? 0 : p, g = l.y, y = g === void 0 ? 0 : g, E = typeof d == "function" ? d({ x: b, y }) : { x: b, y };
  b = E.x, y = E.y;
  var u = l.hasOwnProperty("x"), h = l.hasOwnProperty("y"), T = Ae, v = we, A = window;
  if (c) {
    var N = cn(n), S = "clientHeight", w = "clientWidth";
    if (N === He(n) && (N = gt(n), it(N).position !== "static" && i === "absolute" && (S = "scrollHeight", w = "scrollWidth")), N = N, o === we || (o === Ae || o === Ue) && a === rn) {
      v = $e;
      var D = _ && N === A && A.visualViewport ? A.visualViewport.height : N[S];
      y -= D - r.height, y *= s ? 1 : -1;
    }
    if (o === Ae || (o === we || o === $e) && a === rn) {
      T = Ue;
      var x = _ && N === A && A.visualViewport ? A.visualViewport.width : N[w];
      b -= x - r.width, b *= s ? 1 : -1;
    }
  }
  var V = Object.assign({ position: i }, c && hu), G = d === !0 ? bu({ x: b, y }) : { x: b, y };
  if (b = G.x, y = G.y, s) {
    var j;
    return Object.assign({}, V, (j = {}, j[v] = h ? "0" : "", j[T] = u ? "0" : "", j.transform = (A.devicePixelRatio || 1) <= 1 ? "translate(" + b + "px, " + y + "px)" : "translate3d(" + b + "px, " + y + "px, 0)", j));
  }
  return Object.assign({}, V, (t = {}, t[v] = h ? y + "px" : "", t[T] = u ? b + "px" : "", t.transform = "", t));
}
function Eu(e) {
  var t = e.state, n = e.options, r = n.gpuAcceleration, o = r === void 0 ? !0 : r, a = n.adaptive, l = a === void 0 ? !0 : a, i = n.roundOffsets, s = i === void 0 ? !0 : i, c = { placement: ze(t.placement), variation: Wt(t.placement), popper: t.elements.popper, popperRect: t.rects.popper, gpuAcceleration: o, isFixed: t.options.strategy === "fixed" };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, So(Object.assign({}, c, { offsets: t.modifiersData.popperOffsets, position: t.options.strategy, adaptive: l, roundOffsets: s })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, So(Object.assign({}, c, { offsets: t.modifiersData.arrow, position: "absolute", adaptive: !1, roundOffsets: s })))), t.attributes.popper = Object.assign({}, t.attributes.popper, { "data-popper-placement": t.placement });
}
var Wa = { name: "computeStyles", enabled: !0, phase: "beforeWrite", fn: Eu, data: {} }, vn = { passive: !0 };
function yu(e) {
  var t = e.state, n = e.instance, r = e.options, o = r.scroll, a = o === void 0 ? !0 : o, l = r.resize, i = l === void 0 ? !0 : l, s = He(t.elements.popper), c = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return a && c.forEach(function(d) {
    d.addEventListener("scroll", n.update, vn);
  }), i && s.addEventListener("resize", n.update, vn), function() {
    a && c.forEach(function(d) {
      d.removeEventListener("scroll", n.update, vn);
    }), i && s.removeEventListener("resize", n.update, vn);
  };
}
var Ha = { name: "eventListeners", enabled: !0, phase: "write", fn: function() {
}, effect: yu, data: {} }, Nu = { left: "right", right: "left", bottom: "top", top: "bottom" };
function yn(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return Nu[t];
  });
}
var Ou = { start: "end", end: "start" };
function Co(e) {
  return e.replace(/start|end/g, function(t) {
    return Ou[t];
  });
}
function Cr(e) {
  var t = He(e), n = t.pageXOffset, r = t.pageYOffset;
  return { scrollLeft: n, scrollTop: r };
}
function Rr(e) {
  return Bt(gt(e)).left + Cr(e).scrollLeft;
}
function Tu(e) {
  var t = He(e), n = gt(e), r = t.visualViewport, o = n.clientWidth, a = n.clientHeight, l = 0, i = 0;
  return r && (o = r.width, a = r.height, /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || (l = r.offsetLeft, i = r.offsetTop)), { width: o, height: a, x: l + Rr(e), y: i };
}
function Lu(e) {
  var t, n = gt(e), r = Cr(e), o = (t = e.ownerDocument) == null ? void 0 : t.body, a = Tt(n.scrollWidth, n.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), l = Tt(n.scrollHeight, n.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), i = -r.scrollLeft + Rr(e), s = -r.scrollTop;
  return it(o || n).direction === "rtl" && (i += Tt(n.clientWidth, o ? o.clientWidth : 0) - a), { width: a, height: l, x: i, y: s };
}
function kr(e) {
  var t = it(e), n = t.overflow, r = t.overflowX, o = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + o + r);
}
function ja(e) {
  return ["html", "body", "#document"].indexOf(et(e)) >= 0 ? e.ownerDocument.body : xe(e) && kr(e) ? e : ja(Mn(e));
}
function zt(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = ja(e), o = r === ((n = e.ownerDocument) == null ? void 0 : n.body), a = He(r), l = o ? [a].concat(a.visualViewport || [], kr(r) ? r : []) : r, i = t.concat(l);
  return o ? i : i.concat(zt(Mn(l)));
}
function sr(e) {
  return Object.assign({}, e, { left: e.x, top: e.y, right: e.x + e.width, bottom: e.y + e.height });
}
function Iu(e) {
  var t = Bt(e);
  return t.top = t.top + e.clientTop, t.left = t.left + e.clientLeft, t.bottom = t.top + e.clientHeight, t.right = t.left + e.clientWidth, t.width = e.clientWidth, t.height = e.clientHeight, t.x = t.left, t.y = t.top, t;
}
function Ro(e, t) {
  return t === Fa ? sr(Tu(e)) : Ut(t) ? Iu(t) : sr(Lu(gt(e)));
}
function wu(e) {
  var t = zt(Mn(e)), n = ["absolute", "fixed"].indexOf(it(e).position) >= 0, r = n && xe(e) ? cn(e) : e;
  return Ut(r) ? t.filter(function(o) {
    return Ut(o) && $a(o, r) && et(o) !== "body";
  }) : [];
}
function Au(e, t, n) {
  var r = t === "clippingParents" ? wu(e) : [].concat(t), o = [].concat(r, [n]), a = o[0], l = o.reduce(function(i, s) {
    var c = Ro(e, s);
    return i.top = Tt(c.top, i.top), i.right = An(c.right, i.right), i.bottom = An(c.bottom, i.bottom), i.left = Tt(c.left, i.left), i;
  }, Ro(e, a));
  return l.width = l.right - l.left, l.height = l.bottom - l.top, l.x = l.left, l.y = l.top, l;
}
function Ya(e) {
  var t = e.reference, n = e.element, r = e.placement, o = r ? ze(r) : null, a = r ? Wt(r) : null, l = t.x + t.width / 2 - n.width / 2, i = t.y + t.height / 2 - n.height / 2, s;
  switch (o) {
    case we:
      s = { x: l, y: t.y - n.height };
      break;
    case $e:
      s = { x: l, y: t.y + t.height };
      break;
    case Ue:
      s = { x: t.x + t.width, y: i };
      break;
    case Ae:
      s = { x: t.x - n.width, y: i };
      break;
    default:
      s = { x: t.x, y: t.y };
  }
  var c = o ? Sr(o) : null;
  if (c != null) {
    var d = c === "y" ? "height" : "width";
    switch (a) {
      case $t:
        s[c] = s[c] - (t[d] / 2 - n[d] / 2);
        break;
      case rn:
        s[c] = s[c] + (t[d] / 2 - n[d] / 2);
        break;
    }
  }
  return s;
}
function on(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, o = r === void 0 ? e.placement : r, a = n.boundary, l = a === void 0 ? Qc : a, i = n.rootBoundary, s = i === void 0 ? Fa : i, c = n.elementContext, d = c === void 0 ? Xt : c, _ = n.altBoundary, p = _ === void 0 ? !1 : _, b = n.padding, g = b === void 0 ? 0 : b, y = Va(typeof g != "number" ? g : Ba(g, ln)), E = d === Xt ? Zc : Xt, u = e.rects.popper, h = e.elements[p ? E : d], T = Au(Ut(h) ? h : h.contextElement || gt(e.elements.popper), l, s), v = Bt(e.elements.reference), A = Ya({ reference: v, element: u, strategy: "absolute", placement: o }), N = sr(Object.assign({}, u, A)), S = d === Xt ? N : v, w = { top: T.top - S.top + y.top, bottom: S.bottom - T.bottom + y.bottom, left: T.left - S.left + y.left, right: S.right - T.right + y.right }, D = e.modifiersData.offset;
  if (d === Xt && D) {
    var x = D[o];
    Object.keys(w).forEach(function(V) {
      var G = [Ue, $e].indexOf(V) >= 0 ? 1 : -1, j = [we, $e].indexOf(V) >= 0 ? "y" : "x";
      w[V] += x[j] * G;
    });
  }
  return w;
}
function Su(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, o = n.boundary, a = n.rootBoundary, l = n.padding, i = n.flipVariations, s = n.allowedAutoPlacements, c = s === void 0 ? Ir : s, d = Wt(r), _ = d ? i ? wo : wo.filter(function(g) {
    return Wt(g) === d;
  }) : ln, p = _.filter(function(g) {
    return c.indexOf(g) >= 0;
  });
  p.length === 0 && (p = _);
  var b = p.reduce(function(g, y) {
    return g[y] = on(e, { placement: y, boundary: o, rootBoundary: a, padding: l })[ze(y)], g;
  }, {});
  return Object.keys(b).sort(function(g, y) {
    return b[g] - b[y];
  });
}
function Cu(e) {
  if (ze(e) === Lr)
    return [];
  var t = yn(e);
  return [Co(e), t, Co(t)];
}
function Ru(e) {
  var t = e.state, n = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var o = n.mainAxis, a = o === void 0 ? !0 : o, l = n.altAxis, i = l === void 0 ? !0 : l, s = n.fallbackPlacements, c = n.padding, d = n.boundary, _ = n.rootBoundary, p = n.altBoundary, b = n.flipVariations, g = b === void 0 ? !0 : b, y = n.allowedAutoPlacements, E = t.options.placement, u = ze(E), h = u === E, T = s || (h || !g ? [yn(E)] : Cu(E)), v = [E].concat(T).reduce(function(Te, Ee) {
      return Te.concat(ze(Ee) === Lr ? Su(t, { placement: Ee, boundary: d, rootBoundary: _, padding: c, flipVariations: g, allowedAutoPlacements: y }) : Ee);
    }, []), A = t.rects.reference, N = t.rects.popper, S = /* @__PURE__ */ new Map(), w = !0, D = v[0], x = 0; x < v.length; x++) {
      var V = v[x], G = ze(V), j = Wt(V) === $t, le = [we, $e].indexOf(G) >= 0, se = le ? "width" : "height", q = on(t, { placement: V, boundary: d, rootBoundary: _, altBoundary: p, padding: c }), M = le ? j ? Ue : Ae : j ? $e : we;
      A[se] > N[se] && (M = yn(M));
      var ce = yn(M), _e = [];
      if (a && _e.push(q[G] <= 0), i && _e.push(q[M] <= 0, q[ce] <= 0), _e.every(function(Te) {
        return Te;
      })) {
        D = V, w = !1;
        break;
      }
      S.set(V, _e);
    }
    if (w)
      for (var Ye = g ? 3 : 1, be = function(Te) {
        var Ee = v.find(function(Ke) {
          var Xe = S.get(Ke);
          if (Xe)
            return Xe.slice(0, Te).every(function(Le) {
              return Le;
            });
        });
        if (Ee)
          return D = Ee, "break";
      }, Re = Ye; Re > 0; Re--) {
        var Ge = be(Re);
        if (Ge === "break")
          break;
      }
    t.placement !== D && (t.modifiersData[r]._skip = !0, t.placement = D, t.reset = !0);
  }
}
var ku = { name: "flip", enabled: !0, phase: "main", fn: Ru, requiresIfExists: ["offset"], data: { _skip: !1 } };
function ko(e, t, n) {
  return n === void 0 && (n = { x: 0, y: 0 }), { top: e.top - t.height - n.y, right: e.right - t.width + n.x, bottom: e.bottom - t.height + n.y, left: e.left - t.width - n.x };
}
function Po(e) {
  return [we, Ue, $e, Ae].some(function(t) {
    return e[t] >= 0;
  });
}
function Pu(e) {
  var t = e.state, n = e.name, r = t.rects.reference, o = t.rects.popper, a = t.modifiersData.preventOverflow, l = on(t, { elementContext: "reference" }), i = on(t, { altBoundary: !0 }), s = ko(l, r), c = ko(i, o, a), d = Po(s), _ = Po(c);
  t.modifiersData[n] = { referenceClippingOffsets: s, popperEscapeOffsets: c, isReferenceHidden: d, hasPopperEscaped: _ }, t.attributes.popper = Object.assign({}, t.attributes.popper, { "data-popper-reference-hidden": d, "data-popper-escaped": _ });
}
var Du = { name: "hide", enabled: !0, phase: "main", requiresIfExists: ["preventOverflow"], fn: Pu };
function Mu(e, t, n) {
  var r = ze(e), o = [Ae, we].indexOf(r) >= 0 ? -1 : 1, a = typeof n == "function" ? n(Object.assign({}, t, { placement: e })) : n, l = a[0], i = a[1];
  return l = l || 0, i = (i || 0) * o, [Ae, Ue].indexOf(r) >= 0 ? { x: i, y: l } : { x: l, y: i };
}
function Fu(e) {
  var t = e.state, n = e.options, r = e.name, o = n.offset, a = o === void 0 ? [0, 0] : o, l = Ir.reduce(function(d, _) {
    return d[_] = Mu(_, t.rects, a), d;
  }, {}), i = l[t.placement], s = i.x, c = i.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += s, t.modifiersData.popperOffsets.y += c), t.modifiersData[r] = l;
}
var xu = { name: "offset", enabled: !0, phase: "main", requires: ["popperOffsets"], fn: Fu };
function $u(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = Ya({ reference: t.rects.reference, element: t.rects.popper, strategy: "absolute", placement: t.placement });
}
var Ga = { name: "popperOffsets", enabled: !0, phase: "read", fn: $u, data: {} };
function Uu(e) {
  return e === "x" ? "y" : "x";
}
function Vu(e) {
  var t = e.state, n = e.options, r = e.name, o = n.mainAxis, a = o === void 0 ? !0 : o, l = n.altAxis, i = l === void 0 ? !1 : l, s = n.boundary, c = n.rootBoundary, d = n.altBoundary, _ = n.padding, p = n.tether, b = p === void 0 ? !0 : p, g = n.tetherOffset, y = g === void 0 ? 0 : g, E = on(t, { boundary: s, rootBoundary: c, padding: _, altBoundary: d }), u = ze(t.placement), h = Wt(t.placement), T = !h, v = Sr(u), A = Uu(v), N = t.modifiersData.popperOffsets, S = t.rects.reference, w = t.rects.popper, D = typeof y == "function" ? y(Object.assign({}, t.rects, { placement: t.placement })) : y, x = typeof D == "number" ? { mainAxis: D, altAxis: D } : Object.assign({ mainAxis: 0, altAxis: 0 }, D), V = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, G = { x: 0, y: 0 };
  if (N) {
    if (a) {
      var j, le = v === "y" ? we : Ae, se = v === "y" ? $e : Ue, q = v === "y" ? "height" : "width", M = N[v], ce = M + E[le], _e = M - E[se], Ye = b ? -w[q] / 2 : 0, be = h === $t ? S[q] : w[q], Re = h === $t ? -w[q] : -S[q], Ge = t.elements.arrow, Te = b && Ge ? Ar(Ge) : { width: 0, height: 0 }, Ee = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : Ua(), Ke = Ee[le], Xe = Ee[se], Le = Zt(0, S[q], Te[q]), rt = T ? S[q] / 2 - Ye - Le - Ke - x.mainAxis : be - Le - Ke - x.mainAxis, qe = T ? -S[q] / 2 + Ye + Le + Xe + x.mainAxis : Re + Le + Xe + x.mainAxis, Be = t.elements.arrow && cn(t.elements.arrow), ht = Be ? v === "y" ? Be.clientTop || 0 : Be.clientLeft || 0 : 0, m = (j = V == null ? void 0 : V[v]) != null ? j : 0, f = M + rt - m - ht, O = M + qe - m, R = Zt(b ? An(ce, f) : ce, M, b ? Tt(_e, O) : _e);
      N[v] = R, G[v] = R - M;
    }
    if (i) {
      var $, X = v === "x" ? we : Ae, ke = v === "x" ? $e : Ue, ve = N[A], At = A === "y" ? "height" : "width", fn = ve + E[X], dn = ve - E[ke], Gt = [we, Ae].indexOf(u) !== -1, oe = ($ = V == null ? void 0 : V[A]) != null ? $ : 0, I = Gt ? fn : ve - S[At] - w[At] - oe + x.altAxis, C = Gt ? ve + S[At] + w[At] - oe - x.altAxis : dn, K = b && Gt ? pu(I, ve, C) : Zt(b ? I : fn, ve, b ? C : dn);
      N[A] = K, G[A] = K - ve;
    }
    t.modifiersData[r] = G;
  }
}
var Bu = { name: "preventOverflow", enabled: !0, phase: "main", fn: Vu, requiresIfExists: ["offset"] };
function Wu(e) {
  return { scrollLeft: e.scrollLeft, scrollTop: e.scrollTop };
}
function Hu(e) {
  return e === He(e) || !xe(e) ? Cr(e) : Wu(e);
}
function ju(e) {
  var t = e.getBoundingClientRect(), n = Vt(t.width) / e.offsetWidth || 1, r = Vt(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function Yu(e, t, n) {
  n === void 0 && (n = !1);
  var r = xe(t), o = xe(t) && ju(t), a = gt(t), l = Bt(e, o), i = { scrollLeft: 0, scrollTop: 0 }, s = { x: 0, y: 0 };
  return (r || !r && !n) && ((et(t) !== "body" || kr(a)) && (i = Hu(t)), xe(t) ? (s = Bt(t, !0), s.x += t.clientLeft, s.y += t.clientTop) : a && (s.x = Rr(a))), { x: l.left + i.scrollLeft - s.x, y: l.top + i.scrollTop - s.y, width: l.width, height: l.height };
}
function Gu(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(a) {
    t.set(a.name, a);
  });
  function o(a) {
    n.add(a.name);
    var l = [].concat(a.requires || [], a.requiresIfExists || []);
    l.forEach(function(i) {
      if (!n.has(i)) {
        var s = t.get(i);
        s && o(s);
      }
    }), r.push(a);
  }
  return e.forEach(function(a) {
    n.has(a.name) || o(a);
  }), r;
}
function Ku(e) {
  var t = Gu(e);
  return iu.reduce(function(n, r) {
    return n.concat(t.filter(function(o) {
      return o.phase === r;
    }));
  }, []);
}
function Xu(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function qu(e) {
  var t = e.reduce(function(n, r) {
    var o = n[r.name];
    return n[r.name] = o ? Object.assign({}, o, r, { options: Object.assign({}, o.options, r.options), data: Object.assign({}, o.data, r.data) }) : r, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var Do = { placement: "bottom", modifiers: [], strategy: "absolute" };
function Mo() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function Pr(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, o = t.defaultOptions, a = o === void 0 ? Do : o;
  return function(l, i, s) {
    s === void 0 && (s = a);
    var c = { placement: "bottom", orderedModifiers: [], options: Object.assign({}, Do, a), modifiersData: {}, elements: { reference: l, popper: i }, attributes: {}, styles: {} }, d = [], _ = !1, p = { state: c, setOptions: function(y) {
      var E = typeof y == "function" ? y(c.options) : y;
      g(), c.options = Object.assign({}, a, c.options, E), c.scrollParents = { reference: Ut(l) ? zt(l) : l.contextElement ? zt(l.contextElement) : [], popper: zt(i) };
      var u = Ku(qu([].concat(r, c.options.modifiers)));
      return c.orderedModifiers = u.filter(function(h) {
        return h.enabled;
      }), b(), p.update();
    }, forceUpdate: function() {
      if (!_) {
        var y = c.elements, E = y.reference, u = y.popper;
        if (Mo(E, u)) {
          c.rects = { reference: Yu(E, cn(u), c.options.strategy === "fixed"), popper: Ar(u) }, c.reset = !1, c.placement = c.options.placement, c.orderedModifiers.forEach(function(w) {
            return c.modifiersData[w.name] = Object.assign({}, w.data);
          });
          for (var h = 0; h < c.orderedModifiers.length; h++) {
            if (c.reset === !0) {
              c.reset = !1, h = -1;
              continue;
            }
            var T = c.orderedModifiers[h], v = T.fn, A = T.options, N = A === void 0 ? {} : A, S = T.name;
            typeof v == "function" && (c = v({ state: c, options: N, name: S, instance: p }) || c);
          }
        }
      }
    }, update: Xu(function() {
      return new Promise(function(y) {
        p.forceUpdate(), y(c);
      });
    }), destroy: function() {
      g(), _ = !0;
    } };
    if (!Mo(l, i))
      return p;
    p.setOptions(s).then(function(y) {
      !_ && s.onFirstUpdate && s.onFirstUpdate(y);
    });
    function b() {
      c.orderedModifiers.forEach(function(y) {
        var E = y.name, u = y.options, h = u === void 0 ? {} : u, T = y.effect;
        if (typeof T == "function") {
          var v = T({ state: c, name: E, instance: p, options: h }), A = function() {
          };
          d.push(v || A);
        }
      });
    }
    function g() {
      d.forEach(function(y) {
        return y();
      }), d = [];
    }
    return p;
  };
}
Pr();
var Ju = [Ha, Ga, Wa, xa];
Pr({ defaultModifiers: Ju });
var Qu = [Ha, Ga, Wa, xa, xu, ku, Bu, gu, Du], Zu = Pr({ defaultModifiers: Qu });
const zu = (e, t, n = {}) => {
  const r = {
    name: "updateState",
    enabled: !0,
    phase: "write",
    fn: ({ state: s }) => {
      const c = ef(s);
      Object.assign(l.value, c);
    },
    requires: ["computeStyles"]
  }, o = P(() => {
    const { onFirstUpdate: s, placement: c, strategy: d, modifiers: _ } = L(n);
    return {
      onFirstUpdate: s,
      placement: c || "bottom",
      strategy: d || "absolute",
      modifiers: [
        ..._ || [],
        r,
        { name: "applyStyles", enabled: !1 }
      ]
    };
  }), a = ir(), l = B({
    styles: {
      popper: {
        position: L(o).strategy,
        left: "0",
        top: "0"
      },
      arrow: {
        position: "absolute"
      }
    },
    attributes: {}
  }), i = () => {
    a.value && (a.value.destroy(), a.value = void 0);
  };
  return ne(o, (s) => {
    const c = L(a);
    c && c.setOptions(s);
  }, {
    deep: !0
  }), ne([e, t], ([s, c]) => {
    i(), !(!s || !c) && (a.value = Zu(s, c, L(o)));
  }), nt(() => {
    i();
  }), {
    state: P(() => {
      var s;
      return { ...((s = L(a)) == null ? void 0 : s.state) || {} };
    }),
    styles: P(() => L(l).styles),
    attributes: P(() => L(l).attributes),
    update: () => {
      var s;
      return (s = L(a)) == null ? void 0 : s.update();
    },
    forceUpdate: () => {
      var s;
      return (s = L(a)) == null ? void 0 : s.forceUpdate();
    },
    instanceRef: P(() => L(a))
  };
};
function ef(e) {
  const t = Object.keys(e.elements), n = ar(t.map((o) => [o, e.styles[o] || {}])), r = ar(t.map((o) => [o, e.attributes[o]]));
  return {
    styles: n,
    attributes: r
  };
}
function Fo() {
  let e;
  const t = (r, o) => {
    n(), e = window.setTimeout(r, o);
  }, n = () => window.clearTimeout(e);
  return Pa(() => n()), {
    registerTimeout: t,
    cancelTimeout: n
  };
}
const lr = {
  prefix: Math.floor(Math.random() * 1e4),
  current: 0
}, tf = Symbol("elIdInjection"), Ka = () => sn() ? Ve(tf, lr) : lr, nf = (e) => {
  const t = Ka();
  !Ze && t === lr && In("IdInjection", `Looks like you are using server rendering, you must provide a id provider to ensure the hydration process to be succeed
usage: app.provide(ID_INJECTION_KEY, {
  prefix: number,
  current: number,
})`);
  const n = Tr();
  return P(() => L(e) || `${n.value}-id-${t.prefix}-${t.current++}`);
};
let Pt = [];
const xo = (e) => {
  const t = e;
  t.key === wn.esc && Pt.forEach((n) => n(t));
}, rf = (e) => {
  tt(() => {
    Pt.length === 0 && document.addEventListener("keydown", xo), Ze && Pt.push(e);
  }), nt(() => {
    Pt = Pt.filter((t) => t !== e), Pt.length === 0 && Ze && document.removeEventListener("keydown", xo);
  });
};
let $o;
const Xa = () => {
  const e = Tr(), t = Ka(), n = P(() => `${e.value}-popper-container-${t.prefix}`), r = P(() => `#${n.value}`);
  return {
    id: n,
    selector: r
  };
}, of = (e) => {
  const t = document.createElement("div");
  return t.id = e, document.body.appendChild(t), t;
}, af = () => {
  const { id: e, selector: t } = Xa();
  return ea(() => {
    Ze && (process.env.NODE_ENV === "test" || !$o && !document.body.querySelector(t.value)) && ($o = of(e.value));
  }), {
    id: e,
    selector: t
  };
}, sf = Ce({
  showAfter: {
    type: Number,
    default: 0
  },
  hideAfter: {
    type: Number,
    default: 200
  },
  autoClose: {
    type: Number,
    default: 0
  }
}), lf = ({
  showAfter: e,
  hideAfter: t,
  autoClose: n,
  open: r,
  close: o
}) => {
  const { registerTimeout: a } = Fo(), {
    registerTimeout: l,
    cancelTimeout: i
  } = Fo();
  return {
    onOpen: (s) => {
      a(() => {
        r(s);
        const c = L(n);
        yr(c) && c > 0 && l(() => {
          o(s);
        }, c);
      }, L(e));
    },
    onClose: (s) => {
      i(), a(() => {
        o(s);
      }, L(t));
    }
  };
}, qa = Symbol("elForwardRef"), cf = (e) => {
  mt(qa, {
    setForwardRef: (t) => {
      e.value = t;
    }
  });
}, uf = (e) => ({
  mounted(t) {
    e(t);
  },
  updated(t) {
    e(t);
  },
  unmounted() {
    e(null);
  }
}), Uo = B(0), ff = 2e3, df = Symbol("zIndexContextKey"), pf = (e) => {
  const t = e || Ve(df, void 0), n = P(() => {
    const o = L(t);
    return yr(o) ? o : ff;
  }), r = P(() => n.value + Uo.value);
  return {
    initialZIndex: n,
    currentZIndex: r,
    nextZIndex: () => (Uo.value++, r.value)
  };
};
var je = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, o] of t)
    n[r] = o;
  return n;
};
const Vo = Symbol("formItemContextKey"), Dr = Symbol("popper"), Ja = Symbol("popperContent"), mf = [
  "dialog",
  "grid",
  "group",
  "listbox",
  "menu",
  "navigation",
  "tooltip",
  "tree"
], Qa = Ce({
  role: {
    type: String,
    values: mf,
    default: "tooltip"
  }
}), _f = H({
  name: "ElPopper",
  inheritAttrs: !1
}), vf = /* @__PURE__ */ H({
  ..._f,
  props: Qa,
  setup(e, { expose: t }) {
    const n = e, r = B(), o = B(), a = B(), l = B(), i = P(() => n.role), s = {
      triggerRef: r,
      popperInstanceRef: o,
      contentRef: a,
      referenceRef: l,
      role: i
    };
    return t(s), mt(Dr, s), (c, d) => te(c.$slots, "default");
  }
});
var gf = /* @__PURE__ */ je(vf, [["__file", "/home/runner/work/element-plus/element-plus/packages/components/popper/src/popper.vue"]]);
const Za = Ce({
  arrowOffset: {
    type: Number,
    default: 5
  }
}), hf = H({
  name: "ElPopperArrow",
  inheritAttrs: !1
}), bf = /* @__PURE__ */ H({
  ...hf,
  props: Za,
  setup(e, { expose: t }) {
    const n = e, r = Yt("popper"), { arrowOffset: o, arrowRef: a, arrowStyle: l } = Ve(Ja, void 0);
    return ne(() => n.arrowOffset, (i) => {
      o.value = i;
    }), nt(() => {
      a.value = void 0;
    }), t({
      arrowRef: a
    }), (i, s) => (F(), W("span", {
      ref_key: "arrowRef",
      ref: a,
      class: Fe(L(r).e("arrow")),
      style: us(L(l)),
      "data-popper-arrow": ""
    }, null, 6));
  }
});
var Ef = /* @__PURE__ */ je(bf, [["__file", "/home/runner/work/element-plus/element-plus/packages/components/popper/src/arrow.vue"]]);
const Bn = "ElOnlyChild", yf = H({
  name: Bn,
  setup(e, {
    slots: t,
    attrs: n
  }) {
    var r;
    const o = Ve(qa), a = uf((r = o == null ? void 0 : o.setForwardRef) != null ? r : or);
    return () => {
      var l;
      const i = (l = t.default) == null ? void 0 : l.call(t, n);
      if (!i)
        return null;
      if (i.length > 1)
        return In(Bn, "requires exact only one valid child."), null;
      const s = za(i);
      return s ? Sn(fs(s, n), [[a]]) : (In(Bn, "no valid child node found"), null);
    };
  }
});
function za(e) {
  if (!e)
    return null;
  const t = e;
  for (const n of t) {
    if (hr(n))
      switch (n.type) {
        case ds:
          continue;
        case ta:
        case "svg":
          return Bo(n);
        case Mt:
          return za(n.children);
        default:
          return n;
      }
    return Bo(n);
  }
  return null;
}
function Bo(e) {
  const t = Yt("only-child");
  return We("span", {
    class: t.e("content")
  }, [e]);
}
const es = Ce({
  virtualRef: {
    type: Q(Object)
  },
  virtualTriggering: Boolean,
  onMouseenter: {
    type: Q(Function)
  },
  onMouseleave: {
    type: Q(Function)
  },
  onClick: {
    type: Q(Function)
  },
  onKeydown: {
    type: Q(Function)
  },
  onFocus: {
    type: Q(Function)
  },
  onBlur: {
    type: Q(Function)
  },
  onContextmenu: {
    type: Q(Function)
  },
  id: String,
  open: Boolean
}), Nf = H({
  name: "ElPopperTrigger",
  inheritAttrs: !1
}), Of = /* @__PURE__ */ H({
  ...Nf,
  props: es,
  setup(e, { expose: t }) {
    const n = e, { role: r, triggerRef: o } = Ve(Dr, void 0);
    cf(o);
    const a = P(() => i.value ? n.id : void 0), l = P(() => {
      if (r && r.value === "tooltip")
        return n.open && n.id ? n.id : void 0;
    }), i = P(() => {
      if (r && r.value !== "tooltip")
        return r.value;
    }), s = P(() => i.value ? `${n.open}` : void 0);
    let c;
    return tt(() => {
      ne(() => n.virtualRef, (d) => {
        d && (o.value = Ot(d));
      }, {
        immediate: !0
      }), ne(o, (d, _) => {
        c == null || c(), c = void 0, Ln(d) && ([
          "onMouseenter",
          "onMouseleave",
          "onClick",
          "onKeydown",
          "onFocus",
          "onBlur",
          "onContextmenu"
        ].forEach((p) => {
          var b;
          const g = n[p];
          g && (d.addEventListener(p.slice(2).toLowerCase(), g), (b = _ == null ? void 0 : _.removeEventListener) == null || b.call(_, p.slice(2).toLowerCase(), g));
        }), c = ne([a, l, i, s], (p) => {
          [
            "aria-controls",
            "aria-describedby",
            "aria-haspopup",
            "aria-expanded"
          ].forEach((b, g) => {
            br(p[g]) ? d.removeAttribute(b) : d.setAttribute(b, p[g]);
          });
        }, { immediate: !0 })), Ln(_) && [
          "aria-controls",
          "aria-describedby",
          "aria-haspopup",
          "aria-expanded"
        ].forEach((p) => _.removeAttribute(p));
      }, {
        immediate: !0
      });
    }), nt(() => {
      c == null || c(), c = void 0;
    }), t({
      triggerRef: o
    }), (d, _) => d.virtualTriggering ? re("v-if", !0) : (F(), Oe(L(yf), Cn({ key: 0 }, d.$attrs, {
      "aria-controls": L(a),
      "aria-describedby": L(l),
      "aria-expanded": L(s),
      "aria-haspopup": L(i)
    }), {
      default: pe(() => [
        te(d.$slots, "default")
      ]),
      _: 3
    }, 16, ["aria-controls", "aria-describedby", "aria-expanded", "aria-haspopup"]));
  }
});
var Tf = /* @__PURE__ */ je(Of, [["__file", "/home/runner/work/element-plus/element-plus/packages/components/popper/src/trigger.vue"]]);
const Wn = "focus-trap.focus-after-trapped", Hn = "focus-trap.focus-after-released", Lf = "focus-trap.focusout-prevented", Wo = {
  cancelable: !0,
  bubbles: !1
}, If = {
  cancelable: !0,
  bubbles: !1
}, Ho = "focusAfterTrapped", jo = "focusAfterReleased", wf = Symbol("elFocusTrap"), Mr = B(), Fn = B(0), Fr = B(0);
let gn = 0;
const ts = (e) => {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 || r === document.activeElement ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}, Yo = (e, t) => {
  for (const n of e)
    if (!Af(n, t))
      return n;
}, Af = (e, t) => {
  if (process.env.NODE_ENV === "test")
    return !1;
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}, Sf = (e) => {
  const t = ts(e), n = Yo(t, e), r = Yo(t.reverse(), e);
  return [n, r];
}, Cf = (e) => e instanceof HTMLInputElement && "select" in e, dt = (e, t) => {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), Fr.value = window.performance.now(), e !== n && Cf(e) && t && e.select();
  }
};
function Go(e, t) {
  const n = [...e], r = e.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
const Rf = () => {
  let e = [];
  return {
    push: (t) => {
      const n = e[0];
      n && t !== n && n.pause(), e = Go(e, t), e.unshift(t);
    },
    remove: (t) => {
      var n, r;
      e = Go(e, t), (r = (n = e[0]) == null ? void 0 : n.resume) == null || r.call(n);
    }
  };
}, kf = (e, t = !1) => {
  const n = document.activeElement;
  for (const r of e)
    if (dt(r, t), document.activeElement !== n)
      return;
}, Ko = Rf(), Pf = () => Fn.value > Fr.value, hn = () => {
  Mr.value = "pointer", Fn.value = window.performance.now();
}, Xo = () => {
  Mr.value = "keyboard", Fn.value = window.performance.now();
}, Df = () => (tt(() => {
  gn === 0 && (document.addEventListener("mousedown", hn), document.addEventListener("touchstart", hn), document.addEventListener("keydown", Xo)), gn++;
}), nt(() => {
  gn--, gn <= 0 && (document.removeEventListener("mousedown", hn), document.removeEventListener("touchstart", hn), document.removeEventListener("keydown", Xo));
}), {
  focusReason: Mr,
  lastUserFocusTimestamp: Fn,
  lastAutomatedFocusTimestamp: Fr
}), bn = (e) => new CustomEvent(Lf, {
  ...If,
  detail: e
}), Mf = H({
  name: "ElFocusTrap",
  inheritAttrs: !1,
  props: {
    loop: Boolean,
    trapped: Boolean,
    focusTrapEl: Object,
    focusStartEl: {
      type: [Object, String],
      default: "first"
    }
  },
  emits: [
    Ho,
    jo,
    "focusin",
    "focusout",
    "focusout-prevented",
    "release-requested"
  ],
  setup(e, { emit: t }) {
    const n = B();
    let r, o;
    const { focusReason: a } = Df();
    rf((g) => {
      e.trapped && !l.paused && t("release-requested", g);
    });
    const l = {
      paused: !1,
      pause() {
        this.paused = !0;
      },
      resume() {
        this.paused = !1;
      }
    }, i = (g) => {
      if (!e.loop && !e.trapped || l.paused)
        return;
      const { key: y, altKey: E, ctrlKey: u, metaKey: h, currentTarget: T, shiftKey: v } = g, { loop: A } = e, N = y === wn.tab && !E && !u && !h, S = document.activeElement;
      if (N && S) {
        const w = T, [D, x] = Sf(w);
        if (D && x) {
          if (!v && S === x) {
            const V = bn({
              focusReason: a.value
            });
            t("focusout-prevented", V), V.defaultPrevented || (g.preventDefault(), A && dt(D, !0));
          } else if (v && [D, w].includes(S)) {
            const V = bn({
              focusReason: a.value
            });
            t("focusout-prevented", V), V.defaultPrevented || (g.preventDefault(), A && dt(x, !0));
          }
        } else if (S === w) {
          const V = bn({
            focusReason: a.value
          });
          t("focusout-prevented", V), V.defaultPrevented || g.preventDefault();
        }
      }
    };
    mt(wf, {
      focusTrapRef: n,
      onKeydown: i
    }), ne(() => e.focusTrapEl, (g) => {
      g && (n.value = g);
    }, { immediate: !0 }), ne([n], ([g], [y]) => {
      g && (g.addEventListener("keydown", i), g.addEventListener("focusin", d), g.addEventListener("focusout", _)), y && (y.removeEventListener("keydown", i), y.removeEventListener("focusin", d), y.removeEventListener("focusout", _));
    });
    const s = (g) => {
      t(Ho, g);
    }, c = (g) => t(jo, g), d = (g) => {
      const y = L(n);
      if (!y)
        return;
      const E = g.target, u = g.relatedTarget, h = E && y.contains(E);
      e.trapped || u && y.contains(u) || (r = u), h && t("focusin", g), !l.paused && e.trapped && (h ? o = E : dt(o, !0));
    }, _ = (g) => {
      const y = L(n);
      if (!(l.paused || !y))
        if (e.trapped) {
          const E = g.relatedTarget;
          !br(E) && !y.contains(E) && setTimeout(() => {
            if (!l.paused && e.trapped) {
              const u = bn({
                focusReason: a.value
              });
              t("focusout-prevented", u), u.defaultPrevented || dt(o, !0);
            }
          }, 0);
        } else {
          const E = g.target;
          E && y.contains(E) || t("focusout", g);
        }
    };
    async function p() {
      await Ur();
      const g = L(n);
      if (g) {
        Ko.push(l);
        const y = g.contains(document.activeElement) ? r : document.activeElement;
        if (r = y, !g.contains(y)) {
          const E = new Event(Wn, Wo);
          g.addEventListener(Wn, s), g.dispatchEvent(E), E.defaultPrevented || Ur(() => {
            let u = e.focusStartEl;
            Dn(u) || (dt(u), document.activeElement !== u && (u = "first")), u === "first" && kf(ts(g), !0), (document.activeElement === y || u === "container") && dt(g);
          });
        }
      }
    }
    function b() {
      const g = L(n);
      if (g) {
        g.removeEventListener(Wn, s);
        const y = new CustomEvent(Hn, {
          ...Wo,
          detail: {
            focusReason: a.value
          }
        });
        g.addEventListener(Hn, c), g.dispatchEvent(y), !y.defaultPrevented && (a.value == "keyboard" || !Pf() || g.contains(document.activeElement)) && dt(r ?? document.body), g.removeEventListener(Hn, s), Ko.remove(l);
      }
    }
    return tt(() => {
      e.trapped && p(), ne(() => e.trapped, (g) => {
        g ? p() : b();
      });
    }), nt(() => {
      e.trapped && b();
    }), {
      onKeydown: i
    };
  }
});
function Ff(e, t, n, r, o, a) {
  return te(e.$slots, "default", { handleKeydown: e.onKeydown });
}
var xf = /* @__PURE__ */ je(Mf, [["render", Ff], ["__file", "/home/runner/work/element-plus/element-plus/packages/components/focus-trap/src/focus-trap.vue"]]);
const $f = ["fixed", "absolute"], Uf = Ce({
  boundariesPadding: {
    type: Number,
    default: 0
  },
  fallbackPlacements: {
    type: Q(Array),
    default: void 0
  },
  gpuAcceleration: {
    type: Boolean,
    default: !0
  },
  offset: {
    type: Number,
    default: 12
  },
  placement: {
    type: String,
    values: Ir,
    default: "bottom"
  },
  popperOptions: {
    type: Q(Object),
    default: () => ({})
  },
  strategy: {
    type: String,
    values: $f,
    default: "absolute"
  }
}), ns = Ce({
  ...Uf,
  id: String,
  style: {
    type: Q([String, Array, Object])
  },
  className: {
    type: Q([String, Array, Object])
  },
  effect: {
    type: String,
    default: "dark"
  },
  visible: Boolean,
  enterable: {
    type: Boolean,
    default: !0
  },
  pure: Boolean,
  focusOnShow: {
    type: Boolean,
    default: !1
  },
  trapping: {
    type: Boolean,
    default: !1
  },
  popperClass: {
    type: Q([String, Array, Object])
  },
  popperStyle: {
    type: Q([String, Array, Object])
  },
  referenceEl: {
    type: Q(Object)
  },
  triggerTargetEl: {
    type: Q(Object)
  },
  stopPopperMouseEvent: {
    type: Boolean,
    default: !0
  },
  ariaLabel: {
    type: String,
    default: void 0
  },
  virtualTriggering: Boolean,
  zIndex: Number
}), Vf = {
  mouseenter: (e) => e instanceof MouseEvent,
  mouseleave: (e) => e instanceof MouseEvent,
  focus: () => !0,
  blur: () => !0,
  close: () => !0
}, Bf = (e, t = []) => {
  const { placement: n, strategy: r, popperOptions: o } = e, a = {
    placement: n,
    strategy: r,
    ...o,
    modifiers: [...Hf(e), ...t]
  };
  return jf(a, o == null ? void 0 : o.modifiers), a;
}, Wf = (e) => {
  if (Ze)
    return Ot(e);
};
function Hf(e) {
  const { offset: t, gpuAcceleration: n, fallbackPlacements: r } = e;
  return [
    {
      name: "offset",
      options: {
        offset: [0, t ?? 12]
      }
    },
    {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    },
    {
      name: "flip",
      options: {
        padding: 5,
        fallbackPlacements: r
      }
    },
    {
      name: "computeStyles",
      options: {
        gpuAcceleration: n
      }
    }
  ];
}
function jf(e, t) {
  t && (e.modifiers = [...e.modifiers, ...t ?? []]);
}
const Yf = 0, Gf = (e) => {
  const { popperInstanceRef: t, contentRef: n, triggerRef: r, role: o } = Ve(Dr, void 0), a = B(), l = B(), i = P(() => ({
    name: "eventListeners",
    enabled: !!e.visible
  })), s = P(() => {
    var u;
    const h = L(a), T = (u = L(l)) != null ? u : Yf;
    return {
      name: "arrow",
      enabled: !$c(h),
      options: {
        element: h,
        padding: T
      }
    };
  }), c = P(() => ({
    onFirstUpdate: () => {
      g();
    },
    ...Bf(e, [
      L(s),
      L(i)
    ])
  })), d = P(() => Wf(e.referenceEl) || L(r)), { attributes: _, state: p, styles: b, update: g, forceUpdate: y, instanceRef: E } = zu(d, n, c);
  return ne(E, (u) => t.value = u), tt(() => {
    ne(() => {
      var u;
      return (u = L(d)) == null ? void 0 : u.getBoundingClientRect();
    }, () => {
      g();
    });
  }), {
    attributes: _,
    arrowRef: a,
    contentRef: n,
    instanceRef: E,
    state: p,
    styles: b,
    role: o,
    forceUpdate: y,
    update: g
  };
}, Kf = (e, {
  attributes: t,
  styles: n,
  role: r
}) => {
  const { nextZIndex: o } = pf(), a = Yt("popper"), l = P(() => L(t).popper), i = B(e.zIndex || o()), s = P(() => [
    a.b(),
    a.is("pure", e.pure),
    a.is(e.effect),
    e.popperClass
  ]), c = P(() => [
    { zIndex: L(i) },
    L(n).popper,
    e.popperStyle || {}
  ]), d = P(() => r.value === "dialog" ? "false" : void 0), _ = P(() => L(n).arrow || {});
  return {
    ariaModal: d,
    arrowStyle: _,
    contentAttrs: l,
    contentClass: s,
    contentStyle: c,
    contentZIndex: i,
    updateZIndex: () => {
      i.value = e.zIndex || o();
    }
  };
}, Xf = (e, t) => {
  const n = B(!1), r = B();
  return {
    focusStartRef: r,
    trapped: n,
    onFocusAfterReleased: (o) => {
      var a;
      ((a = o.detail) == null ? void 0 : a.focusReason) !== "pointer" && (r.value = "first", t("blur"));
    },
    onFocusAfterTrapped: () => {
      t("focus");
    },
    onFocusInTrap: (o) => {
      e.visible && !n.value && (o.target && (r.value = o.target), n.value = !0);
    },
    onFocusoutPrevented: (o) => {
      e.trapping || (o.detail.focusReason === "pointer" && o.preventDefault(), n.value = !1);
    },
    onReleaseRequested: () => {
      n.value = !1, t("close");
    }
  };
}, qf = H({
  name: "ElPopperContent"
}), Jf = /* @__PURE__ */ H({
  ...qf,
  props: ns,
  emits: Vf,
  setup(e, { expose: t, emit: n }) {
    const r = e, {
      focusStartRef: o,
      trapped: a,
      onFocusAfterReleased: l,
      onFocusAfterTrapped: i,
      onFocusInTrap: s,
      onFocusoutPrevented: c,
      onReleaseRequested: d
    } = Xf(r, n), { attributes: _, arrowRef: p, contentRef: b, styles: g, instanceRef: y, role: E, update: u } = Gf(r), {
      ariaModal: h,
      arrowStyle: T,
      contentAttrs: v,
      contentClass: A,
      contentStyle: N,
      updateZIndex: S
    } = Kf(r, {
      styles: g,
      attributes: _,
      role: E
    }), w = Ve(Vo, void 0), D = B();
    mt(Ja, {
      arrowStyle: T,
      arrowRef: p,
      arrowOffset: D
    }), w && (w.addInputId || w.removeInputId) && mt(Vo, {
      ...w,
      addInputId: or,
      removeInputId: or
    });
    let x;
    const V = (j = !0) => {
      u(), j && S();
    }, G = () => {
      V(!1), r.visible && r.focusOnShow ? a.value = !0 : r.visible === !1 && (a.value = !1);
    };
    return tt(() => {
      ne(() => r.triggerTargetEl, (j, le) => {
        x == null || x(), x = void 0;
        const se = L(j || b.value), q = L(le || b.value);
        Ln(se) && (x = ne([E, () => r.ariaLabel, h, () => r.id], (M) => {
          ["role", "aria-label", "aria-modal", "id"].forEach((ce, _e) => {
            br(M[_e]) ? se.removeAttribute(ce) : se.setAttribute(ce, M[_e]);
          });
        }, { immediate: !0 })), q !== se && Ln(q) && ["role", "aria-label", "aria-modal", "id"].forEach((M) => {
          q.removeAttribute(M);
        });
      }, { immediate: !0 }), ne(() => r.visible, G, { immediate: !0 });
    }), nt(() => {
      x == null || x(), x = void 0;
    }), t({
      popperContentRef: b,
      popperInstanceRef: y,
      updatePopper: V,
      contentStyle: N
    }), (j, le) => (F(), W("div", Cn({
      ref_key: "contentRef",
      ref: b
    }, L(v), {
      style: L(N),
      class: L(A),
      tabindex: "-1",
      onMouseenter: le[0] || (le[0] = (se) => j.$emit("mouseenter", se)),
      onMouseleave: le[1] || (le[1] = (se) => j.$emit("mouseleave", se))
    }), [
      We(L(xf), {
        trapped: L(a),
        "trap-on-focus-in": !0,
        "focus-trap-el": L(b),
        "focus-start-el": L(o),
        onFocusAfterTrapped: L(i),
        onFocusAfterReleased: L(l),
        onFocusin: L(s),
        onFocusoutPrevented: L(c),
        onReleaseRequested: L(d)
      }, {
        default: pe(() => [
          te(j.$slots, "default")
        ]),
        _: 3
      }, 8, ["trapped", "focus-trap-el", "focus-start-el", "onFocusAfterTrapped", "onFocusAfterReleased", "onFocusin", "onFocusoutPrevented", "onReleaseRequested"])
    ], 16));
  }
});
var Qf = /* @__PURE__ */ je(Jf, [["__file", "/home/runner/work/element-plus/element-plus/packages/components/popper/src/content.vue"]]);
const Zf = Or(gf), xr = Symbol("elTooltip"), De = Ce({
  ...sf,
  ...ns,
  appendTo: {
    type: Q([String, Object])
  },
  content: {
    type: String,
    default: ""
  },
  rawContent: {
    type: Boolean,
    default: !1
  },
  persistent: Boolean,
  ariaLabel: String,
  visible: {
    type: Q(Boolean),
    default: null
  },
  transition: String,
  teleported: {
    type: Boolean,
    default: !0
  },
  disabled: Boolean
}), an = Ce({
  ...es,
  disabled: Boolean,
  trigger: {
    type: Q([String, Array]),
    default: "hover"
  },
  triggerKeys: {
    type: Q(Array),
    default: () => [wn.enter, wn.space]
  }
}), {
  useModelToggleProps: zf,
  useModelToggleEmits: ed,
  useModelToggle: td
} = Jc("visible"), nd = Ce({
  ...Qa,
  ...zf,
  ...De,
  ...an,
  ...Za,
  showArrow: {
    type: Boolean,
    default: !0
  }
}), rd = [
  ...ed,
  "before-show",
  "before-hide",
  "show",
  "hide",
  "open",
  "close"
], od = (e, t) => xc(e) ? e.includes(t) : e === t, Ct = (e, t, n) => (r) => {
  od(L(e), t) && n(r);
}, ad = H({
  name: "ElTooltipTrigger"
}), sd = /* @__PURE__ */ H({
  ...ad,
  props: an,
  setup(e, { expose: t }) {
    const n = e, r = Yt("tooltip"), { controlled: o, id: a, open: l, onOpen: i, onClose: s, onToggle: c } = Ve(xr, void 0), d = B(null), _ = () => {
      if (L(o) || n.disabled)
        return !0;
    }, p = qt(n, "trigger"), b = at(_, Ct(p, "hover", i)), g = at(_, Ct(p, "hover", s)), y = at(_, Ct(p, "click", (v) => {
      v.button === 0 && c(v);
    })), E = at(_, Ct(p, "focus", i)), u = at(_, Ct(p, "focus", s)), h = at(_, Ct(p, "contextmenu", (v) => {
      v.preventDefault(), c(v);
    })), T = at(_, (v) => {
      const { code: A } = v;
      n.triggerKeys.includes(A) && (v.preventDefault(), c(v));
    });
    return t({
      triggerRef: d
    }), (v, A) => (F(), Oe(L(Tf), {
      id: L(a),
      "virtual-ref": v.virtualRef,
      open: L(l),
      "virtual-triggering": v.virtualTriggering,
      class: Fe(L(r).e("trigger")),
      onBlur: L(u),
      onClick: L(y),
      onContextmenu: L(h),
      onFocus: L(E),
      onMouseenter: L(b),
      onMouseleave: L(g),
      onKeydown: L(T)
    }, {
      default: pe(() => [
        te(v.$slots, "default")
      ]),
      _: 3
    }, 8, ["id", "virtual-ref", "open", "virtual-triggering", "class", "onBlur", "onClick", "onContextmenu", "onFocus", "onMouseenter", "onMouseleave", "onKeydown"]));
  }
});
var ld = /* @__PURE__ */ je(sd, [["__file", "/home/runner/work/element-plus/element-plus/packages/components/tooltip/src/trigger.vue"]]);
const id = H({
  name: "ElTooltipContent",
  inheritAttrs: !1
}), cd = /* @__PURE__ */ H({
  ...id,
  props: De,
  setup(e, { expose: t }) {
    const n = e, { selector: r } = Xa(), o = Yt("tooltip"), a = B(null), l = B(!1), {
      controlled: i,
      id: s,
      open: c,
      trigger: d,
      onClose: _,
      onOpen: p,
      onShow: b,
      onHide: g,
      onBeforeShow: y,
      onBeforeHide: E
    } = Ve(xr, void 0), u = P(() => n.transition || `${o.namespace.value}-fade-in-linear`), h = P(() => process.env.NODE_ENV === "test" ? !0 : n.persistent);
    nt(() => {
      l.value = !0;
    });
    const T = P(() => L(h) ? !0 : L(c)), v = P(() => n.disabled ? !1 : L(c)), A = P(() => n.appendTo || r.value), N = P(() => {
      var M;
      return (M = n.style) != null ? M : {};
    }), S = P(() => !L(c)), w = () => {
      g();
    }, D = () => {
      if (L(i))
        return !0;
    }, x = at(D, () => {
      n.enterable && L(d) === "hover" && p();
    }), V = at(D, () => {
      L(d) === "hover" && _();
    }), G = () => {
      var M, ce;
      (ce = (M = a.value) == null ? void 0 : M.updatePopper) == null || ce.call(M), y == null || y();
    }, j = () => {
      E == null || E();
    }, le = () => {
      b(), q = Cc(P(() => {
        var M;
        return (M = a.value) == null ? void 0 : M.popperContentRef;
      }), () => {
        L(i) || L(d) !== "hover" && _();
      });
    }, se = () => {
      n.virtualTriggering || _();
    };
    let q;
    return ne(() => L(c), (M) => {
      M || q == null || q();
    }, {
      flush: "post"
    }), ne(() => n.content, () => {
      var M, ce;
      (ce = (M = a.value) == null ? void 0 : M.updatePopper) == null || ce.call(M);
    }), t({
      contentRef: a
    }), (M, ce) => (F(), Oe(ps, {
      disabled: !M.teleported,
      to: L(A)
    }, [
      We(ms, {
        name: L(u),
        onAfterLeave: w,
        onBeforeEnter: G,
        onAfterEnter: le,
        onBeforeLeave: j
      }, {
        default: pe(() => [
          L(T) ? Sn((F(), Oe(L(Qf), Cn({
            key: 0,
            id: L(s),
            ref_key: "contentRef",
            ref: a
          }, M.$attrs, {
            "aria-label": M.ariaLabel,
            "aria-hidden": L(S),
            "boundaries-padding": M.boundariesPadding,
            "fallback-placements": M.fallbackPlacements,
            "gpu-acceleration": M.gpuAcceleration,
            offset: M.offset,
            placement: M.placement,
            "popper-options": M.popperOptions,
            strategy: M.strategy,
            effect: M.effect,
            enterable: M.enterable,
            pure: M.pure,
            "popper-class": M.popperClass,
            "popper-style": [M.popperStyle, L(N)],
            "reference-el": M.referenceEl,
            "trigger-target-el": M.triggerTargetEl,
            visible: L(v),
            "z-index": M.zIndex,
            onMouseenter: L(x),
            onMouseleave: L(V),
            onBlur: se,
            onClose: L(_)
          }), {
            default: pe(() => [
              l.value ? re("v-if", !0) : te(M.$slots, "default", { key: 0 })
            ]),
            _: 3
          }, 16, ["id", "aria-label", "aria-hidden", "boundaries-padding", "fallback-placements", "gpu-acceleration", "offset", "placement", "popper-options", "strategy", "effect", "enterable", "pure", "popper-class", "popper-style", "reference-el", "trigger-target-el", "visible", "z-index", "onMouseenter", "onMouseleave", "onClose"])), [
            [na, L(v)]
          ]) : re("v-if", !0)
        ]),
        _: 3
      }, 8, ["name"])
    ], 8, ["disabled", "to"]));
  }
});
var ud = /* @__PURE__ */ je(cd, [["__file", "/home/runner/work/element-plus/element-plus/packages/components/tooltip/src/content.vue"]]);
const fd = ["innerHTML"], dd = { key: 1 }, pd = H({
  name: "ElTooltip"
}), md = /* @__PURE__ */ H({
  ...pd,
  props: nd,
  emits: rd,
  setup(e, { expose: t, emit: n }) {
    const r = e;
    af();
    const o = nf(), a = B(), l = B(), i = () => {
      var u;
      const h = L(a);
      h && ((u = h.popperInstanceRef) == null || u.update());
    }, s = B(!1), c = B(), { show: d, hide: _, hasUpdateHandler: p } = td({
      indicator: s,
      toggleReason: c
    }), { onOpen: b, onClose: g } = lf({
      showAfter: qt(r, "showAfter"),
      hideAfter: qt(r, "hideAfter"),
      autoClose: qt(r, "autoClose"),
      open: d,
      close: _
    }), y = P(() => Er(r.visible) && !p.value);
    mt(xr, {
      controlled: y,
      id: o,
      open: _s(s),
      trigger: qt(r, "trigger"),
      onOpen: (u) => {
        b(u);
      },
      onClose: (u) => {
        g(u);
      },
      onToggle: (u) => {
        L(s) ? g(u) : b(u);
      },
      onShow: () => {
        n("show", c.value);
      },
      onHide: () => {
        n("hide", c.value);
      },
      onBeforeShow: () => {
        n("before-show", c.value);
      },
      onBeforeHide: () => {
        n("before-hide", c.value);
      },
      updatePopper: i
    }), ne(() => r.disabled, (u) => {
      u && s.value && (s.value = !1);
    });
    const E = () => {
      var u, h;
      const T = (h = (u = l.value) == null ? void 0 : u.contentRef) == null ? void 0 : h.popperContentRef;
      return T && T.contains(document.activeElement);
    };
    return vs(() => s.value && _()), t({
      popperRef: a,
      contentRef: l,
      isFocusInsideContent: E,
      updatePopper: i,
      onOpen: b,
      onClose: g,
      hide: _
    }), (u, h) => (F(), Oe(L(Zf), {
      ref_key: "popperRef",
      ref: a,
      role: u.role
    }, {
      default: pe(() => [
        We(ld, {
          disabled: u.disabled,
          trigger: u.trigger,
          "trigger-keys": u.triggerKeys,
          "virtual-ref": u.virtualRef,
          "virtual-triggering": u.virtualTriggering
        }, {
          default: pe(() => [
            u.$slots.default ? te(u.$slots, "default", { key: 0 }) : re("v-if", !0)
          ]),
          _: 3
        }, 8, ["disabled", "trigger", "trigger-keys", "virtual-ref", "virtual-triggering"]),
        We(ud, {
          ref_key: "contentRef",
          ref: l,
          "aria-label": u.ariaLabel,
          "boundaries-padding": u.boundariesPadding,
          content: u.content,
          disabled: u.disabled,
          effect: u.effect,
          enterable: u.enterable,
          "fallback-placements": u.fallbackPlacements,
          "hide-after": u.hideAfter,
          "gpu-acceleration": u.gpuAcceleration,
          offset: u.offset,
          persistent: u.persistent,
          "popper-class": u.popperClass,
          "popper-style": u.popperStyle,
          placement: u.placement,
          "popper-options": u.popperOptions,
          pure: u.pure,
          "raw-content": u.rawContent,
          "reference-el": u.referenceEl,
          "trigger-target-el": u.triggerTargetEl,
          "show-after": u.showAfter,
          strategy: u.strategy,
          teleported: u.teleported,
          transition: u.transition,
          "virtual-triggering": u.virtualTriggering,
          "z-index": u.zIndex,
          "append-to": u.appendTo
        }, {
          default: pe(() => [
            te(u.$slots, "content", {}, () => [
              u.rawContent ? (F(), W("span", {
                key: 0,
                innerHTML: u.content
              }, null, 8, fd)) : (F(), W("span", dd, z(u.content), 1))
            ]),
            u.showArrow ? (F(), Oe(L(Ef), {
              key: 0,
              "arrow-offset": u.arrowOffset
            }, null, 8, ["arrow-offset"])) : re("v-if", !0)
          ]),
          _: 3
        }, 8, ["aria-label", "boundaries-padding", "content", "disabled", "effect", "enterable", "fallback-placements", "hide-after", "gpu-acceleration", "offset", "persistent", "popper-class", "popper-style", "placement", "popper-options", "pure", "raw-content", "reference-el", "trigger-target-el", "show-after", "strategy", "teleported", "transition", "virtual-triggering", "z-index", "append-to"])
      ]),
      _: 3
    }, 8, ["role"]));
  }
});
var _d = /* @__PURE__ */ je(md, [["__file", "/home/runner/work/element-plus/element-plus/packages/components/tooltip/src/tooltip.vue"]]);
const vd = Or(_d), gd = /* @__PURE__ */ H({
  inheritAttrs: !1
});
function hd(e, t, n, r, o, a) {
  return te(e.$slots, "default");
}
var bd = /* @__PURE__ */ je(gd, [["render", hd], ["__file", "/home/runner/work/element-plus/element-plus/packages/components/collection/src/collection.vue"]]);
const Ed = /* @__PURE__ */ H({
  name: "ElCollectionItem",
  inheritAttrs: !1
});
function yd(e, t, n, r, o, a) {
  return te(e.$slots, "default");
}
var Nd = /* @__PURE__ */ je(Ed, [["render", yd], ["__file", "/home/runner/work/element-plus/element-plus/packages/components/collection/src/collection-item.vue"]]);
const Od = "data-el-collection-item", Td = (e) => {
  const t = `El${e}Collection`, n = `${t}Item`, r = Symbol(t), o = Symbol(n), a = {
    ...bd,
    name: t,
    setup() {
      const i = B(null), s = /* @__PURE__ */ new Map();
      mt(r, {
        itemMap: s,
        getItems: () => {
          const c = L(i);
          if (!c)
            return [];
          const d = Array.from(c.querySelectorAll(`[${Od}]`));
          return [...s.values()].sort((_, p) => d.indexOf(_.ref) - d.indexOf(p.ref));
        },
        collectionRef: i
      });
    }
  }, l = {
    ...Nd,
    name: n,
    setup(i, { attrs: s }) {
      const c = B(null), d = Ve(r, void 0);
      mt(o, {
        collectionItemRef: c
      }), tt(() => {
        const _ = L(c);
        _ && d.itemMap.set(_, {
          ref: _,
          ...s
        });
      }), nt(() => {
        const _ = L(c);
        d.itemMap.delete(_);
      });
    }
  };
  return {
    COLLECTION_INJECTION_KEY: r,
    COLLECTION_ITEM_INJECTION_KEY: o,
    ElCollection: a,
    ElCollectionItem: l
  };
}, jn = Ce({
  trigger: an.trigger,
  effect: {
    ...De.effect,
    default: "light"
  },
  type: {
    type: Q(String)
  },
  placement: {
    type: Q(String),
    default: "bottom"
  },
  popperOptions: {
    type: Q(Object),
    default: () => ({})
  },
  id: String,
  size: {
    type: String,
    default: ""
  },
  splitButton: Boolean,
  hideOnClick: {
    type: Boolean,
    default: !0
  },
  loop: {
    type: Boolean,
    default: !0
  },
  showTimeout: {
    type: Number,
    default: 150
  },
  hideTimeout: {
    type: Number,
    default: 150
  },
  tabindex: {
    type: Q([Number, String]),
    default: 0
  },
  maxHeight: {
    type: Q([Number, String]),
    default: ""
  },
  popperClass: {
    type: String,
    default: ""
  },
  disabled: {
    type: Boolean,
    default: !1
  },
  role: {
    type: String,
    default: "menu"
  },
  buttonProps: {
    type: Q(Object)
  },
  teleported: De.teleported
});
Ce({
  command: {
    type: [Object, String, Number],
    default: () => ({})
  },
  disabled: Boolean,
  divided: Boolean,
  textValue: String,
  icon: {
    type: jc
  }
});
Ce({
  onKeydown: { type: Q(Function) }
});
Td("Dropdown");
const Ld = Ce({
  trigger: an.trigger,
  placement: jn.placement,
  disabled: an.disabled,
  visible: De.visible,
  transition: De.transition,
  popperOptions: jn.popperOptions,
  tabindex: jn.tabindex,
  content: De.content,
  popperStyle: De.popperStyle,
  popperClass: De.popperClass,
  enterable: {
    ...De.enterable,
    default: !0
  },
  effect: {
    ...De.effect,
    default: "light"
  },
  teleported: De.teleported,
  title: String,
  width: {
    type: [String, Number],
    default: 150
  },
  offset: {
    type: Number,
    default: void 0
  },
  showAfter: {
    type: Number,
    default: 0
  },
  hideAfter: {
    type: Number,
    default: 200
  },
  autoClose: {
    type: Number,
    default: 0
  },
  showArrow: {
    type: Boolean,
    default: !0
  },
  persistent: {
    type: Boolean,
    default: !0
  },
  "onUpdate:visible": {
    type: Function
  }
}), Id = {
  "update:visible": (e) => Er(e),
  "before-enter": () => !0,
  "before-leave": () => !0,
  "after-enter": () => !0,
  "after-leave": () => !0
}, wd = "onUpdate:visible", Ad = H({
  name: "ElPopover"
}), Sd = /* @__PURE__ */ H({
  ...Ad,
  props: Ld,
  emits: Id,
  setup(e, { expose: t, emit: n }) {
    const r = e, o = P(() => r[wd]), a = Yt("popover"), l = B(), i = P(() => {
      var E;
      return (E = L(l)) == null ? void 0 : E.popperRef;
    }), s = P(() => [
      {
        width: Wc(r.width)
      },
      r.popperStyle
    ]), c = P(() => [a.b(), r.popperClass, { [a.m("plain")]: !!r.content }]), d = P(() => r.transition === `${a.namespace.value}-fade-in-linear`), _ = () => {
      var E;
      (E = l.value) == null || E.hide();
    }, p = () => {
      n("before-enter");
    }, b = () => {
      n("before-leave");
    }, g = () => {
      n("after-enter");
    }, y = () => {
      n("update:visible", !1), n("after-leave");
    };
    return t({
      popperRef: i,
      hide: _
    }), (E, u) => (F(), Oe(L(vd), Cn({
      ref_key: "tooltipRef",
      ref: l
    }, E.$attrs, {
      trigger: E.trigger,
      placement: E.placement,
      disabled: E.disabled,
      visible: E.visible,
      transition: E.transition,
      "popper-options": E.popperOptions,
      tabindex: E.tabindex,
      content: E.content,
      offset: E.offset,
      "show-after": E.showAfter,
      "hide-after": E.hideAfter,
      "auto-close": E.autoClose,
      "show-arrow": E.showArrow,
      "aria-label": E.title,
      effect: E.effect,
      enterable: E.enterable,
      "popper-class": L(c),
      "popper-style": L(s),
      teleported: E.teleported,
      persistent: E.persistent,
      "gpu-acceleration": L(d),
      "onUpdate:visible": L(o),
      onBeforeShow: p,
      onBeforeHide: b,
      onShow: g,
      onHide: y
    }), {
      content: pe(() => [
        E.title ? (F(), W("div", {
          key: 0,
          class: Fe(L(a).e("title")),
          role: "title"
        }, z(E.title), 3)) : re("v-if", !0),
        te(E.$slots, "default", {}, () => [
          Jt(z(E.content), 1)
        ])
      ]),
      default: pe(() => [
        E.$slots.reference ? te(E.$slots, "reference", { key: 0 }) : re("v-if", !0)
      ]),
      _: 3
    }, 16, ["trigger", "placement", "disabled", "visible", "transition", "popper-options", "tabindex", "content", "offset", "show-after", "hide-after", "auto-close", "show-arrow", "aria-label", "effect", "enterable", "popper-class", "popper-style", "teleported", "persistent", "gpu-acceleration", "onUpdate:visible"]));
  }
});
var Cd = /* @__PURE__ */ je(Sd, [["__file", "/home/runner/work/element-plus/element-plus/packages/components/popover/src/popover.vue"]]);
const qo = (e, t) => {
  const n = t.arg || t.value, r = n == null ? void 0 : n.popperRef;
  r && (r.triggerRef = e);
};
var Rd = {
  mounted(e, t) {
    qo(e, t);
  },
  updated(e, t) {
    qo(e, t);
  }
};
const kd = "popover", Pd = Yc(Rd, kd), Dd = Or(Cd, {
  directive: Pd
}), Md = /* @__PURE__ */ H({
  __name: "BaseToolTip",
  props: {
    placement: {},
    trigger: { default: "hover" },
    message: {},
    width: { default: "auto" },
    cssClass: {},
    visible: { type: [Boolean, null], default: null },
    offset: { default: 15 }
  },
  emits: ["show", "hide"],
  setup(e, { emit: t }) {
    const n = (o) => {
      t("show", o);
    }, r = (o) => {
      t("hide", o);
    };
    return (o, a) => (F(), Oe(L(Dd), {
      "popper-class": ["ap-tooltip", o.cssClass],
      placement: o.placement,
      trigger: o.trigger,
      offset: o.offset,
      "hide-after": 0,
      content: o.message,
      width: o.width,
      visible: o.visible,
      persistent: !1,
      onShow: n,
      onHide: r
    }, {
      reference: pe(() => [
        te(o.$slots, "default")
      ]),
      default: pe(() => [
        te(o.$slots, "content")
      ]),
      _: 3
    }, 8, ["popper-class", "placement", "trigger", "offset", "content", "width", "visible"]));
  }
}), Fd = /* @__PURE__ */ H({
  __name: "ContentToolTip",
  props: {
    placement: { default: "bottom" },
    trigger: {},
    message: {},
    width: {}
  },
  setup(e) {
    return (t, n) => (F(), Oe(Md, {
      cssClass: "ap-content-tooltip",
      placement: t.placement,
      trigger: t.trigger,
      message: t.message,
      width: t.width
    }, {
      content: pe(() => [
        te(t.$slots, "content")
      ]),
      default: pe(() => [
        te(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["placement", "trigger", "message", "width"]));
  }
}), xd = { class: "ap-long-string" }, $d = ["data-ellipsis"], Ud = { key: 1 }, Vd = /* @__PURE__ */ H({
  __name: "LongString",
  props: {
    value: {},
    cellLayout: {}
  },
  setup(e) {
    const t = e, { cellLayout: n } = Vr(t), { maxLenght: r, forcedTooltip: o, hasEllipsis: a } = Vr(n.value), l = P(() => t.value.slice(0, r.value)), i = P(() => a.value && t.value.length > r.value), s = P(() => o.value || i.value);
    return (c, d) => (F(), W("div", xd, [
      s.value ? (F(), Oe(L(Fd), { key: 0 }, {
        content: pe(() => [
          fe("span", null, z(t.value), 1)
        ]),
        default: pe(() => [
          fe("div", {
            class: "ap-table-content",
            "data-ellipsis": i.value
          }, [
            fe("span", null, z(l.value), 1)
          ], 8, $d)
        ]),
        _: 1
      })) : (F(), W("span", Ud, z(l.value), 1))
    ]));
  }
});
const Bd = /* @__PURE__ */ H({
  __name: "GeneralType",
  props: {
    value: String
  },
  setup(e) {
    const t = e;
    return (n, r) => (F(), W("span", null, z(t.value), 1));
  }
}), Wd = {
  DateTime: Hi,
  LeftTime: Ic,
  LongString: Vd,
  GeneralType: Bd
}, Hd = { class: "ap-header-cell" }, jd = {
  key: 1,
  class: "ap-header-cell__label"
}, Yd = /* @__PURE__ */ H({
  __name: "HeaderCell",
  props: {
    id: {},
    text: {},
    sorting: {}
  },
  emits: ["sortingChange"],
  setup(e, { emit: t }) {
    const n = t, r = e, o = P(() => r.sorting.direction !== Rt.inactive), a = () => {
      n("sortingChange", r.id);
    };
    return (l, i) => (F(), W("div", Hd, [
      r.sorting.isEnabled ? (F(), W("button", {
        key: 0,
        class: Fe(["ap-header-cell__label ap-header-cell__sort-btn", {
          "ap-header-cell__label_active": o.value,
          [`ap-header-cell__sort-btn_${r.sorting.direction}`]: !0
        }]),
        onClick: a
      }, z(r.text), 3)) : (F(), W("span", jd, z(r.text), 1))
    ]));
  }
});
const un = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, o] of t)
    n[r] = o;
  return n;
}, Gd = /* @__PURE__ */ un(Yd, [["__scopeId", "data-v-264a7baf"]]), Kd = { class: "ap-checkbox" }, Xd = ["id", "name", "value", "disabled"], qd = ["for"], Jd = ["for"], Jo = /* @__PURE__ */ H({
  __name: "CheckBox",
  props: {
    id: null,
    name: null,
    label: null,
    value: null,
    modelValue: null,
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, r = P({
      get() {
        return n.modelValue;
      },
      set(o) {
        t("update:modelValue", o);
      }
    });
    return (o, a) => (F(), W("div", Kd, [
      Sn(fe("input", {
        type: "checkbox",
        id: e.id,
        name: e.name,
        value: e.value,
        disabled: e.disabled,
        "onUpdate:modelValue": a[0] || (a[0] = (l) => Gn(r) ? r.value = l : null)
      }, null, 8, Xd), [
        [hs, L(r)]
      ]),
      fe("label", {
        class: "checkbox",
        for: e.id
      }, null, 8, qd),
      e.label ? (F(), W("label", {
        key: 0,
        class: "text",
        for: e.id
      }, z(e.label), 9, Jd)) : re("", !0)
    ]));
  }
}), Qd = /* @__PURE__ */ bs('<div class="loader-image"><svg class="spinner" viewBox="0 0 50 50"><circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle></svg><svg class="spinner-small" viewBox="0 0 50 50"><circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle></svg></div>', 1), Zd = /* @__PURE__ */ H({
  __name: "Loader",
  props: {
    show: { type: Boolean },
    theme: { default: "grey" },
    text: { default: "loader.text" }
  },
  setup(e) {
    return (t, n) => Sn((F(), W("div", {
      class: Fe("ap-loader ap-loader_theme-" + e.theme)
    }, [
      Qd,
      fe("span", null, z(t.$t(e.text)), 1)
    ], 2)), [
      [na, e.show]
    ]);
  }
});
const zd = "Снять выделение", ep = "Выбрать все записи", tp = "Выбрано", np = "записей | запись | записи | записей", rp = {
  resetSelection: zd,
  selectAllText: ep,
  selectedTextBeforeNumber: tp,
  selectedTextAfterNumber: np
}, op = {}, ap = {}, sp = {}, lp = {}, ip = {}, cp = {
  ru: rp,
  kk: op,
  en: ap,
  pl: sp,
  uz: lp,
  es: ip
}, up = ["disabled"], fp = ["href", "target"], dp = /* @__PURE__ */ H({
  __name: "BaseButton",
  props: {
    behavior: { default: "button" },
    type: {},
    disabled: { type: Boolean },
    url: {},
    target: {}
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, r = (o) => {
      n.disabled ? o.preventDefault() : t("click", o);
    };
    return (o, a) => o.behavior === "button" ? (F(), W("button", {
      key: 0,
      class: Fe(["ap-btn", "ap-btn_" + o.type]),
      disabled: o.disabled,
      onClick: r
    }, [
      te(o.$slots, "default")
    ], 10, up)) : o.behavior === "link" ? (F(), W("a", {
      key: 1,
      class: Fe(["ap-btn", "ap-btn_" + o.type, o.disabled && "ap-btn_disabled"]),
      href: o.disabled ? "#" : o.url,
      target: o.target,
      onClick: r
    }, [
      te(o.$slots, "default")
    ], 10, fp)) : re("", !0);
  }
}), Qo = /* @__PURE__ */ H({
  __name: "DefaultButton",
  props: {
    behavior: {},
    disabled: { type: Boolean },
    url: {},
    target: {}
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = (r) => {
      t("click", r);
    };
    return (r, o) => (F(), Oe(dp, {
      type: "default",
      behavior: r.behavior,
      url: r.url,
      target: r.target,
      disabled: r.disabled,
      onClick: n
    }, {
      default: pe(() => [
        te(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["behavior", "url", "target", "disabled"]));
  }
}), pp = { class: "ap-select-all-prompt" }, mp = { class: "ap-select-all-prompt__selected-info" }, _p = /* @__PURE__ */ H({
  __name: "SelectAllPrompt",
  props: {
    numOfSelectedRows: {},
    totalRows: {},
    selectAllText: {},
    selectedTextBeforeNumberPath: {},
    selectedTextAfterNumberPath: {}
  },
  emits: ["resetSelection", "selectAllInvisibleRows"],
  setup(e, { emit: t }) {
    const { t: n } = jt({ messages: cp }), r = t, o = e, a = B(!1), l = B(""), i = B("");
    a.value = o.totalRows === o.numOfSelectedRows, l.value = n(o.selectedTextBeforeNumberPath ?? "selectedTextBeforeNumber"), i.value = n(o.selectedTextAfterNumberPath ?? "selectedTextAfterNumber", o.numOfSelectedRows);
    const s = (d) => {
      r("resetSelection", d);
    }, c = (d) => {
      r("selectAllInvisibleRows", d);
    };
    return (d, _) => (F(), W("div", pp, [
      fe("span", mp, [
        Jt(z(l.value) + " ", 1),
        fe("strong", null, z(o.numOfSelectedRows), 1),
        Jt(" " + z(i.value), 1)
      ]),
      We(L(Qo), {
        class: "ap-select-all-prompt__button ap-select-all-prompt__button_confirm",
        onClick: c,
        disabled: a.value
      }, {
        default: pe(() => [
          Jt(z(o.selectAllText || L(n)("selectAllText")), 1)
        ]),
        _: 1
      }, 8, ["disabled"]),
      We(L(Qo), {
        class: "ap-select-all-prompt__button ap-select-all-prompt__button_reset-selection",
        onClick: s
      }, {
        default: pe(() => [
          Jt(z(L(n)("resetSelection")), 1)
        ]),
        _: 1
      })
    ]));
  }
});
const vp = /* @__PURE__ */ un(_p, [["__scopeId", "data-v-d0298df5"]]);
function gp(e) {
  return ra() ? (oa(e), !0) : !1;
}
function rs(e) {
  return typeof e == "function" ? e() : L(e);
}
const os = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const hp = Object.prototype.toString, bp = (e) => hp.call(e) === "[object Object]", Nn = () => {
}, Ep = /* @__PURE__ */ yp();
function yp() {
  var e, t;
  return os && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(ad|hone|od)/.test(window.navigator.userAgent) || ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function Qt(e) {
  var t;
  const n = rs(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
const as = os ? window : void 0;
function Yn(...e) {
  let t, n, r, o;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([n, r, o] = e, t = as) : [t, n, r, o] = e, !t)
    return Nn;
  Array.isArray(n) || (n = [n]), Array.isArray(r) || (r = [r]);
  const a = [], l = () => {
    a.forEach((d) => d()), a.length = 0;
  }, i = (d, _, p, b) => (d.addEventListener(_, p, b), () => d.removeEventListener(_, p, b)), s = ne(
    () => [Qt(t), rs(o)],
    ([d, _]) => {
      if (l(), !d)
        return;
      const p = bp(_) ? { ..._ } : _;
      a.push(
        ...n.flatMap((b) => r.map((g) => i(d, b, g, p)))
      );
    },
    { immediate: !0, flush: "post" }
  ), c = () => {
    s(), l();
  };
  return gp(c), c;
}
let Zo = !1;
function Np(e, t, n = {}) {
  const { window: r = as, ignore: o = [], capture: a = !0, detectIframe: l = !1 } = n;
  if (!r)
    return Nn;
  Ep && !Zo && (Zo = !0, Array.from(r.document.body.children).forEach((p) => p.addEventListener("click", Nn)), r.document.documentElement.addEventListener("click", Nn));
  let i = !0;
  const s = (p) => o.some((b) => {
    if (typeof b == "string")
      return Array.from(r.document.querySelectorAll(b)).some((g) => g === p.target || p.composedPath().includes(g));
    {
      const g = Qt(b);
      return g && (p.target === g || p.composedPath().includes(g));
    }
  }), d = [
    Yn(r, "click", (p) => {
      const b = Qt(e);
      if (!(!b || b === p.target || p.composedPath().includes(b))) {
        if (p.detail === 0 && (i = !s(p)), !i) {
          i = !0;
          return;
        }
        t(p);
      }
    }, { passive: !0, capture: a }),
    Yn(r, "pointerdown", (p) => {
      const b = Qt(e);
      i = !s(p) && !!(b && !p.composedPath().includes(b));
    }, { passive: !0 }),
    l && Yn(r, "blur", (p) => {
      setTimeout(() => {
        var b;
        const g = Qt(e);
        ((b = r.document.activeElement) == null ? void 0 : b.tagName) === "IFRAME" && !(g != null && g.contains(r.document.activeElement)) && t(p);
      }, 0);
    })
  ].filter(Boolean);
  return () => d.forEach((p) => p());
}
const Op = { class: "ap-table__wrapper" }, Tp = {
  key: 0,
  class: "ap-sr-only"
}, Lp = { class: "ap-table__header" }, Ip = {
  key: 0,
  class: "ap-table__header-cell ap-table__row-selector"
}, wp = ["colspan"], Ap = { class: "ap-table__system-messages" }, Sp = { class: "ap-table__body" }, Cp = {
  key: 0,
  class: "ap-table__cell ap-table__row-selector"
}, Rp = ["data-col-title", "colspan"], kp = /* @__PURE__ */ H({
  __name: "ApTable",
  props: {
    id: {},
    headers: { default: () => [] },
    data: { default: () => [] },
    isCardModeForced: { type: Boolean, default: !1 },
    cardModeMediaQuery: { default: "(max-width: 768px)" },
    caption: { default: "" },
    noDataText: {},
    isLoading: { type: Boolean },
    loadingText: {},
    allowToSelectRows: { type: Boolean, default: !1 },
    selectVisibleRowsOnly: { type: Boolean, default: !0 },
    selectAllText: {},
    selectedTextBeforeNumberPath: {},
    selectedTextAfterNumberPath: {},
    totalRows: {},
    sorting: {}
  },
  emits: ["selectedRowsChange", "selectAllInvisibleRows", "sortingChange"],
  setup(e, { emit: t }) {
    const n = t, r = e, o = B(r.isCardModeForced), a = B({}), l = P(() => !r.data.length && !!r.noDataText), i = P(() => r.data.length === 1 || l.value), s = r.allowToSelectRows ? 1 : 0, c = r.headers.length + s;
    a.value = r.headers.reduce((v, A) => ({ ...v, [A.id]: A }), {});
    const {
      onSortingChanged: d,
      retrieveSortingOptionsForHeader: _
    } = ws(r, n);
    if (!r.isCardModeForced) {
      const v = new As(
        r.cardModeMediaQuery,
        o
      );
      Ls(v);
    }
    const {
      selectedRowIndex: p,
      selectAllValues: b,
      areAllRowsSelected: g,
      isSelectAllInvisibleRowsShown: y,
      onSelectAllRowsClick: E,
      onSelectAllInvisibleRows: u,
      onResetSelection: h
    } = Is(r, n);
    ne(p, () => {
      b.value = g.value, n("selectedRowsChange", Es(p.value));
    }), ne(g, () => {
      g.value && (y.value = !0);
    });
    const T = B(null);
    return Np(T, () => y.value = !1), (v, A) => (F(), W("div", Op, [
      fe("table", {
        class: Fe(["ap-table", {
          "ap-table_mode_card": o.value,
          "ap-table_single-row": i.value
        }])
      }, [
        r.caption ? (F(), W("caption", Tp, z(r.caption), 1)) : re("", !0),
        fe("thead", Lp, [
          fe("tr", null, [
            r.allowToSelectRows ? (F(), W("th", Ip, [
              We(L(Jo), {
                name: "allVisibleRows",
                id: `allVisibleRows__${v.id}`,
                modelValue: L(b),
                "onUpdate:modelValue": A[0] || (A[0] = (N) => Gn(b) ? b.value = N : null),
                onChange: L(E),
                disabled: r.isLoading || !r.data.length
              }, null, 8, ["id", "modelValue", "onChange", "disabled"])
            ])) : re("", !0),
            (F(!0), W(Mt, null, xn(r.headers, (N) => (F(), W("th", {
              key: N.id,
              class: Fe(`ap-table__header-cell ap-table__header-cell_${N.id}`),
              colspan: N.colspan || 1
            }, [
              We(Gd, {
                id: N.id,
                text: N.label,
                sorting: L(_)(N.id, N.isSortable),
                onSortingChange: L(d)
              }, null, 8, ["id", "text", "sorting", "onSortingChange"])
            ], 10, wp))), 128))
          ])
        ]),
        fe("tbody", Ap, [
          v.selectVisibleRowsOnly ? re("", !0) : (F(), W("tr", {
            key: 0,
            ref_key: "allInvisibleRowsSelector",
            ref: T
          }, [
            fe("td", {
              colspan: c,
              class: "ap-table__system-message"
            }, [
              L(y) ? (F(), Oe(vp, {
                key: 0,
                class: "ap-table__select-all",
                "num-of-selected-rows": L(p).length,
                "total-rows": r.totalRows || 0,
                "select-all-text": r.selectAllText || "",
                "selected-text-after-number-path": r.selectedTextAfterNumberPath,
                "selected-text-before-number-path": r.selectedTextBeforeNumberPath,
                onResetSelection: L(h),
                onSelectAllInvisibleRows: L(u)
              }, null, 8, ["num-of-selected-rows", "total-rows", "select-all-text", "selected-text-after-number-path", "selected-text-before-number-path", "onResetSelection", "onSelectAllInvisibleRows"])) : re("", !0)
            ])
          ], 512))
        ]),
        fe("tbody", Sp, [
          l.value ? (F(), W("tr", {
            key: 0,
            class: Fe(["ap-table__row ap-table__no-data-text", { "ap-table__row_single-row": i.value }])
          }, [
            fe("td", { colspan: c }, z(r.noDataText), 1)
          ], 2)) : re("", !0),
          (F(!0), W(Mt, null, xn(r.data, (N, S) => (F(), W("tr", {
            key: S,
            class: Fe(["ap-table__row", { "ap-table__row_single-row": i.value }])
          }, [
            r.allowToSelectRows && N.isSelectable !== !1 ? (F(), W("td", Cp, [
              We(L(Jo), {
                name: `${S}_${v.id}`,
                id: `${S}_${v.id}`,
                value: S,
                modelValue: L(p),
                "onUpdate:modelValue": A[1] || (A[1] = (w) => Gn(p) ? p.value = w : null),
                disabled: r.isLoading
              }, null, 8, ["name", "id", "value", "modelValue", "disabled"])
            ])) : re("", !0),
            (F(!0), W(Mt, null, xn(N.cells, (w, D) => {
              var x;
              return F(), W("td", {
                key: D,
                "data-col-title": ((x = a.value[D]) == null ? void 0 : x.label) || "",
                colspan: (w.colspan || 1) + (N.isSelectable !== !1 ? 0 : L(s)),
                class: Fe("ap-table__cell ap-table__cell_" + D)
              }, [
                te(v.$slots, D, { field: w }, () => {
                  var V;
                  return [
                    (F(), Oe(ys(L(Wd)[((V = a.value[D]) == null ? void 0 : V.type) || "GeneralType"]), Ns(Os({
                      ...w,
                      ...a.value[D]
                    })), null, 16))
                  ];
                }, !0)
              ], 10, Rp);
            }), 128))
          ], 2))), 128))
        ])
      ], 2),
      r.isLoading ? (F(), Oe(L(Zd), {
        key: 0,
        class: "ap-table__loader",
        show: r.isLoading,
        theme: "blue",
        text: v.loadingText
      }, null, 8, ["show", "text"])) : re("", !0)
    ]));
  }
});
const Pp = /* @__PURE__ */ un(kp, [["__scopeId", "data-v-ea36fb95"]]), Dp = { class: "ap-total-counter" }, Mp = {
  key: 0,
  class: "ap-total-counter__value"
}, Fp = { class: "ap-total-counter__label" }, xp = /* @__PURE__ */ H({
  __name: "TotalCounter",
  props: {
    value: {},
    label: {}
  },
  setup(e) {
    const t = e;
    return (n, r) => (F(), W("div", Dp, [
      t.value ? (F(), W("span", Mp, z(t.value ?? 0), 1)) : re("", !0),
      fe("span", Fp, z(` ${t.label}`), 1)
    ]));
  }
});
const $p = /* @__PURE__ */ un(xp, [["__scopeId", "data-v-6376f527"]]), Up = { class: "ap-table-controls" }, Vp = {
  key: 0,
  class: "ap-table-controls__header"
}, Bp = {
  key: 0,
  class: "ap-table-controls__title"
}, Wp = {
  key: 1,
  class: "ap-table-controls__top-toolbar"
}, Hp = {
  key: 1,
  class: "ap-table-controls__bottom-nav ap-section"
}, jp = { class: "ap-section__left" }, Yp = {
  key: 1,
  class: "ap-table-controls__items-per-page"
}, Gp = {
  key: 0,
  class: "ap-section__right"
}, Kp = { class: "ap-table-controls__bottom-pagination" }, Xp = /* @__PURE__ */ H({
  __name: "ApTableControls",
  props: {
    totalCounter: {}
  },
  setup(e) {
    const t = e, n = Ts(), r = B(!1), o = B(!1);
    return r.value = n.title !== void 0 || n.topToolbar !== void 0, o.value = t.totalCounter !== void 0 || n.itemsPerPage !== void 0 || n.bottomPagination !== void 0, (a, l) => (F(), W("div", Up, [
      r.value ? (F(), W("header", Vp, [
        L(n).title ? (F(), W("div", Bp, [
          te(a.$slots, "title", {}, void 0, !0)
        ])) : re("", !0),
        L(n).topToolbar ? (F(), W("section", Wp, [
          te(a.$slots, "topToolbar", {}, void 0, !0)
        ])) : re("", !0)
      ])) : re("", !0),
      te(a.$slots, "table", {}, void 0, !0),
      o.value ? (F(), W("footer", Hp, [
        fe("div", jp, [
          t.totalCounter ? (F(), Oe($p, {
            key: 0,
            class: "ap-table-controls__total-counter",
            value: t.totalCounter.value,
            label: t.totalCounter.label
          }, null, 8, ["value", "label"])) : re("", !0),
          L(n).itemsPerPage ? (F(), W("div", Yp, [
            te(a.$slots, "itemsPerPage", {}, void 0, !0)
          ])) : re("", !0)
        ]),
        L(n).bottomPagination ? (F(), W("div", Gp, [
          fe("div", Kp, [
            te(a.$slots, "bottomPagination", {}, void 0, !0)
          ])
        ])) : re("", !0)
      ])) : re("", !0)
    ]));
  }
});
const qp = /* @__PURE__ */ un(Xp, [["__scopeId", "data-v-ebd667f9"]]), Zp = {
  install: (e) => {
    e.component("ApTable", Pp), e.component("ApTableControls", qp);
  }
};
export {
  Pp as ApTable,
  qp as ApTableControls,
  Zp as default
};
